{
  "level": "bs04",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:bs04",
    "objects": "AREAS.E3:bs04.e3",
    "mesh": "TREES.E3:bs04.e3"
  },
  "spawn_point": {
    "position": [
      -2942.4681514019853,
      -4136.263006457602,
      1073.7808837890625
    ],
    "facing_rad": 0.0,
    "look_point": [
      -2942.4681514019853,
      -4036.2630064576024,
      1073.7808837890625
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -4007.749267578125,
      -5045.98291015625,
      1049.7808837890625
    ],
    "bbox_max": [
      -1964.791748046875,
      -3857.455078125,
      1402.623779296875
    ],
    "vertex_count": 1319,
    "vertices": [
      [
        -2704.999755859375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2704.999755859375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2708.999755859375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2708.999755859375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2708.999755859375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2704.999755859375,
        -4022.0,
        1052.5999755859375
      ],
      [
        -2704.999755859375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2704.999755859375,
        -4022.0,
        1052.5999755859375
      ],
      [
        -2708.999755859375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2704.999755859375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2704.999755859375,
        -4012.0,
        1052.5999755859375
      ],
      [
        -2708.999755859375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2704.999755859375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2708.999755859375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2704.999755859375,
        -4012.0,
        1052.5999755859375
      ],
      [
        -2704.999755859375,
        -4012.0,
        1052.623779296875
      ],
      [
        -3341.90576171875,
        -4133.39013671875,
        1049.7808837890625
      ],
      [
        -3276.144775390625,
        -4067.62939453125,
        1049.781005859375
      ],
      [
        -3271.119384765625,
        -4072.65478515625,
        1052.623779296875
      ],
      [
        -2654.999755859375,
        -4012.0,
        1052.5999755859375
      ],
      [
        -2654.999755859375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2654.999755859375,
        -4012.0,
        1052.5999755859375
      ],
      [
        -2654.999755859375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2658.771240234375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2658.771240234375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2658.771240234375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2658.771240234375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2652.997802734375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2652.971435546875,
        -4011.955322265625,
        1052.623779296875
      ],
      [
        -2652.971435546875,
        -4011.955322265625,
        1052.623779296875
      ],
      [
        -2652.997802734375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2652.971435546875,
        -4011.955322265625,
        1052.623779296875
      ],
      [
        -2652.971435546875,
        -4011.955322265625,
        1052.623779296875
      ],
      [
        -2652.997802734375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2652.997802734375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1082.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1052.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1082.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1187.623779296875
      ],
      [
        -2354.91015625,
        -4155.29296875,
        1082.623779296875
      ],
      [
        -2354.909423828125,
        -4155.2939453125,
        1185.623779296875
      ],
      [
        -2346.291259765625,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -2346.291259765625,
        -4249.7685546875,
        1226.623779296875
      ],
      [
        -2295.551025390625,
        -4249.7685546875,
        1187.623779296875
      ],
      [
        -2295.551025390625,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -2589.23681640625,
        -4020.00439453125,
        1062.623779296875
      ],
      [
        -2615.536865234375,
        -4065.557373046875,
        1062.623779296875
      ],
      [
        -2615.536865234375,
        -4065.557373046875,
        1101.623779296875
      ],
      [
        -2615.536865234375,
        -4065.557373046875,
        1112.623779296875
      ],
      [
        -2615.537109375,
        -4065.557373046875,
        1112.623779296875
      ],
      [
        -2615.536865234375,
        -4065.557373046875,
        1121.623779296875
      ],
      [
        -2615.537109375,
        -4065.557373046875,
        1062.623779296875
      ],
      [
        -2615.536865234375,
        -4065.557373046875,
        1101.623779296875
      ],
      [
        -2601.536865234375,
        -4041.30859375,
        1115.17236328125
      ],
      [
        -2596.536865234375,
        -4032.6484375,
        1115.1722412109375
      ],
      [
        -2596.536865234375,
        -4032.6484375,
        1112.623779296875
      ],
      [
        -2596.536865234375,
        -4032.6484375,
        1115.1722412109375
      ],
      [
        -2615.537109375,
        -4065.557373046875,
        1062.623779296875
      ],
      [
        -2615.537109375,
        -4065.557373046875,
        1062.623779296875
      ],
      [
        -2739.973876953125,
        -4244.7236328125,
        1052.623779296875
      ],
      [
        -2739.973876953125,
        -4244.7236328125,
        1152.623779296875
      ],
      [
        -2682.318603515625,
        -4075.498291015625,
        1063.98681640625
      ],
      [
        -2671.367431640625,
        -4043.355712890625,
        1052.623779296875
      ],
      [
        -2628.05224609375,
        -4058.33154296875,
        1101.623779296875
      ],
      [
        -2627.052490234375,
        -4056.599609375,
        1101.623779296875
      ],
      [
        -2619.05224609375,
        -4042.7431640625,
        1101.623779296875
      ],
      [
        -2627.052490234375,
        -4056.599609375,
        1101.623779296875
      ],
      [
        -2627.052490234375,
        -4056.599609375,
        1117.623779296875
      ],
      [
        -2628.05224609375,
        -4058.33154296875,
        1112.623779296875
      ],
      [
        -2627.052490234375,
        -4056.599609375,
        1112.623779296875
      ],
      [
        -2653.26416015625,
        -4012.0,
        1052.623779296875
      ],
      [
        -2653.26416015625,
        -4012.0,
        1052.623779296875
      ],
      [
        -2657.474609375,
        -4022.0,
        1054.9588623046875
      ],
      [
        -2659.03759765625,
        -4022.0,
        1052.623779296875
      ],
      [
        -2658.9130859375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2658.9130859375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2659.03759765625,
        -4022.0,
        1052.623779296875
      ],
      [
        -2657.47509765625,
        -4022.0,
        1054.9581298828125
      ],
      [
        -2626.624267578125,
        -4071.857666015625,
        1072.623779296875
      ],
      [
        -2621.124267578125,
        -4062.33154296875,
        1072.623779296875
      ],
      [
        -2621.990234375,
        -4061.83154296875,
        1072.623779296875
      ],
      [
        -2626.990234375,
        -4070.49169921875,
        1072.623779296875
      ],
      [
        -2626.624267578125,
        -4071.857666015625,
        1072.623779296875
      ],
      [
        -2627.490234375,
        -4071.357666015625,
        1072.623779296875
      ],
      [
        -2637.016357421875,
        -4065.857666015625,
        1055.72021484375
      ],
      [
        -2636.150390625,
        -4066.357666015625,
        1057.7200927734375
      ],
      [
        -2634.027099609375,
        -4067.58349609375,
        1062.623779296875
      ],
      [
        -2629.69677734375,
        -4070.083740234375,
        1072.623779296875
      ],
      [
        -2631.516357421875,
        -4056.33154296875,
        1055.720458984375
      ],
      [
        -2637.016357421875,
        -4065.857666015625,
        1055.72021484375
      ],
      [
        -2633.527099609375,
        -4066.717529296875,
        1062.623779296875
      ],
      [
        -2626.990234375,
        -4070.49169921875,
        1072.623779296875
      ],
      [
        -2629.19677734375,
        -4069.2177734375,
        1072.623779296875
      ],
      [
        -2633.527099609375,
        -4066.717529296875,
        1062.623779296875
      ],
      [
        -2634.027099609375,
        -4067.58349609375,
        1062.623779296875
      ],
      [
        -2635.650390625,
        -4065.49169921875,
        1057.7200927734375
      ],
      [
        -2636.150390625,
        -4066.357666015625,
        1057.7200927734375
      ],
      [
        -2635.650390625,
        -4065.49169921875,
        1057.7200927734375
      ],
      [
        -2630.650390625,
        -4056.83154296875,
        1057.7200927734375
      ],
      [
        -2626.624267578125,
        -4071.857666015625,
        1079.719482421875
      ],
      [
        -2621.124267578125,
        -4062.33154296875,
        1079.7197265625
      ],
      [
        -2621.990234375,
        -4061.83154296875,
        1077.7197265625
      ],
      [
        -2626.990234375,
        -4070.49169921875,
        1077.719482421875
      ],
      [
        -2626.624267578125,
        -4071.857666015625,
        1079.719482421875
      ],
      [
        -2627.490234375,
        -4071.357666015625,
        1072.623779296875
      ],
      [
        -2627.490234375,
        -4071.357666015625,
        1077.7197265625
      ],
      [
        -2626.990234375,
        -4070.49169921875,
        1077.7196044921875
      ],
      [
        -2636.150390625,
        -4066.357666015625,
        1113.623779296875
      ],
      [
        -2630.650634765625,
        -4056.83154296875,
        1113.623779296875
      ],
      [
        -2636.150390625,
        -4066.357666015625,
        1113.623779296875
      ],
      [
        -2626.124267578125,
        -4070.99169921875,
        1113.623779296875
      ],
      [
        -2626.124267578125,
        -4070.99169921875,
        1079.719482421875
      ],
      [
        -2626.124267578125,
        -4070.99169921875,
        1113.623779296875
      ],
      [
        -2635.650390625,
        -4065.49169921875,
        1113.623779296875
      ],
      [
        -2621.990234375,
        -4061.83154296875,
        1113.623779296875
      ],
      [
        -2626.990234375,
        -4070.49169921875,
        1113.623779296875
      ],
      [
        -2688.893310546875,
        -4094.796630859375,
        1052.623779296875
      ],
      [
        -2685.8232421875,
        -4085.78515625,
        1059.6280517578125
      ],
      [
        -2682.318603515625,
        -4075.498291015625,
        1063.98681640625
      ],
      [
        -2685.8232421875,
        -4085.78515625,
        1059.6280517578125
      ],
      [
        -2660.6845703125,
        -4012.0,
        1057.623779296875
      ],
      [
        -2664.091552734375,
        -4022.0,
        1057.623779296875
      ],
      [
        -2664.091552734375,
        -4022.0,
        1057.623779296875
      ],
      [
        -2660.6845703125,
        -4012.0,
        1057.623779296875
      ],
      [
        -2660.6845703125,
        -4012.0,
        1052.623779296875
      ],
      [
        -2660.6845703125,
        -4012.0,
        1057.623779296875
      ],
      [
        -2660.6845703125,
        -4012.0,
        1057.623779296875
      ],
      [
        -2660.6845703125,
        -4012.0,
        1052.623779296875
      ],
      [
        -2664.091552734375,
        -4022.0,
        1057.623779296875
      ],
      [
        -2664.091552734375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2664.091552734375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2664.091552734375,
        -4022.0,
        1057.623779296875
      ],
      [
        -3015.999755859375,
        -4124.7685546875,
        1052.623779296875
      ],
      [
        -3015.999755859375,
        -4124.7685546875,
        1057.5999755859375
      ],
      [
        -2704.999755859375,
        -4124.7685546875,
        1052.623779296875
      ],
      [
        -2704.999755859375,
        -4124.7685546875,
        1057.5999755859375
      ],
      [
        -3041.499755859375,
        -4124.7685546875,
        1052.623779296875
      ],
      [
        -3041.499755859375,
        -4130.7685546875,
        1052.623779296875
      ],
      [
        -3041.499755859375,
        -4130.7685546875,
        1057.5999755859375
      ],
      [
        -3041.499755859375,
        -4124.7685546875,
        1057.5999755859375
      ],
      [
        -2667.587646484375,
        -3974.7685546875,
        1057.5999755859375
      ],
      [
        -2658.927490234375,
        -3979.7685546875,
        1057.5999755859375
      ],
      [
        -2658.927490234375,
        -3979.7685546875,
        1052.623779296875
      ],
      [
        -2667.587646484375,
        -3974.7685546875,
        1052.623779296875
      ],
      [
        -3015.999755859375,
        -3979.7685546875,
        1057.5999755859375
      ],
      [
        -3015.999755859375,
        -3979.7685546875,
        1052.623779296875
      ],
      [
        -2704.999755859375,
        -3979.7685546875,
        1057.5999755859375
      ],
      [
        -2704.999755859375,
        -3979.7685546875,
        1052.623779296875
      ],
      [
        -3041.499755859375,
        -3974.800048828125,
        1057.5999755859375
      ],
      [
        -3046.499755859375,
        -3974.800048828125,
        1057.5999755859375
      ],
      [
        -3041.499755859375,
        -3974.800048828125,
        1057.5999755859375
      ],
      [
        -3041.499755859375,
        -3979.7685546875,
        1052.623779296875
      ],
      [
        -3041.499755859375,
        -3979.7685546875,
        1057.5999755859375
      ],
      [
        -3021.999755859375,
        -3987.7685546875,
        1057.5999755859375
      ],
      [
        -3021.999755859375,
        -4020.7685546875,
        1057.5999755859375
      ],
      [
        -3021.999755859375,
        -4058.2685546875,
        1057.5999755859375
      ],
      [
        -3021.999755859375,
        -4091.2685546875,
        1057.5999755859375
      ],
      [
        -3034.999755859375,
        -3987.7685546875,
        1057.5999755859375
      ],
      [
        -3034.999755859375,
        -4020.7685546875,
        1057.5999755859375
      ],
      [
        -3034.999755859375,
        -4058.2685546875,
        1057.5999755859375
      ],
      [
        -3034.999755859375,
        -4091.2685546875,
        1057.5999755859375
      ],
      [
        -3021.999755859375,
        -4020.7685546875,
        1057.5999755859375
      ],
      [
        -3034.999755859375,
        -4020.7685546875,
        1057.5999755859375
      ],
      [
        -3034.999755859375,
        -3987.7685546875,
        1057.5999755859375
      ],
      [
        -3021.999755859375,
        -3987.7685546875,
        1057.5999755859375
      ],
      [
        -3021.999755859375,
        -4091.2685546875,
        1057.5999755859375
      ],
      [
        -3034.999755859375,
        -4091.2685546875,
        1057.5999755859375
      ],
      [
        -3034.999755859375,
        -4058.2685546875,
        1057.5999755859375
      ],
      [
        -3021.999755859375,
        -4058.2685546875,
        1057.5999755859375
      ],
      [
        -2704.999755859375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2704.999755859375,
        -4022.0,
        1057.5999755859375
      ],
      [
        -2704.999755859375,
        -4022.0,
        1052.623779296875
      ],
      [
        -2704.999755859375,
        -4022.0,
        1057.5999755859375
      ],
      [
        -2704.999755859375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2704.999755859375,
        -4012.0,
        1057.5999755859375
      ],
      [
        -2704.999755859375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2704.999755859375,
        -4012.0,
        1057.5999755859375
      ],
      [
        -2660.6845703125,
        -4012.0,
        1057.5999755859375
      ],
      [
        -2660.6845703125,
        -4012.0,
        1057.5999755859375
      ],
      [
        -2664.091552734375,
        -4022.0,
        1057.5999755859375
      ],
      [
        -2664.091552734375,
        -4022.0,
        1057.5999755859375
      ],
      [
        -2685.525146484375,
        -4073.64697265625,
        1057.5999755859375
      ],
      [
        -2676.163330078125,
        -4057.431884765625,
        1057.5999755859375
      ],
      [
        -2685.525146484375,
        -4073.64697265625,
        1057.5999755859375
      ],
      [
        -2687.17529296875,
        -4088.126953125,
        1057.5999755859375
      ],
      [
        -2687.17529296875,
        -4088.126953125,
        1057.5999755859375
      ],
      [
        -2686.712158203125,
        -4088.39453125,
        1057.5999755859375
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1057.5999755859375
      ],
      [
        -3026.0,
        -3925.124267578125,
        1057.5999755859375
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1052.623779296875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1057.5999755859375
      ],
      [
        -2998.0,
        -3922.08203125,
        1057.5999755859375
      ],
      [
        -2846.860595703125,
        -3905.65966796875,
        1057.5999755859375
      ],
      [
        -2998.0,
        -3902.0,
        1057.5999755859375
      ],
      [
        -3026.0,
        -3902.0,
        1057.5999755859375
      ],
      [
        -2845.2509765625,
        -3898.5556640625,
        1057.5999755859375
      ],
      [
        -2829.04638671875,
        -3902.0,
        1057.5999755859375
      ],
      [
        -2829.04638671875,
        -3902.0,
        1052.623779296875
      ],
      [
        -2846.031494140625,
        -3902.0,
        1057.5999755859375
      ],
      [
        -2845.2509765625,
        -3898.5556640625,
        1057.5999755859375
      ],
      [
        -2846.031494140625,
        -3902.0,
        1052.623779296875
      ],
      [
        -3026.0,
        -3902.0,
        1057.5999755859375
      ],
      [
        -3026.0,
        -3925.124267578125,
        1057.5999755859375
      ],
      [
        -2998.0,
        -3922.08203125,
        1057.5999755859375
      ],
      [
        -2998.0,
        -3902.0,
        1057.5999755859375
      ],
      [
        -2823.678955078125,
        -3903.140869140625,
        1057.5999755859375
      ],
      [
        -2823.678955078125,
        -3903.140869140625,
        1052.623779296875
      ],
      [
        -2846.860595703125,
        -3905.65966796875,
        1057.5999755859375
      ],
      [
        -2752.65576171875,
        -3925.654541015625,
        1057.5999755859375
      ],
      [
        -2772.989501953125,
        -3913.915283203125,
        1057.5999755859375
      ],
      [
        -2751.3486328125,
        -3918.51513671875,
        1057.5999755859375
      ],
      [
        -2772.989501953125,
        -3913.915283203125,
        1052.623779296875
      ],
      [
        -2751.3486328125,
        -3918.51513671875,
        1057.5999755859375
      ],
      [
        -2752.65576171875,
        -3925.654541015625,
        1057.5999755859375
      ],
      [
        -3046.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -2910.0,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -2894.0,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -2750.961181640625,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -2910.0,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -2910.0,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -2910.0,
        -4249.7685546875,
        1057.5999755859375
      ],
      [
        -2894.0,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -2894.0,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -2894.0,
        -4249.7685546875,
        1057.5999755859375
      ],
      [
        -3041.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -2739.973876953125,
        -4244.7236328125,
        1057.5999755859375
      ],
      [
        -2750.961181640625,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -3041.499755859375,
        -4249.7685546875,
        1121.623779296875
      ],
      [
        -3046.499755859375,
        -4249.7685546875,
        1121.623779296875
      ],
      [
        -3046.499755859375,
        -4247.66796875,
        1121.623779296875
      ],
      [
        -3041.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -3041.499755859375,
        -4247.66796875,
        1121.623779296875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1072.9744873046875
      ],
      [
        -3041.499755859375,
        -3926.80859375,
        1071.66943359375
      ],
      [
        -3041.499755859375,
        -3926.80859375,
        1057.5999755859375
      ],
      [
        -3041.499755859375,
        -3926.80859375,
        1071.66943359375
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1072.9744873046875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1082.623779296875
      ],
      [
        -3041.499755859375,
        -3926.80859375,
        1082.623779296875
      ],
      [
        -3041.499755859375,
        -3926.80859375,
        1082.623779296875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1082.623779296875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1121.623779296875
      ],
      [
        -3041.499755859375,
        -3926.80859375,
        1121.623779296875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1187.623779296875
      ],
      [
        -3041.499755859375,
        -3926.80859375,
        1187.623779296875
      ],
      [
        -3041.499755859375,
        -4247.66796875,
        1149.37744140625
      ],
      [
        -3041.499755859375,
        -4247.66796875,
        1152.623779296875
      ],
      [
        -3041.499755859375,
        -4247.66796875,
        1149.37744140625
      ],
      [
        -2894.0,
        -4249.7685546875,
        1064.0
      ],
      [
        -2910.0,
        -4249.7685546875,
        1064.0
      ],
      [
        -2910.0,
        -4249.7685546875,
        1064.0
      ],
      [
        -2894.0,
        -4249.7685546875,
        1064.0
      ],
      [
        -2823.6796875,
        -3903.140869140625,
        1082.623779296875
      ],
      [
        -2823.6796875,
        -3903.140869140625,
        1057.5999755859375
      ],
      [
        -2823.6796875,
        -3903.140869140625,
        1082.623779296875
      ],
      [
        -2823.6796875,
        -3903.140869140625,
        1185.623779296875
      ],
      [
        -2772.9892578125,
        -3913.915283203125,
        1082.623779296875
      ],
      [
        -2772.9892578125,
        -3913.915283203125,
        1057.5999755859375
      ],
      [
        -2772.9892578125,
        -3913.915283203125,
        1082.623779296875
      ],
      [
        -2772.9892578125,
        -3913.915283203125,
        1185.623779296875
      ],
      [
        -3003.1396484375,
        -4050.7685546875,
        1057.5999755859375
      ],
      [
        -3003.1396484375,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1057.5999755859375
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4050.7685546875,
        1057.5999755859375
      ],
      [
        -2994.94970703125,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -3003.1396484375,
        -4046.718505859375,
        1127.5999755859375
      ],
      [
        -3003.1396484375,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4046.718505859375,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4048.234375,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4048.234375,
        1137.623779296875
      ],
      [
        -2994.94970703125,
        -4048.234375,
        1137.623779296875
      ],
      [
        -2994.94970703125,
        -4048.234375,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4046.718505859375,
        1082.623779296875
      ],
      [
        -2994.94970703125,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -3003.1396484375,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -3003.1396484375,
        -4046.718505859375,
        1082.623779296875
      ],
      [
        -2994.94970703125,
        -4046.718505859375,
        1102.623779296875
      ],
      [
        -2994.94970703125,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -3003.1396484375,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -3003.1396484375,
        -4046.718505859375,
        1102.623779296875
      ],
      [
        -2994.94970703125,
        -4039.7685546875,
        1102.623779296875
      ],
      [
        -3003.1396484375,
        -4039.7685546875,
        1102.623779296875
      ],
      [
        -2994.94970703125,
        -4042.89697265625,
        1139.873779296875
      ],
      [
        -3003.1396484375,
        -4042.89697265625,
        1139.873779296875
      ],
      [
        -3003.1396484375,
        -4042.89697265625,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4042.89697265625,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4042.89697265625,
        1127.5999755859375
      ],
      [
        -3003.1396484375,
        -4042.89697265625,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4042.89697265625,
        1102.623779296875
      ],
      [
        -3003.1396484375,
        -4042.89697265625,
        1102.623779296875
      ],
      [
        -3003.1396484375,
        -4039.7685546875,
        1102.623779296875
      ],
      [
        -2994.94970703125,
        -4039.7685546875,
        1102.623779296875
      ],
      [
        -2994.94970703125,
        -4039.7685546875,
        1082.623779296875
      ],
      [
        -3003.1396484375,
        -4039.7685546875,
        1082.623779296875
      ],
      [
        -3003.1396484375,
        -4039.7685546875,
        1082.623779296875
      ],
      [
        -2994.94970703125,
        -4039.7685546875,
        1082.623779296875
      ],
      [
        -2725.0498046875,
        -4050.7685546875,
        1057.5999755859375
      ],
      [
        -2725.0498046875,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4046.718505859375,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2716.85986328125,
        -4046.718505859375,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4048.234375,
        1137.623779296875
      ],
      [
        -2725.0498046875,
        -4048.234375,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4048.234375,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4048.234375,
        1137.623779296875
      ],
      [
        -2716.85986328125,
        -4046.718505859375,
        1082.623779296875
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -2725.0498046875,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -2725.0498046875,
        -4046.718505859375,
        1082.623779296875
      ],
      [
        -2716.85986328125,
        -4046.718505859375,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2725.0498046875,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2725.0498046875,
        -4046.718505859375,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4039.7685546875,
        1102.623779296875
      ],
      [
        -2725.0498046875,
        -4039.7685546875,
        1102.623779296875
      ],
      [
        -2725.0498046875,
        -4042.89697265625,
        1127.5999755859375
      ],
      [
        -2716.85986328125,
        -4042.89697265625,
        1127.5999755859375
      ],
      [
        -2716.85986328125,
        -4042.89697265625,
        1139.873779296875
      ],
      [
        -2725.0498046875,
        -4042.89697265625,
        1139.873779296875
      ],
      [
        -2716.85986328125,
        -4042.89697265625,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4042.89697265625,
        1127.5999755859375
      ],
      [
        -2716.85986328125,
        -4042.89697265625,
        1102.623779296875
      ],
      [
        -2725.0498046875,
        -4042.89697265625,
        1102.623779296875
      ],
      [
        -2725.0498046875,
        -4039.7685546875,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4039.7685546875,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4039.7685546875,
        1082.623779296875
      ],
      [
        -2725.0498046875,
        -4039.7685546875,
        1082.623779296875
      ],
      [
        -2725.0498046875,
        -4039.7685546875,
        1082.623779296875
      ],
      [
        -2716.85986328125,
        -4039.7685546875,
        1082.623779296875
      ],
      [
        -2919.676025390625,
        -4009.93701171875,
        1106.623779296875
      ],
      [
        -2919.676025390625,
        -4009.93701171875,
        1084.623779296875
      ],
      [
        -2939.89990234375,
        -4020.226318359375,
        1108.123779296875
      ],
      [
        -2939.499755859375,
        -4020.02294921875,
        1137.623779296875
      ],
      [
        -2938.099853515625,
        -4019.310546875,
        1108.123779296875
      ],
      [
        -2938.499755859375,
        -4019.513916015625,
        1137.623779296875
      ],
      [
        -2939.89990234375,
        -4018.86865234375,
        1108.123779296875
      ],
      [
        -2938.099853515625,
        -4018.86865234375,
        1108.123779296875
      ],
      [
        -2938.099853515625,
        -4019.310546875,
        1108.123779296875
      ],
      [
        -2939.89990234375,
        -4020.226318359375,
        1108.123779296875
      ],
      [
        -2937.2314453125,
        -4018.86865234375,
        1108.123779296875
      ],
      [
        -2958.323486328125,
        -4029.60009765625,
        1106.623779296875
      ],
      [
        -2958.323486328125,
        -4029.60009765625,
        1084.623779296875
      ],
      [
        -2951.499755859375,
        -4026.1279296875,
        1093.623779296875
      ],
      [
        -2958.32373046875,
        -4029.599853515625,
        1093.623779296875
      ],
      [
        -2952.968505859375,
        -4026.875244140625,
        1076.123779296875
      ],
      [
        -2952.968505859375,
        -4026.875244140625,
        1057.5999755859375
      ],
      [
        -2956.301513671875,
        -4018.434814453125,
        1076.123779296875
      ],
      [
        -2956.156494140625,
        -4018.18359375,
        1057.5999755859375
      ],
      [
        -2957.07177734375,
        -4019.7685546875,
        1092.123779296875
      ],
      [
        -2952.96875,
        -4026.875244140625,
        1092.123779296875
      ],
      [
        -2951.499755859375,
        -4026.1279296875,
        1092.123779296875
      ],
      [
        -2951.499755859375,
        -4026.1279296875,
        1093.623779296875
      ],
      [
        -2951.499755859375,
        -4026.1279296875,
        1092.123779296875
      ],
      [
        -2956.301513671875,
        -4018.434814453125,
        1076.123779296875
      ],
      [
        -2957.827392578125,
        -4018.4599609375,
        1077.97802734375
      ],
      [
        -2958.323486328125,
        -4029.60009765625,
        1084.623779296875
      ],
      [
        -2952.968505859375,
        -4026.875244140625,
        1076.123779296875
      ],
      [
        -2958.32373046875,
        -4029.599853515625,
        1092.123779296875
      ],
      [
        -2963.29638671875,
        -4018.55029296875,
        1084.623779296875
      ],
      [
        -2958.323486328125,
        -4029.60009765625,
        1106.623779296875
      ],
      [
        -2954.753662109375,
        -4027.783447265625,
        1113.123779296875
      ],
      [
        -2955.397216796875,
        -4018.86865234375,
        1108.123779296875
      ],
      [
        -2952.075927734375,
        -4026.421142578125,
        1108.123779296875
      ],
      [
        -2963.468505859375,
        -4018.848388671875,
        1106.623779296875
      ],
      [
        -2962.414306640625,
        -4018.86865234375,
        1108.123779296875
      ],
      [
        -2962.933837890625,
        -4019.7685546875,
        1108.123779296875
      ],
      [
        -2954.753662109375,
        -4027.783447265625,
        1113.123779296875
      ],
      [
        -2952.075927734375,
        -4026.421142578125,
        1108.123779296875
      ],
      [
        -2959.386962890625,
        -4018.92724609375,
        1112.431640625
      ],
      [
        -2958.900390625,
        -4018.9365234375,
        1113.123779296875
      ],
      [
        -2955.397216796875,
        -4018.86865234375,
        1108.123779296875
      ],
      [
        -2958.900390625,
        -4018.9365234375,
        1113.123779296875
      ],
      [
        -2963.999755859375,
        -4032.48779296875,
        1093.623779296875
      ],
      [
        -2963.999755859375,
        -4032.48779296875,
        1092.123779296875
      ],
      [
        -2963.999755859375,
        -4032.48779296875,
        1092.123779296875
      ],
      [
        -2963.999755859375,
        -4032.48779296875,
        1093.623779296875
      ],
      [
        -2925.923828125,
        -4013.11572265625,
        1108.123779296875
      ],
      [
        -2925.03125,
        -4012.66162109375,
        1076.123779296875
      ],
      [
        -2925.03125,
        -4012.66162109375,
        1057.5999755859375
      ],
      [
        -2919.676025390625,
        -4009.93701171875,
        1084.623779296875
      ],
      [
        -2923.03564453125,
        -4004.117919921875,
        1084.623779296875
      ],
      [
        -2925.03125,
        -4012.66162109375,
        1076.123779296875
      ],
      [
        -2923.03564453125,
        -4004.117919921875,
        1106.623779296875
      ],
      [
        -2919.676025390625,
        -4009.93701171875,
        1106.623779296875
      ],
      [
        -2920.5,
        -4010.356201171875,
        1108.123779296875
      ],
      [
        -2924.1015625,
        -4004.117919921875,
        1108.123779296875
      ],
      [
        -2944.571533203125,
        -3998.117919921875,
        1084.623779296875
      ],
      [
        -2927.03271484375,
        -3999.041015625,
        1108.123779296875
      ],
      [
        -2923.524169921875,
        -4005.117919921875,
        1108.123779296875
      ],
      [
        -2923.24609375,
        -4011.75341796875,
        1113.123779296875
      ],
      [
        -2925.923828125,
        -4013.11572265625,
        1108.123779296875
      ],
      [
        -2923.24609375,
        -4011.75341796875,
        1113.123779296875
      ],
      [
        -2987.999755859375,
        -4044.6982421875,
        1102.623779296875
      ],
      [
        -2994.94970703125,
        -4048.234375,
        1098.82373046875
      ],
      [
        -2992.185791015625,
        -4046.827880859375,
        1139.873779296875
      ],
      [
        -2992.185791015625,
        -4046.827880859375,
        1127.5999755859375
      ],
      [
        -2992.18603515625,
        -4046.828125,
        1102.623779296875
      ],
      [
        -2994.94970703125,
        -4048.234375,
        1102.623779296875
      ],
      [
        -2994.94970703125,
        -4042.89697265625,
        1102.623779296875
      ],
      [
        -2994.455322265625,
        -4042.89697265625,
        1102.623779296875
      ],
      [
        -2994.94970703125,
        -4048.234130859375,
        1127.5999755859375
      ],
      [
        -2992.185791015625,
        -4046.827880859375,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4042.040283203125,
        1102.623779296875
      ],
      [
        -2987.999755859375,
        -4044.6982421875,
        1102.623779296875
      ],
      [
        -2987.999755859375,
        -4044.6982421875,
        1082.623779296875
      ],
      [
        -2994.94970703125,
        -4048.234375,
        1078.82373046875
      ],
      [
        -2987.999755859375,
        -4044.6982421875,
        1082.623779296875
      ],
      [
        -2994.94970703125,
        -4048.234375,
        1082.623779296875
      ],
      [
        -2781.499755859375,
        -4019.513916015625,
        1137.623779296875
      ],
      [
        -2781.899658203125,
        -4019.310302734375,
        1108.123779296875
      ],
      [
        -2780.499755859375,
        -4020.023193359375,
        1137.623779296875
      ],
      [
        -2780.099609375,
        -4020.226318359375,
        1108.123779296875
      ],
      [
        -2781.8994140625,
        -4020.66845703125,
        1108.123779296875
      ],
      [
        -2781.8994140625,
        -4019.310546875,
        1108.123779296875
      ],
      [
        -2780.099609375,
        -4020.226318359375,
        1108.123779296875
      ],
      [
        -2780.099609375,
        -4020.66845703125,
        1108.123779296875
      ],
      [
        -2779.230712890625,
        -4020.66845703125,
        1108.123779296875
      ],
      [
        -2761.676025390625,
        -4029.60009765625,
        1084.623779296875
      ],
      [
        -2761.676025390625,
        -4029.60009765625,
        1106.623779296875
      ],
      [
        -2768.499755859375,
        -4041.419189453125,
        1093.623779296875
      ],
      [
        -2768.499755859375,
        -4026.1279296875,
        1093.623779296875
      ],
      [
        -2761.676025390625,
        -4029.599853515625,
        1093.623779296875
      ],
      [
        -2782.58447265625,
        -4035.419189453125,
        1057.5999755859375
      ],
      [
        -2782.333251953125,
        -4035.419189453125,
        1076.123779296875
      ],
      [
        -2767.03125,
        -4026.87548828125,
        1057.5999755859375
      ],
      [
        -2767.03125,
        -4026.87548828125,
        1076.123779296875
      ],
      [
        -2768.499755859375,
        -4029.4189453125,
        1092.123779296875
      ],
      [
        -2768.499755859375,
        -4026.1279296875,
        1092.123779296875
      ],
      [
        -2768.499755859375,
        -4026.1279296875,
        1093.623779296875
      ],
      [
        -2768.499755859375,
        -4029.4189453125,
        1093.623779296875
      ],
      [
        -2768.499755859375,
        -4026.1279296875,
        1092.123779296875
      ],
      [
        -2768.499755859375,
        -4029.4189453125,
        1092.123779296875
      ],
      [
        -2767.031005859375,
        -4026.875244140625,
        1092.123779296875
      ],
      [
        -2767.03125,
        -4026.87548828125,
        1076.123779296875
      ],
      [
        -2765.03564453125,
        -4035.419189453125,
        1084.623779296875
      ],
      [
        -2761.676025390625,
        -4029.60009765625,
        1084.623779296875
      ],
      [
        -2768.499755859375,
        -4035.419189453125,
        1092.123779296875
      ],
      [
        -2765.03564453125,
        -4035.419189453125,
        1092.123779296875
      ],
      [
        -2761.676025390625,
        -4029.599853515625,
        1092.123779296875
      ],
      [
        -2768.499755859375,
        -4035.419189453125,
        1092.123779296875
      ],
      [
        -2768.499755859375,
        -4035.419189453125,
        1093.623779296875
      ],
      [
        -2782.333251953125,
        -4035.419189453125,
        1076.123779296875
      ],
      [
        -2782.218017578125,
        -4041.419189453125,
        1084.623779296875
      ],
      [
        -2768.499755859375,
        -4041.419189453125,
        1092.123779296875
      ],
      [
        -2768.499755859375,
        -4041.419189453125,
        1092.123779296875
      ],
      [
        -2768.499755859375,
        -4041.419189453125,
        1093.623779296875
      ],
      [
        -2765.245849609375,
        -4027.783447265625,
        1113.123779296875
      ],
      [
        -2761.676025390625,
        -4029.60009765625,
        1106.623779296875
      ],
      [
        -2767.923583984375,
        -4026.421142578125,
        1108.123779296875
      ],
      [
        -2781.8994140625,
        -4034.419189453125,
        1108.123779296875
      ],
      [
        -2769.03271484375,
        -4040.49609375,
        1108.123779296875
      ],
      [
        -2781.919921875,
        -4041.419189453125,
        1106.623779296875
      ],
      [
        -2781.8994140625,
        -4040.49609375,
        1108.123779296875
      ],
      [
        -2781.83154296875,
        -4037.419189453125,
        1113.123779296875
      ],
      [
        -2767.923583984375,
        -4026.421142578125,
        1108.123779296875
      ],
      [
        -2765.245849609375,
        -4027.783447265625,
        1113.123779296875
      ],
      [
        -2781.8994140625,
        -4034.419189453125,
        1108.123779296875
      ],
      [
        -2781.83154296875,
        -4037.419189453125,
        1113.123779296875
      ],
      [
        -2755.999755859375,
        -4032.48779296875,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4041.419189453125,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4041.419189453125,
        1092.123779296875
      ],
      [
        -2755.999755859375,
        -4032.48779296875,
        1092.123779296875
      ],
      [
        -2755.999755859375,
        -4041.419189453125,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4032.48779296875,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4032.48779296875,
        1092.123779296875
      ],
      [
        -2755.999755859375,
        -4041.419189453125,
        1092.123779296875
      ],
      [
        -2800.323486328125,
        -4009.93701171875,
        1084.623779296875
      ],
      [
        -2800.323486328125,
        -4009.93701171875,
        1106.623779296875
      ],
      [
        -2794.07568359375,
        -4013.11572265625,
        1108.123779296875
      ],
      [
        -2794.96826171875,
        -4012.66162109375,
        1076.123779296875
      ],
      [
        -2800.323486328125,
        -4009.93701171875,
        1084.623779296875
      ],
      [
        -2792.966796875,
        -4040.49609375,
        1108.123779296875
      ],
      [
        -2781.8994140625,
        -4040.49609375,
        1108.123779296875
      ],
      [
        -2804.933837890625,
        -4019.7685546875,
        1108.123779296875
      ],
      [
        -2800.323486328125,
        -4009.93701171875,
        1106.623779296875
      ],
      [
        -2799.49951171875,
        -4010.356201171875,
        1108.123779296875
      ],
      [
        -2782.459228515625,
        -4035.419189453125,
        1066.82861328125
      ],
      [
        -2794.96826171875,
        -4012.66162109375,
        1066.055419921875
      ],
      [
        -2794.96826171875,
        -4012.66162109375,
        1076.123779296875
      ],
      [
        -2801.425048828125,
        -4013.69140625,
        1108.123779296875
      ],
      [
        -2785.94970703125,
        -4040.49609375,
        1108.123779296875
      ],
      [
        -2794.07568359375,
        -4013.11572265625,
        1108.123779296875
      ],
      [
        -2796.75341796875,
        -4011.75341796875,
        1113.123779296875
      ],
      [
        -2796.75341796875,
        -4011.75341796875,
        1113.123779296875
      ],
      [
        -2794.96826171875,
        -4012.66162109375,
        1057.5999755859375
      ],
      [
        -2768.499755859375,
        -4050.7685546875,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4050.7685546875,
        1093.623779296875
      ],
      [
        -2768.499755859375,
        -4050.7685546875,
        1092.123779296875
      ],
      [
        -2755.999755859375,
        -4050.7685546875,
        1092.123779296875
      ],
      [
        -2768.499755859375,
        -4050.7685546875,
        1092.123779296875
      ],
      [
        -2768.499755859375,
        -4050.7685546875,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4050.7685546875,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4050.7685546875,
        1092.123779296875
      ],
      [
        -2725.0498046875,
        -4050.7685546875,
        1078.82373046875
      ],
      [
        -2725.0498046875,
        -4048.234375,
        1078.82373046875
      ],
      [
        -2731.999755859375,
        -4044.698486328125,
        1082.623779296875
      ],
      [
        -2731.999755859375,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -2731.999755859375,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -2731.999755859375,
        -4044.698486328125,
        1082.623779296875
      ],
      [
        -2725.0498046875,
        -4048.234375,
        1082.623779296875
      ],
      [
        -2725.0498046875,
        -4050.7685546875,
        1098.82373046875
      ],
      [
        -2725.0498046875,
        -4048.234375,
        1098.82373046875
      ],
      [
        -2731.999755859375,
        -4044.698486328125,
        1102.623779296875
      ],
      [
        -2731.999755859375,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2727.813720703125,
        -4046.827880859375,
        1127.5999755859375
      ],
      [
        -2727.813720703125,
        -4046.827880859375,
        1139.873779296875
      ],
      [
        -2727.813720703125,
        -4046.827880859375,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4048.234130859375,
        1127.5999755859375
      ],
      [
        -2727.81396484375,
        -4046.828125,
        1102.623779296875
      ],
      [
        -2725.0498046875,
        -4048.234375,
        1102.623779296875
      ],
      [
        -2730.0888671875,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2731.999755859375,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2731.999755859375,
        -4044.698486328125,
        1102.623779296875
      ],
      [
        -2867.466796875,
        -4030.041015625,
        1108.123779296875
      ],
      [
        -2879.433837890625,
        -4050.7685546875,
        1108.123779296875
      ],
      [
        -2831.565673828125,
        -4050.7685546875,
        1108.123779296875
      ],
      [
        -2843.53271484375,
        -4030.041015625,
        1108.123779296875
      ],
      [
        -2843.53271484375,
        -4030.041015625,
        1108.123779296875
      ],
      [
        -2867.466796875,
        -4030.041015625,
        1108.123779296875
      ],
      [
        -2849.927734375,
        -4029.117919921875,
        1084.623779296875
      ],
      [
        -2861.071533203125,
        -4029.117919921875,
        1084.623779296875
      ],
      [
        -2856.39990234375,
        -4050.7685546875,
        1108.123779296875
      ],
      [
        -2855.999755859375,
        -4050.7685546875,
        1137.623779296875
      ],
      [
        -2854.599853515625,
        -4050.7685546875,
        1108.123779296875
      ],
      [
        -2854.999755859375,
        -4050.7685546875,
        1137.623779296875
      ],
      [
        -2835.59912109375,
        -4049.9365234375,
        1113.123779296875
      ],
      [
        -2832.085205078125,
        -4049.86865234375,
        1108.123779296875
      ],
      [
        -2839.102294921875,
        -4049.86865234375,
        1108.123779296875
      ],
      [
        -2835.59912109375,
        -4049.9365234375,
        1113.123779296875
      ],
      [
        -2850.549560546875,
        -4030.041015625,
        1108.123779296875
      ],
      [
        -2856.39990234375,
        -4036.117919921875,
        1108.123779296875
      ],
      [
        -2856.33203125,
        -4033.117919921875,
        1113.123779296875
      ],
      [
        -2856.33203125,
        -4033.117919921875,
        1113.123779296875
      ],
      [
        -2856.39990234375,
        -4030.041015625,
        1108.123779296875
      ],
      [
        -2860.44970703125,
        -4030.041015625,
        1108.123779296875
      ],
      [
        -2939.900146484375,
        -4020.226318359375,
        1108.123779296875
      ],
      [
        -2938.10009765625,
        -4019.310546875,
        1108.123779296875
      ],
      [
        -2938.10009765625,
        -4020.66845703125,
        1108.123779296875
      ],
      [
        -2939.900146484375,
        -4020.66845703125,
        1108.123779296875
      ],
      [
        -2940.768798828125,
        -4020.66845703125,
        1108.123779296875
      ],
      [
        -2958.32373046875,
        -4029.599853515625,
        1093.623779296875
      ],
      [
        -2951.499755859375,
        -4041.419189453125,
        1093.623779296875
      ],
      [
        -2937.666259765625,
        -4035.419189453125,
        1076.123779296875
      ],
      [
        -2937.4150390625,
        -4035.419189453125,
        1057.5999755859375
      ],
      [
        -2951.499755859375,
        -4029.419921875,
        1093.623779296875
      ],
      [
        -2951.499755859375,
        -4029.419921875,
        1092.123779296875
      ],
      [
        -2951.499755859375,
        -4029.419921875,
        1092.123779296875
      ],
      [
        -2952.96875,
        -4026.875244140625,
        1092.123779296875
      ],
      [
        -2954.9638671875,
        -4035.419189453125,
        1084.623779296875
      ],
      [
        -2951.499755859375,
        -4035.419189453125,
        1092.123779296875
      ],
      [
        -2958.32373046875,
        -4029.599853515625,
        1092.123779296875
      ],
      [
        -2954.9638671875,
        -4035.419189453125,
        1092.123779296875
      ],
      [
        -2951.499755859375,
        -4035.419189453125,
        1093.623779296875
      ],
      [
        -2951.499755859375,
        -4035.419189453125,
        1092.123779296875
      ],
      [
        -2937.781494140625,
        -4041.419189453125,
        1084.623779296875
      ],
      [
        -2937.666259765625,
        -4035.419189453125,
        1076.123779296875
      ],
      [
        -2951.499755859375,
        -4041.419189453125,
        1092.123779296875
      ],
      [
        -2951.499755859375,
        -4041.419189453125,
        1093.623779296875
      ],
      [
        -2951.499755859375,
        -4041.419189453125,
        1092.123779296875
      ],
      [
        -2938.10009765625,
        -4034.419189453125,
        1108.123779296875
      ],
      [
        -2938.07958984375,
        -4041.419189453125,
        1106.623779296875
      ],
      [
        -2950.966796875,
        -4040.49609375,
        1108.123779296875
      ],
      [
        -2938.10009765625,
        -4040.49609375,
        1108.123779296875
      ],
      [
        -2938.16796875,
        -4037.419189453125,
        1113.123779296875
      ],
      [
        -2938.16796875,
        -4037.419189453125,
        1113.123779296875
      ],
      [
        -2938.10009765625,
        -4034.419189453125,
        1108.123779296875
      ],
      [
        -2963.999755859375,
        -4041.419189453125,
        1093.623779296875
      ],
      [
        -2963.999755859375,
        -4041.419189453125,
        1092.123779296875
      ],
      [
        -2963.999755859375,
        -4041.419189453125,
        1092.123779296875
      ],
      [
        -2963.999755859375,
        -4041.419189453125,
        1093.623779296875
      ],
      [
        -2938.10009765625,
        -4040.49609375,
        1108.123779296875
      ],
      [
        -2927.03271484375,
        -4040.49609375,
        1108.123779296875
      ],
      [
        -2915.065673828125,
        -4019.7685546875,
        1108.123779296875
      ],
      [
        -2920.5,
        -4010.356201171875,
        1108.123779296875
      ],
      [
        -2937.540283203125,
        -4035.419189453125,
        1066.8287353515625
      ],
      [
        -2925.03125,
        -4012.66162109375,
        1066.0555419921875
      ],
      [
        -2918.574462890625,
        -4013.69140625,
        1108.123779296875
      ],
      [
        -2934.0498046875,
        -4040.49609375,
        1108.123779296875
      ],
      [
        -2963.999755859375,
        -4050.7685546875,
        1093.623779296875
      ],
      [
        -2951.499755859375,
        -4050.7685546875,
        1093.623779296875
      ],
      [
        -2963.999755859375,
        -4050.7685546875,
        1092.123779296875
      ],
      [
        -2951.499755859375,
        -4050.7685546875,
        1092.123779296875
      ],
      [
        -2963.999755859375,
        -4050.7685546875,
        1092.123779296875
      ],
      [
        -2963.999755859375,
        -4050.7685546875,
        1093.623779296875
      ],
      [
        -2951.499755859375,
        -4050.7685546875,
        1093.623779296875
      ],
      [
        -2951.499755859375,
        -4050.7685546875,
        1092.123779296875
      ],
      [
        -2987.999755859375,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -2994.94970703125,
        -4050.7685546875,
        1078.82373046875
      ],
      [
        -2987.999755859375,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -2987.999755859375,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2994.94970703125,
        -4050.7685546875,
        1098.82373046875
      ],
      [
        -2989.9111328125,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2992.18603515625,
        -4046.828125,
        1102.623779296875
      ],
      [
        -2987.999755859375,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2780.099609375,
        -4020.226318359375,
        1108.123779296875
      ],
      [
        -2781.899658203125,
        -4019.310546875,
        1108.123779296875
      ],
      [
        -2781.899658203125,
        -4018.86865234375,
        1108.123779296875
      ],
      [
        -2780.099609375,
        -4018.86865234375,
        1108.123779296875
      ],
      [
        -2782.76806640625,
        -4018.86865234375,
        1108.123779296875
      ],
      [
        -2761.676025390625,
        -4029.599853515625,
        1093.623779296875
      ],
      [
        -2763.843017578125,
        -4018.18359375,
        1057.5999755859375
      ],
      [
        -2763.697998046875,
        -4018.434814453125,
        1076.123779296875
      ],
      [
        -2767.031005859375,
        -4026.875244140625,
        1092.123779296875
      ],
      [
        -2762.927978515625,
        -4019.7685546875,
        1092.123779296875
      ],
      [
        -2763.697998046875,
        -4018.434814453125,
        1076.123779296875
      ],
      [
        -2762.172607421875,
        -4018.4599609375,
        1077.9774169921875
      ],
      [
        -2761.676025390625,
        -4029.599853515625,
        1092.123779296875
      ],
      [
        -2756.703125,
        -4018.55029296875,
        1084.623779296875
      ],
      [
        -2764.602294921875,
        -4018.86865234375,
        1108.123779296875
      ],
      [
        -2757.065673828125,
        -4019.7685546875,
        1108.123779296875
      ],
      [
        -2757.585205078125,
        -4018.86865234375,
        1108.123779296875
      ],
      [
        -2756.531005859375,
        -4018.848388671875,
        1106.623779296875
      ],
      [
        -2760.612548828125,
        -4018.92724609375,
        1112.431396484375
      ],
      [
        -2764.602294921875,
        -4018.86865234375,
        1108.123779296875
      ],
      [
        -2761.09912109375,
        -4018.9365234375,
        1113.123779296875
      ],
      [
        -2761.09912109375,
        -4018.9365234375,
        1113.123779296875
      ],
      [
        -2796.9638671875,
        -4004.117919921875,
        1084.623779296875
      ],
      [
        -2795.89794921875,
        -4004.117919921875,
        1108.123779296875
      ],
      [
        -2799.49951171875,
        -4010.356201171875,
        1108.123779296875
      ],
      [
        -2796.9638671875,
        -4004.117919921875,
        1106.623779296875
      ],
      [
        -2775.427978515625,
        -3998.117919921875,
        1084.623779296875
      ],
      [
        -2792.966796875,
        -3999.041015625,
        1108.123779296875
      ],
      [
        -2796.475341796875,
        -4005.117919921875,
        1108.123779296875
      ],
      [
        -2725.0498046875,
        -4042.89697265625,
        1102.623779296875
      ],
      [
        -2727.81396484375,
        -4046.828125,
        1102.623779296875
      ],
      [
        -2725.54443359375,
        -4042.89697265625,
        1102.623779296875
      ],
      [
        -2725.0498046875,
        -4042.040283203125,
        1102.623779296875
      ],
      [
        -2709.7998046875,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2709.7998046875,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -2709.7998046875,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1078.82373046875
      ],
      [
        -2709.7998046875,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1098.82373046875
      ],
      [
        -3010.19970703125,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -3010.19970703125,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -3003.1396484375,
        -4050.7685546875,
        1078.82373046875
      ],
      [
        -3010.19970703125,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -3003.1396484375,
        -4050.7685546875,
        1098.82373046875
      ],
      [
        -3010.19970703125,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2994.94970703125,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -3003.1396484375,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -3003.1396484375,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4053.302734375,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4053.302734375,
        1137.623779296875
      ],
      [
        -2994.94970703125,
        -4053.302734375,
        1137.623779296875
      ],
      [
        -2994.94970703125,
        -4053.302734375,
        1127.5999755859375
      ],
      [
        -3003.1396484375,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -2994.94970703125,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -2994.94970703125,
        -4054.818603515625,
        1082.623779296875
      ],
      [
        -3003.1396484375,
        -4054.818603515625,
        1082.623779296875
      ],
      [
        -3003.1396484375,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2994.94970703125,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2994.94970703125,
        -4054.818603515625,
        1102.623779296875
      ],
      [
        -3003.1396484375,
        -4054.818603515625,
        1102.623779296875
      ],
      [
        -3003.1396484375,
        -4061.7685546875,
        1102.623779296875
      ],
      [
        -2994.94970703125,
        -4061.7685546875,
        1102.623779296875
      ],
      [
        -3003.1396484375,
        -4058.64013671875,
        1139.873779296875
      ],
      [
        -2994.94970703125,
        -4058.64013671875,
        1139.873779296875
      ],
      [
        -2994.94970703125,
        -4058.64013671875,
        1127.5999755859375
      ],
      [
        -3003.1396484375,
        -4058.64013671875,
        1127.5999755859375
      ],
      [
        -3003.1396484375,
        -4058.64013671875,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4058.64013671875,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4058.64013671875,
        1102.623779296875
      ],
      [
        -3003.1396484375,
        -4058.64013671875,
        1102.623779296875
      ],
      [
        -2994.94970703125,
        -4061.7685546875,
        1102.623779296875
      ],
      [
        -3003.1396484375,
        -4061.7685546875,
        1102.623779296875
      ],
      [
        -3003.1396484375,
        -4061.7685546875,
        1082.623779296875
      ],
      [
        -2994.94970703125,
        -4061.7685546875,
        1082.623779296875
      ],
      [
        -2994.94970703125,
        -4061.7685546875,
        1082.623779296875
      ],
      [
        -3003.1396484375,
        -4061.7685546875,
        1082.623779296875
      ],
      [
        -2716.85986328125,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4053.302734375,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4053.302734375,
        1137.623779296875
      ],
      [
        -2725.0498046875,
        -4053.302734375,
        1137.623779296875
      ],
      [
        -2725.0498046875,
        -4053.302734375,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4054.818603515625,
        1082.623779296875
      ],
      [
        -2725.0498046875,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1082.623779296875
      ],
      [
        -2716.85986328125,
        -4054.818603515625,
        1082.623779296875
      ],
      [
        -2725.0498046875,
        -4054.818603515625,
        1102.623779296875
      ],
      [
        -2725.0498046875,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4054.818603515625,
        1102.623779296875
      ],
      [
        -2725.0498046875,
        -4061.7685546875,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4061.7685546875,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4058.64013671875,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4058.64013671875,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4058.64013671875,
        1139.873779296875
      ],
      [
        -2716.85986328125,
        -4058.64013671875,
        1139.873779296875
      ],
      [
        -2725.0498046875,
        -4058.64013671875,
        1127.5999755859375
      ],
      [
        -2716.85986328125,
        -4058.64013671875,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4058.64013671875,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4058.64013671875,
        1102.623779296875
      ],
      [
        -2716.85986328125,
        -4061.7685546875,
        1102.623779296875
      ],
      [
        -2725.0498046875,
        -4061.7685546875,
        1102.623779296875
      ],
      [
        -2725.0498046875,
        -4061.7685546875,
        1082.623779296875
      ],
      [
        -2716.85986328125,
        -4061.7685546875,
        1082.623779296875
      ],
      [
        -2716.85986328125,
        -4061.7685546875,
        1082.623779296875
      ],
      [
        -2725.0498046875,
        -4061.7685546875,
        1082.623779296875
      ],
      [
        -2800.323486328125,
        -4091.60009765625,
        1106.623779296875
      ],
      [
        -2800.323486328125,
        -4091.60009765625,
        1084.623779296875
      ],
      [
        -2780.099609375,
        -4081.310791015625,
        1108.123779296875
      ],
      [
        -2780.499755859375,
        -4081.514404296875,
        1137.623779296875
      ],
      [
        -2781.899658203125,
        -4082.2265625,
        1108.123779296875
      ],
      [
        -2781.499755859375,
        -4082.023193359375,
        1137.623779296875
      ],
      [
        -2780.099609375,
        -4082.668701171875,
        1108.123779296875
      ],
      [
        -2781.899658203125,
        -4082.668701171875,
        1108.123779296875
      ],
      [
        -2781.899658203125,
        -4082.226806640625,
        1108.123779296875
      ],
      [
        -2780.099609375,
        -4081.31103515625,
        1108.123779296875
      ],
      [
        -2782.768310546875,
        -4082.668701171875,
        1108.123779296875
      ],
      [
        -2761.67578125,
        -4071.937255859375,
        1106.623779296875
      ],
      [
        -2761.67578125,
        -4071.937255859375,
        1084.623779296875
      ],
      [
        -2768.499755859375,
        -4075.4091796875,
        1093.623779296875
      ],
      [
        -2761.676025390625,
        -4071.937255859375,
        1093.623779296875
      ],
      [
        -2767.031005859375,
        -4074.661865234375,
        1076.123779296875
      ],
      [
        -2767.031005859375,
        -4074.661865234375,
        1057.5999755859375
      ],
      [
        -2763.697998046875,
        -4083.1025390625,
        1076.123779296875
      ],
      [
        -2763.84326171875,
        -4083.353759765625,
        1057.5999755859375
      ],
      [
        -2768.499755859375,
        -4075.4091796875,
        1092.123779296875
      ],
      [
        -2762.927978515625,
        -4081.7685546875,
        1092.123779296875
      ],
      [
        -2767.031005859375,
        -4074.661865234375,
        1092.123779296875
      ],
      [
        -2768.499755859375,
        -4075.4091796875,
        1092.123779296875
      ],
      [
        -2768.499755859375,
        -4075.4091796875,
        1093.623779296875
      ],
      [
        -2763.697998046875,
        -4083.1025390625,
        1076.123779296875
      ],
      [
        -2762.172119140625,
        -4083.077392578125,
        1077.97802734375
      ],
      [
        -2761.67578125,
        -4071.937255859375,
        1084.623779296875
      ],
      [
        -2767.031005859375,
        -4074.661865234375,
        1076.123779296875
      ],
      [
        -2761.676025390625,
        -4071.937255859375,
        1092.123779296875
      ],
      [
        -2756.703369140625,
        -4082.9873046875,
        1084.623779296875
      ],
      [
        -2761.67578125,
        -4071.937255859375,
        1106.623779296875
      ],
      [
        -2765.245849609375,
        -4073.753662109375,
        1113.123779296875
      ],
      [
        -2764.602294921875,
        -4082.66845703125,
        1108.123779296875
      ],
      [
        -2767.923583984375,
        -4075.115966796875,
        1108.123779296875
      ],
      [
        -2756.53125,
        -4082.68896484375,
        1106.623779296875
      ],
      [
        -2757.58544921875,
        -4082.668701171875,
        1108.123779296875
      ],
      [
        -2757.065673828125,
        -4081.7685546875,
        1108.123779296875
      ],
      [
        -2765.245849609375,
        -4073.753662109375,
        1113.123779296875
      ],
      [
        -2767.923583984375,
        -4075.115966796875,
        1108.123779296875
      ],
      [
        -2760.6123046875,
        -4082.6103515625,
        1112.4306640625
      ],
      [
        -2761.099365234375,
        -4082.60107421875,
        1113.123779296875
      ],
      [
        -2764.602294921875,
        -4082.66845703125,
        1108.123779296875
      ],
      [
        -2761.099365234375,
        -4082.60107421875,
        1113.123779296875
      ],
      [
        -2755.999755859375,
        -4069.04931640625,
        1092.123779296875
      ],
      [
        -2755.999755859375,
        -4069.04931640625,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4069.04931640625,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4069.04931640625,
        1092.123779296875
      ],
      [
        -2794.07568359375,
        -4088.421630859375,
        1108.123779296875
      ],
      [
        -2794.96826171875,
        -4088.87548828125,
        1076.123779296875
      ],
      [
        -2794.96826171875,
        -4088.87548828125,
        1057.5999755859375
      ],
      [
        -2800.323486328125,
        -4091.60009765625,
        1084.623779296875
      ],
      [
        -2796.9638671875,
        -4097.4189453125,
        1084.623779296875
      ],
      [
        -2794.96826171875,
        -4088.87548828125,
        1076.123779296875
      ],
      [
        -2796.9638671875,
        -4097.4189453125,
        1106.623779296875
      ],
      [
        -2800.323486328125,
        -4091.60009765625,
        1106.623779296875
      ],
      [
        -2799.49951171875,
        -4091.180908203125,
        1108.123779296875
      ],
      [
        -2795.89794921875,
        -4097.4189453125,
        1108.123779296875
      ],
      [
        -2775.427978515625,
        -4103.4189453125,
        1084.623779296875
      ],
      [
        -2792.966796875,
        -4102.49609375,
        1108.123779296875
      ],
      [
        -2796.475341796875,
        -4096.4189453125,
        1108.123779296875
      ],
      [
        -2796.753173828125,
        -4089.78369140625,
        1113.123779296875
      ],
      [
        -2794.07568359375,
        -4088.421630859375,
        1108.123779296875
      ],
      [
        -2796.753173828125,
        -4089.78369140625,
        1113.123779296875
      ],
      [
        -2725.0498046875,
        -4053.302978515625,
        1098.82373046875
      ],
      [
        -2731.999755859375,
        -4056.8388671875,
        1102.623779296875
      ],
      [
        -2727.813720703125,
        -4054.709228515625,
        1127.5999755859375
      ],
      [
        -2727.813720703125,
        -4054.709228515625,
        1139.873779296875
      ],
      [
        -2727.81396484375,
        -4054.709228515625,
        1102.623779296875
      ],
      [
        -2725.0498046875,
        -4053.302978515625,
        1102.623779296875
      ],
      [
        -2725.0498046875,
        -4058.64013671875,
        1102.623779296875
      ],
      [
        -2725.544921875,
        -4058.64013671875,
        1102.623779296875
      ],
      [
        -2727.813720703125,
        -4054.709228515625,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4053.302978515625,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4059.497802734375,
        1102.623779296875
      ],
      [
        -2731.999755859375,
        -4056.8388671875,
        1102.623779296875
      ],
      [
        -2725.0498046875,
        -4053.302978515625,
        1078.82373046875
      ],
      [
        -2731.999755859375,
        -4056.8388671875,
        1082.623779296875
      ],
      [
        -2731.999755859375,
        -4056.8388671875,
        1082.623779296875
      ],
      [
        -2725.0498046875,
        -4053.302978515625,
        1082.623779296875
      ],
      [
        -2780.099609375,
        -4081.310791015625,
        1108.123779296875
      ],
      [
        -2781.8994140625,
        -4082.2265625,
        1108.123779296875
      ],
      [
        -2781.8994140625,
        -4080.86865234375,
        1108.123779296875
      ],
      [
        -2780.099609375,
        -4080.86865234375,
        1108.123779296875
      ],
      [
        -2779.230712890625,
        -4080.86865234375,
        1108.123779296875
      ],
      [
        -2768.499755859375,
        -4060.117919921875,
        1093.623779296875
      ],
      [
        -2761.676025390625,
        -4071.937255859375,
        1093.623779296875
      ],
      [
        -2782.333251953125,
        -4066.117919921875,
        1076.123779296875
      ],
      [
        -2782.58447265625,
        -4066.117919921875,
        1057.5999755859375
      ],
      [
        -2768.499755859375,
        -4072.1181640625,
        1092.123779296875
      ],
      [
        -2768.499755859375,
        -4072.1181640625,
        1093.623779296875
      ],
      [
        -2768.499755859375,
        -4072.1181640625,
        1092.123779296875
      ],
      [
        -2767.031005859375,
        -4074.661865234375,
        1092.123779296875
      ],
      [
        -2765.03564453125,
        -4066.117919921875,
        1084.623779296875
      ],
      [
        -2768.499755859375,
        -4066.117919921875,
        1092.123779296875
      ],
      [
        -2761.676025390625,
        -4071.937255859375,
        1092.123779296875
      ],
      [
        -2765.03564453125,
        -4066.117919921875,
        1092.123779296875
      ],
      [
        -2768.499755859375,
        -4066.117919921875,
        1092.123779296875
      ],
      [
        -2768.499755859375,
        -4066.117919921875,
        1093.623779296875
      ],
      [
        -2782.218017578125,
        -4060.117919921875,
        1084.623779296875
      ],
      [
        -2782.333251953125,
        -4066.117919921875,
        1076.123779296875
      ],
      [
        -2768.499755859375,
        -4060.117919921875,
        1092.123779296875
      ],
      [
        -2768.499755859375,
        -4060.117919921875,
        1092.123779296875
      ],
      [
        -2768.499755859375,
        -4060.117919921875,
        1093.623779296875
      ],
      [
        -2781.8994140625,
        -4067.117919921875,
        1108.123779296875
      ],
      [
        -2781.919921875,
        -4060.117919921875,
        1106.623779296875
      ],
      [
        -2769.03271484375,
        -4061.041015625,
        1108.123779296875
      ],
      [
        -2781.8994140625,
        -4061.041015625,
        1108.123779296875
      ],
      [
        -2781.83154296875,
        -4064.117919921875,
        1113.123779296875
      ],
      [
        -2781.83154296875,
        -4064.117919921875,
        1113.123779296875
      ],
      [
        -2781.8994140625,
        -4067.117919921875,
        1108.123779296875
      ],
      [
        -2755.999755859375,
        -4060.117919921875,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4060.117919921875,
        1092.123779296875
      ],
      [
        -2755.999755859375,
        -4060.117919921875,
        1093.623779296875
      ],
      [
        -2755.999755859375,
        -4060.117919921875,
        1092.123779296875
      ],
      [
        -2781.8994140625,
        -4061.041015625,
        1108.123779296875
      ],
      [
        -2792.966796875,
        -4061.041015625,
        1108.123779296875
      ],
      [
        -2804.933837890625,
        -4081.7685546875,
        1108.123779296875
      ],
      [
        -2799.49951171875,
        -4091.180908203125,
        1108.123779296875
      ],
      [
        -2782.459228515625,
        -4066.117919921875,
        1066.82861328125
      ],
      [
        -2794.96826171875,
        -4088.87548828125,
        1066.0556640625
      ],
      [
        -2801.425048828125,
        -4087.845703125,
        1108.123779296875
      ],
      [
        -2785.94970703125,
        -4061.041015625,
        1108.123779296875
      ],
      [
        -2730.089111328125,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2727.81396484375,
        -4054.709228515625,
        1102.623779296875
      ],
      [
        -2843.53271484375,
        -4071.49609375,
        1108.123779296875
      ],
      [
        -2831.565673828125,
        -4050.7685546875,
        1108.123779296875
      ],
      [
        -2879.433837890625,
        -4050.7685546875,
        1108.123779296875
      ],
      [
        -2867.466796875,
        -4071.49609375,
        1108.123779296875
      ],
      [
        -2867.466796875,
        -4071.49609375,
        1108.123779296875
      ],
      [
        -2843.53271484375,
        -4071.49609375,
        1108.123779296875
      ],
      [
        -2861.071533203125,
        -4072.419189453125,
        1084.623779296875
      ],
      [
        -2849.927734375,
        -4072.419189453125,
        1084.623779296875
      ],
      [
        -2835.59912109375,
        -4051.6005859375,
        1113.123779296875
      ],
      [
        -2832.085205078125,
        -4051.66845703125,
        1108.123779296875
      ],
      [
        -2839.102294921875,
        -4051.66845703125,
        1108.123779296875
      ],
      [
        -2835.59912109375,
        -4051.6005859375,
        1113.123779296875
      ],
      [
        -2850.549560546875,
        -4071.49609375,
        1108.123779296875
      ],
      [
        -2856.39990234375,
        -4065.419189453125,
        1108.123779296875
      ],
      [
        -2856.33203125,
        -4068.419189453125,
        1113.123779296875
      ],
      [
        -2856.33203125,
        -4068.419189453125,
        1113.123779296875
      ],
      [
        -2856.39990234375,
        -4071.49609375,
        1108.123779296875
      ],
      [
        -2860.44970703125,
        -4071.49609375,
        1108.123779296875
      ],
      [
        -2938.499755859375,
        -4082.023193359375,
        1137.623779296875
      ],
      [
        -2938.099853515625,
        -4082.2265625,
        1108.123779296875
      ],
      [
        -2939.499755859375,
        -4081.514404296875,
        1137.623779296875
      ],
      [
        -2939.89990234375,
        -4081.310791015625,
        1108.123779296875
      ],
      [
        -2938.10009765625,
        -4080.86865234375,
        1108.123779296875
      ],
      [
        -2938.10009765625,
        -4082.2265625,
        1108.123779296875
      ],
      [
        -2939.900146484375,
        -4081.310791015625,
        1108.123779296875
      ],
      [
        -2939.900146484375,
        -4080.86865234375,
        1108.123779296875
      ],
      [
        -2940.768798828125,
        -4080.86865234375,
        1108.123779296875
      ],
      [
        -2958.32373046875,
        -4071.937255859375,
        1084.623779296875
      ],
      [
        -2958.32373046875,
        -4071.937255859375,
        1106.623779296875
      ],
      [
        -2951.499755859375,
        -4060.117919921875,
        1093.623779296875
      ],
      [
        -2951.499755859375,
        -4075.4091796875,
        1093.623779296875
      ],
      [
        -2958.323486328125,
        -4071.937255859375,
        1093.623779296875
      ],
      [
        -2937.4150390625,
        -4066.117919921875,
        1057.5999755859375
      ],
      [
        -2937.666259765625,
        -4066.117919921875,
        1076.123779296875
      ],
      [
        -2952.968505859375,
        -4074.661865234375,
        1057.5999755859375
      ],
      [
        -2952.968505859375,
        -4074.661865234375,
        1076.123779296875
      ],
      [
        -2951.499755859375,
        -4075.4091796875,
        1093.623779296875
      ],
      [
        -2951.499755859375,
        -4072.11767578125,
        1093.623779296875
      ],
      [
        -2951.499755859375,
        -4072.11767578125,
        1092.123779296875
      ],
      [
        -2951.499755859375,
        -4075.4091796875,
        1092.123779296875
      ],
      [
        -2952.968505859375,
        -4074.661865234375,
        1092.123779296875
      ],
      [
        -2951.499755859375,
        -4075.4091796875,
        1092.123779296875
      ],
      [
        -2951.499755859375,
        -4072.11767578125,
        1092.123779296875
      ],
      [
        -2952.968505859375,
        -4074.661865234375,
        1076.123779296875
      ],
      [
        -2954.9638671875,
        -4066.117919921875,
        1084.623779296875
      ],
      [
        -2958.32373046875,
        -4071.937255859375,
        1084.623779296875
      ],
      [
        -2958.323486328125,
        -4071.937255859375,
        1092.123779296875
      ],
      [
        -2951.499755859375,
        -4066.117919921875,
        1092.123779296875
      ],
      [
        -2954.9638671875,
        -4066.117919921875,
        1092.123779296875
      ],
      [
        -2951.499755859375,
        -4066.117919921875,
        1093.623779296875
      ],
      [
        -2951.499755859375,
        -4066.117919921875,
        1092.123779296875
      ],
      [
        -2937.666259765625,
        -4066.117919921875,
        1076.123779296875
      ],
      [
        -2937.781494140625,
        -4060.117919921875,
        1084.623779296875
      ],
      [
        -2951.499755859375,
        -4060.117919921875,
        1092.123779296875
      ],
      [
        -2951.499755859375,
        -4060.117919921875,
        1093.623779296875
      ],
      [
        -2951.499755859375,
        -4060.117919921875,
        1092.123779296875
      ],
      [
        -2954.753662109375,
        -4073.753662109375,
        1113.123779296875
      ],
      [
        -2958.32373046875,
        -4071.937255859375,
        1106.623779296875
      ],
      [
        -2952.075927734375,
        -4075.115966796875,
        1108.123779296875
      ],
      [
        -2938.10009765625,
        -4067.117919921875,
        1108.123779296875
      ],
      [
        -2950.966796875,
        -4061.041015625,
        1108.123779296875
      ],
      [
        -2938.07958984375,
        -4060.117919921875,
        1106.623779296875
      ],
      [
        -2938.10009765625,
        -4061.041015625,
        1108.123779296875
      ],
      [
        -2938.16796875,
        -4064.117919921875,
        1113.123779296875
      ],
      [
        -2952.075927734375,
        -4075.115966796875,
        1108.123779296875
      ],
      [
        -2954.753662109375,
        -4073.753662109375,
        1113.123779296875
      ],
      [
        -2938.10009765625,
        -4067.117919921875,
        1108.123779296875
      ],
      [
        -2938.16796875,
        -4064.117919921875,
        1113.123779296875
      ],
      [
        -2963.999755859375,
        -4069.04931640625,
        1093.623779296875
      ],
      [
        -2963.999755859375,
        -4060.117919921875,
        1093.623779296875
      ],
      [
        -2963.999755859375,
        -4060.117919921875,
        1092.123779296875
      ],
      [
        -2963.999755859375,
        -4069.04931640625,
        1092.123779296875
      ],
      [
        -2963.999755859375,
        -4069.04931640625,
        1092.123779296875
      ],
      [
        -2963.999755859375,
        -4060.117919921875,
        1092.123779296875
      ],
      [
        -2963.999755859375,
        -4060.117919921875,
        1093.623779296875
      ],
      [
        -2963.999755859375,
        -4069.04931640625,
        1093.623779296875
      ],
      [
        -2919.676025390625,
        -4091.60009765625,
        1084.623779296875
      ],
      [
        -2919.676025390625,
        -4091.60009765625,
        1106.623779296875
      ],
      [
        -2925.923828125,
        -4088.421630859375,
        1108.123779296875
      ],
      [
        -2925.03125,
        -4088.87548828125,
        1076.123779296875
      ],
      [
        -2919.676025390625,
        -4091.60009765625,
        1084.623779296875
      ],
      [
        -2927.03271484375,
        -4061.041015625,
        1108.123779296875
      ],
      [
        -2938.10009765625,
        -4061.041015625,
        1108.123779296875
      ],
      [
        -2915.065673828125,
        -4081.7685546875,
        1108.123779296875
      ],
      [
        -2919.676025390625,
        -4091.60009765625,
        1106.623779296875
      ],
      [
        -2920.5,
        -4091.180908203125,
        1108.123779296875
      ],
      [
        -2937.540283203125,
        -4066.117919921875,
        1066.82861328125
      ],
      [
        -2925.03125,
        -4088.87548828125,
        1066.0557861328125
      ],
      [
        -2925.03125,
        -4088.87548828125,
        1076.123779296875
      ],
      [
        -2918.574462890625,
        -4087.845703125,
        1108.123779296875
      ],
      [
        -2934.0498046875,
        -4061.041015625,
        1108.123779296875
      ],
      [
        -2925.923828125,
        -4088.421630859375,
        1108.123779296875
      ],
      [
        -2923.246337890625,
        -4089.783935546875,
        1113.123779296875
      ],
      [
        -2923.246337890625,
        -4089.783935546875,
        1113.123779296875
      ],
      [
        -2925.03125,
        -4088.87548828125,
        1057.5999755859375
      ],
      [
        -2987.999755859375,
        -4056.839111328125,
        1082.623779296875
      ],
      [
        -2994.94970703125,
        -4053.30322265625,
        1078.82373046875
      ],
      [
        -2987.999755859375,
        -4056.839111328125,
        1082.623779296875
      ],
      [
        -2994.94970703125,
        -4053.302978515625,
        1082.623779296875
      ],
      [
        -2987.999755859375,
        -4056.839111328125,
        1102.623779296875
      ],
      [
        -2994.94970703125,
        -4053.30322265625,
        1098.82373046875
      ],
      [
        -2992.185791015625,
        -4054.709228515625,
        1139.873779296875
      ],
      [
        -2992.185791015625,
        -4054.709228515625,
        1127.5999755859375
      ],
      [
        -2992.185791015625,
        -4054.709228515625,
        1127.5999755859375
      ],
      [
        -2994.94970703125,
        -4053.302978515625,
        1127.5999755859375
      ],
      [
        -2989.91064453125,
        -4050.7685546875,
        1102.623779296875
      ],
      [
        -2992.185791015625,
        -4054.709228515625,
        1102.623779296875
      ],
      [
        -2994.94970703125,
        -4053.302978515625,
        1102.623779296875
      ],
      [
        -2987.999755859375,
        -4056.839111328125,
        1102.623779296875
      ],
      [
        -2939.89990234375,
        -4081.310791015625,
        1108.123779296875
      ],
      [
        -2938.099853515625,
        -4082.2265625,
        1108.123779296875
      ],
      [
        -2938.099853515625,
        -4082.668701171875,
        1108.123779296875
      ],
      [
        -2939.89990234375,
        -4082.668701171875,
        1108.123779296875
      ],
      [
        -2937.231201171875,
        -4082.668701171875,
        1108.123779296875
      ],
      [
        -2958.323486328125,
        -4071.937255859375,
        1093.623779296875
      ],
      [
        -2956.15625,
        -4083.353759765625,
        1057.5999755859375
      ],
      [
        -2956.301513671875,
        -4083.1025390625,
        1076.123779296875
      ],
      [
        -2957.071533203125,
        -4081.7685546875,
        1092.123779296875
      ],
      [
        -2952.968505859375,
        -4074.661865234375,
        1092.123779296875
      ],
      [
        -2956.301513671875,
        -4083.1025390625,
        1076.123779296875
      ],
      [
        -2957.827392578125,
        -4083.077392578125,
        1077.97802734375
      ],
      [
        -2958.323486328125,
        -4071.937255859375,
        1092.123779296875
      ],
      [
        -2963.296142578125,
        -4082.9873046875,
        1084.623779296875
      ],
      [
        -2955.397216796875,
        -4082.66845703125,
        1108.123779296875
      ],
      [
        -2962.933837890625,
        -4081.7685546875,
        1108.123779296875
      ],
      [
        -2962.4140625,
        -4082.668701171875,
        1108.123779296875
      ],
      [
        -2963.46826171875,
        -4082.68896484375,
        1106.623779296875
      ],
      [
        -2959.38720703125,
        -4082.6103515625,
        1112.430908203125
      ],
      [
        -2955.397216796875,
        -4082.66845703125,
        1108.123779296875
      ],
      [
        -2958.900146484375,
        -4082.60107421875,
        1113.123779296875
      ],
      [
        -2958.900146484375,
        -4082.60107421875,
        1113.123779296875
      ],
      [
        -2923.03564453125,
        -4097.4189453125,
        1084.623779296875
      ],
      [
        -2924.1015625,
        -4097.4189453125,
        1108.123779296875
      ],
      [
        -2920.5,
        -4091.180908203125,
        1108.123779296875
      ],
      [
        -2923.03564453125,
        -4097.4189453125,
        1106.623779296875
      ],
      [
        -2944.572021484375,
        -4103.4189453125,
        1084.623779296875
      ],
      [
        -2927.03271484375,
        -4102.49609375,
        1108.123779296875
      ],
      [
        -2923.524169921875,
        -4096.4189453125,
        1108.123779296875
      ],
      [
        -2994.94970703125,
        -4058.64013671875,
        1102.623779296875
      ],
      [
        -2992.185791015625,
        -4054.709228515625,
        1102.623779296875
      ],
      [
        -2994.455078125,
        -4058.64013671875,
        1102.623779296875
      ],
      [
        -2994.94970703125,
        -4059.4970703125,
        1102.623779296875
      ],
      [
        -3301.525146484375,
        -3890.92822265625,
        1100.8765869140625
      ],
      [
        -3434.203125,
        -4041.093017578125,
        1052.623779296875
      ],
      [
        -3434.10791015625,
        -4041.188232421875,
        1052.623779296875
      ],
      [
        -3431.343017578125,
        -4043.953125,
        1052.623779296875
      ],
      [
        -3431.343017578125,
        -4043.953125,
        1102.623779296875
      ],
      [
        -3428.32373046875,
        -4188.44482421875,
        1121.623779296875
      ],
      [
        -3424.76611328125,
        -4192.00244140625,
        1052.623779296875
      ],
      [
        -3424.765869140625,
        -4192.00244140625,
        1102.6240234375
      ],
      [
        -3411.343017578125,
        -4076.0,
        1076.5999755859375
      ],
      [
        -3415.4033203125,
        -4201.365234375,
        1052.623779296875
      ],
      [
        -3380.645263671875,
        -4162.93359375,
        1076.5999755859375
      ],
      [
        -3383.989013671875,
        -4165.82568359375,
        1076.5999755859375
      ],
      [
        -3347.388427734375,
        -4134.17333984375,
        1076.5999755859375
      ],
      [
        -3380.645263671875,
        -4162.93359375,
        1076.5999755859375
      ],
      [
        -3339.53857421875,
        -4135.7568359375,
        1052.623779296875
      ],
      [
        -3342.22705078125,
        -4136.0224609375,
        1058.5216064453125
      ],
      [
        -3348.673828125,
        -4136.681640625,
        1072.5999755859375
      ],
      [
        -3342.22705078125,
        -4136.0224609375,
        1058.5216064453125
      ],
      [
        -3348.674072265625,
        -4136.681640625,
        1072.5999755859375
      ],
      [
        -3348.65087890625,
        -4136.65673828125,
        1072.6136474609375
      ],
      [
        -3342.398193359375,
        -4129.96923828125,
        1076.2808837890625
      ],
      [
        -3341.851806640625,
        -4129.38525390625,
        1076.5999755859375
      ],
      [
        -3342.398193359375,
        -4129.96923828125,
        1076.2808837890625
      ],
      [
        -3344.110595703125,
        -4129.94189453125,
        1080.5999755859375
      ],
      [
        -3343.96337890625,
        -4129.9052734375,
        1080.3402099609375
      ],
      [
        -3343.96337890625,
        -4129.9052734375,
        1080.3402099609375
      ],
      [
        -3341.851806640625,
        -4129.38525390625,
        1076.5999755859375
      ],
      [
        -3384.736572265625,
        -4165.0751953125,
        1080.5999755859375
      ],
      [
        -3383.989013671875,
        -4165.82568359375,
        1076.5999755859375
      ],
      [
        -3384.736572265625,
        -4165.0751953125,
        1080.5999755859375
      ],
      [
        -3385.494873046875,
        -4165.73095703125,
        1080.5999755859375
      ],
      [
        -3344.8671875,
        -4130.59619140625,
        1080.5999755859375
      ],
      [
        -3344.110595703125,
        -4129.94189453125,
        1080.5999755859375
      ],
      [
        -3170.86669921875,
        -3902.59228515625,
        1302.623779296875
      ],
      [
        -3188.277587890625,
        -3976.673095703125,
        1133.5926513671875
      ],
      [
        -3063.126220703125,
        -3857.455078125,
        1165.0567626953125
      ],
      [
        -3066.32861328125,
        -3883.4814453125,
        1098.453857421875
      ],
      [
        -3163.276611328125,
        -3965.8662109375,
        1102.623779296875
      ],
      [
        -3188.277587890625,
        -3976.673095703125,
        1133.5926513671875
      ],
      [
        -3136.854736328125,
        -3950.0,
        1082.623779296875
      ],
      [
        -3147.131591796875,
        -3958.887451171875,
        1082.623779296875
      ],
      [
        -3169.5,
        -3968.556396484375,
        1082.623779296875
      ],
      [
        -3144.93017578125,
        -3950.0,
        1102.623779296875
      ],
      [
        -3169.5,
        -3968.556396484375,
        1102.623779296875
      ],
      [
        -3163.27734375,
        -3965.86669921875,
        1102.623779296875
      ],
      [
        -3169.5,
        -3968.556396484375,
        1082.623779296875
      ],
      [
        -3169.5,
        -3968.556396484375,
        1102.623779296875
      ],
      [
        -3144.93017578125,
        -3950.0,
        1102.623779296875
      ],
      [
        -3136.854736328125,
        -3950.0,
        1082.623779296875
      ],
      [
        -3066.32861328125,
        -3883.4814453125,
        1098.4541015625
      ],
      [
        -3068.5068359375,
        -3889.566650390625,
        1086.4215087890625
      ],
      [
        -3140.0,
        -3950.0,
        1090.413330078125
      ],
      [
        -3140.0,
        -3951.0,
        1087.5501708984375
      ],
      [
        -3149.70458984375,
        -3960.0,
        1082.623779296875
      ],
      [
        -3150.0,
        -3960.0,
        1086.5421142578125
      ],
      [
        -3149.70458984375,
        -3960.0,
        1085.8109130859375
      ],
      [
        -3169.5,
        -3978.231689453125,
        1082.623779296875
      ],
      [
        -3169.5,
        -3978.231689453125,
        1082.623779296875
      ],
      [
        -3169.5,
        -3971.248046875,
        1102.623779296875
      ],
      [
        -3191.206787109375,
        -3997.00390625,
        1082.623779296875
      ],
      [
        -3191.951416015625,
        -3996.25927734375,
        1086.5999755859375
      ],
      [
        -3196.198974609375,
        -3996.25439453125,
        1086.5999755859375
      ],
      [
        -3191.951416015625,
        -3996.25927734375,
        1086.5999755859375
      ],
      [
        -3193.11865234375,
        -3997.268798828125,
        1086.5999755859375
      ],
      [
        -3175.532470703125,
        -3976.46484375,
        1102.623779296875
      ],
      [
        -3169.5,
        -3968.55615234375,
        1102.623779296875
      ],
      [
        -3169.5,
        -3971.247802734375,
        1102.623779296875
      ],
      [
        -3169.5,
        -3971.248046875,
        1102.623779296875
      ],
      [
        -3163.277099609375,
        -3965.8662109375,
        1102.623779296875
      ],
      [
        -3148.417724609375,
        -3960.0,
        1082.623779296875
      ],
      [
        -3194.2265625,
        -3998.226806640625,
        1086.5999755859375
      ],
      [
        -3126.570556640625,
        -3950.0,
        1102.623779296875
      ],
      [
        -3163.27734375,
        -3965.86669921875,
        1102.623779296875
      ],
      [
        -3126.571044921875,
        -3950.0,
        1088.0
      ],
      [
        -3126.571044921875,
        -3950.0,
        1086.0
      ],
      [
        -3126.570556640625,
        -3950.0,
        1102.623779296875
      ],
      [
        -3126.57080078125,
        -3950.0,
        1082.623779296875
      ],
      [
        -3126.57080078125,
        -3950.0,
        1082.623779296875
      ],
      [
        -3147.131591796875,
        -3958.887451171875,
        1082.623779296875
      ],
      [
        -3149.70458984375,
        -3960.0,
        1085.8109130859375
      ],
      [
        -3149.70458984375,
        -3960.0,
        1096.5999755859375
      ],
      [
        -3140.0,
        -3955.804931640625,
        1096.5999755859375
      ],
      [
        -3140.0,
        -3955.804931640625,
        1095.4000244140625
      ],
      [
        -3051.571044921875,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -3051.571044921875,
        -4249.7685546875,
        1152.623779296875
      ],
      [
        -3208.600830078125,
        -4249.7685546875,
        1087.26513671875
      ],
      [
        -3208.600830078125,
        -4239.7685546875,
        1087.26513671875
      ],
      [
        -3181.398681640625,
        -4239.7685546875,
        1087.26513671875
      ],
      [
        -3181.398681640625,
        -4249.7685546875,
        1087.26513671875
      ],
      [
        -3181.398681640625,
        -4249.7685546875,
        1087.26513671875
      ],
      [
        -3181.398681640625,
        -4239.7685546875,
        1087.26513671875
      ],
      [
        -3167.36328125,
        -4239.7685546875,
        1067.623779296875
      ],
      [
        -3167.36328125,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3219.999755859375,
        -4239.7685546875,
        1067.623779296875
      ],
      [
        -3219.999755859375,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3207.499755859375,
        -4249.7685546875,
        1084.9443359375
      ],
      [
        -3207.499755859375,
        -4239.7685546875,
        1084.9443359375
      ],
      [
        -3219.999755859375,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3219.999755859375,
        -4239.7685546875,
        1067.623779296875
      ],
      [
        -3219.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      [
        -3219.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -3167.36328125,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3167.36328125,
        -4239.7685546875,
        1067.623779296875
      ],
      [
        -3167.36328125,
        -4239.7685546875,
        1052.623779296875
      ],
      [
        -3167.36328125,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -3086.468505859375,
        -4060.0,
        1086.5999755859375
      ],
      [
        -3420.64208984375,
        -4196.12646484375,
        1080.5999755859375
      ],
      [
        -3376.999755859375,
        -4239.7685546875,
        1080.5999755859375
      ],
      [
        -3371.0078125,
        -4239.7685546875,
        1080.5999755859375
      ],
      [
        -3341.189697265625,
        -4208.77197265625,
        1076.5999755859375
      ],
      [
        -3340.276123046875,
        -4209.6884765625,
        1080.5999755859375
      ],
      [
        -3296.76953125,
        -4239.7685546875,
        1080.5999755859375
      ],
      [
        -3296.76953125,
        -4194.7666015625,
        1080.5999755859375
      ],
      [
        -3368.5,
        -4169.5,
        1057.767578125
      ],
      [
        -3351.298583984375,
        -4152.22900390625,
        1067.5
      ],
      [
        -3364.766357421875,
        -4173.23095703125,
        1057.777587890625
      ],
      [
        -3368.5,
        -4169.5,
        1057.7677001953125
      ],
      [
        -3325.052490234375,
        -4166.0009765625,
        1080.5999755859375
      ],
      [
        -3301.6640625,
        -4189.78173828125,
        1080.5999755859375
      ],
      [
        -3325.052490234375,
        -4166.0009765625,
        1080.5999755859375
      ],
      [
        -3348.229736328125,
        -4186.04443359375,
        1080.5999755859375
      ],
      [
        -3332.62451171875,
        -4201.787109375,
        1080.5999755859375
      ],
      [
        -3339.9560546875,
        -4209.37548828125,
        1080.5999755859375
      ],
      [
        -3296.76953125,
        -4194.7666015625,
        1080.5999755859375
      ],
      [
        -3301.6640625,
        -4189.78173828125,
        1080.5999755859375
      ],
      [
        -3339.9560546875,
        -4209.37548828125,
        1080.5999755859375
      ],
      [
        -3288.314453125,
        -4239.7685546875,
        1060.7547607421875
      ],
      [
        -3288.30078125,
        -4239.7685546875,
        1060.7181396484375
      ],
      [
        -3368.5,
        -4169.5,
        1057.696044921875
      ],
      [
        -3351.240234375,
        -4152.17041015625,
        1067.5
      ],
      [
        -3364.766357421875,
        -4173.23095703125,
        1057.706787109375
      ],
      [
        -3368.5,
        -4169.5,
        1057.6956787109375
      ],
      [
        -3339.879638671875,
        -4144.32568359375,
        1070.0885009765625
      ],
      [
        -3341.637939453125,
        -4142.5673828125,
        1070.0885009765625
      ],
      [
        -3339.879638671875,
        -4144.32568359375,
        1070.0885009765625
      ],
      [
        -3219.999755859375,
        -4235.3251953125,
        1052.623779296875
      ],
      [
        -3219.999755859375,
        -4239.7685546875,
        1058.8939208984375
      ],
      [
        -3421.02099609375,
        -4195.74755859375,
        1082.623779296875
      ],
      [
        -3376.999755859375,
        -4239.7685546875,
        1082.623779296875
      ],
      [
        -3297.279296875,
        -4239.7685546875,
        1082.623779296875
      ],
      [
        -3297.279296875,
        -4194.9736328125,
        1082.623779296875
      ],
      [
        -3370.07177734375,
        -4239.7685546875,
        1082.623779296875
      ],
      [
        -3342.94775390625,
        -4213.2197265625,
        1082.623779296875
      ],
      [
        -3310.627197265625,
        -4180.66845703125,
        1080.5999755859375
      ],
      [
        -3304.650390625,
        -4187.466796875,
        1082.623779296875
      ],
      [
        -3310.529541015625,
        -4181.48876953125,
        1082.623779296875
      ],
      [
        -3297.279296875,
        -4194.9736328125,
        1082.623779296875
      ],
      [
        -3304.650390625,
        -4187.466796875,
        1082.623779296875
      ],
      [
        -3325.08056640625,
        -4166.69384765625,
        1082.623779296875
      ],
      [
        -3347.4892578125,
        -4186.07275390625,
        1082.623779296875
      ],
      [
        -3325.08056640625,
        -4166.69384765625,
        1082.623779296875
      ],
      [
        -3331.906982421875,
        -4201.79248046875,
        1082.623779296875
      ],
      [
        -3342.94775390625,
        -4213.2197265625,
        1082.623779296875
      ],
      [
        -3219.999755859375,
        -4235.2646484375,
        1052.623779296875
      ],
      [
        -3219.999755859375,
        -4239.7685546875,
        1058.951904296875
      ],
      [
        -3186.496337890625,
        -4042.05517578125,
        1072.623779296875
      ],
      [
        -3234.283935546875,
        -4089.69140625,
        1072.623779296875
      ],
      [
        -3178.08203125,
        -4179.7685546875,
        1082.623779296875
      ],
      [
        -3178.08203125,
        -4239.7685546875,
        1082.623779296875
      ],
      [
        -3209.174560546875,
        -4179.7685546875,
        1082.623779296875
      ],
      [
        -3209.174560546875,
        -4239.7685546875,
        1082.623779296875
      ],
      [
        -3222.63623046875,
        -4179.7685546875,
        1063.9708251953125
      ],
      [
        -3209.174560546875,
        -4179.7685546875,
        1082.623779296875
      ],
      [
        -3211.91748046875,
        -4179.7685546875,
        1082.623779296875
      ],
      [
        -3180.824951171875,
        -4179.7685546875,
        1082.623779296875
      ],
      [
        -3178.08203125,
        -4179.7685546875,
        1082.623779296875
      ],
      [
        -3128.210693359375,
        -4060.0,
        1086.5999755859375
      ],
      [
        -3421.765625,
        -4195.0029296875,
        1086.5999755859375
      ],
      [
        -3376.999755859375,
        -4239.7685546875,
        1086.5999755859375
      ],
      [
        -3180.92333984375,
        -4179.7685546875,
        1086.5999755859375
      ],
      [
        -3180.92333984375,
        -4239.7685546875,
        1086.5999755859375
      ],
      [
        -3298.281005859375,
        -4239.7685546875,
        1086.5999755859375
      ],
      [
        -3298.281005859375,
        -4195.38037109375,
        1086.5999755859375
      ],
      [
        -3368.23291015625,
        -4239.7685546875,
        1086.5999755859375
      ],
      [
        -3348.82568359375,
        -4220.77294921875,
        1086.5999755859375
      ],
      [
        -3298.281005859375,
        -4195.38037109375,
        1086.5999755859375
      ],
      [
        -3310.33837890625,
        -4183.1015625,
        1086.5999755859375
      ],
      [
        -3310.343994140625,
        -4183.0537109375,
        1086.4820556640625
      ],
      [
        -3310.529541015625,
        -4181.48876953125,
        1082.623779296875
      ],
      [
        -3310.343994140625,
        -4183.0537109375,
        1086.482177734375
      ],
      [
        -3325.135498046875,
        -4168.0556640625,
        1086.5999755859375
      ],
      [
        -3346.0341796875,
        -4186.12890625,
        1086.5999755859375
      ],
      [
        -3330.4970703125,
        -4201.802734375,
        1086.5999755859375
      ],
      [
        -3348.82568359375,
        -4220.77294921875,
        1086.5999755859375
      ],
      [
        -3310.517822265625,
        -4182.9189453125,
        1086.5999755859375
      ],
      [
        -3311.417236328125,
        -4180.58642578125,
        1082.623779296875
      ],
      [
        -3310.517822265625,
        -4182.9189453125,
        1086.5999755859375
      ],
      [
        -3311.39208984375,
        -4182.02978515625,
        1086.5999755859375
      ],
      [
        -3325.135498046875,
        -4168.0556640625,
        1086.5999755859375
      ],
      [
        -3208.28515625,
        -4179.7685546875,
        1086.5999755859375
      ],
      [
        -3209.076171875,
        -4179.7685546875,
        1086.5999755859375
      ],
      [
        -3208.28515625,
        -4179.7685546875,
        1086.5999755859375
      ],
      [
        -3206.304931640625,
        -4179.7685546875,
        1086.5999755859375
      ],
      [
        -3181.71435546875,
        -4179.7685546875,
        1086.5999755859375
      ],
      [
        -3180.92333984375,
        -4179.7685546875,
        1086.5999755859375
      ],
      [
        -3181.71435546875,
        -4179.7685546875,
        1086.5999755859375
      ],
      [
        -3298.448486328125,
        -4239.7685546875,
        1087.26513671875
      ],
      [
        -3298.448486328125,
        -4195.4482421875,
        1087.26513671875
      ],
      [
        -3325.144775390625,
        -4168.28369140625,
        1087.26513671875
      ],
      [
        -3345.790771484375,
        -4186.13818359375,
        1087.26513671875
      ],
      [
        -3330.26123046875,
        -4201.8046875,
        1087.26513671875
      ],
      [
        -3349.80908203125,
        -4222.03662109375,
        1087.26513671875
      ],
      [
        -3298.448486328125,
        -4195.4482421875,
        1087.26513671875
      ],
      [
        -3311.38818359375,
        -4182.271484375,
        1087.26513671875
      ],
      [
        -3311.388427734375,
        -4182.244140625,
        1087.1900634765625
      ],
      [
        -3311.39208984375,
        -4182.02978515625,
        1086.5999755859375
      ],
      [
        -3311.388427734375,
        -4182.244140625,
        1087.1900634765625
      ],
      [
        -3367.92529296875,
        -4239.7685546875,
        1087.26513671875
      ],
      [
        -3349.80908203125,
        -4222.03662109375,
        1087.26513671875
      ],
      [
        -3311.499267578125,
        -4182.158203125,
        1087.26513671875
      ],
      [
        -3325.144775390625,
        -4168.28369140625,
        1087.26513671875
      ],
      [
        -3311.499267578125,
        -4182.158203125,
        1087.26513671875
      ],
      [
        -3311.33935546875,
        -4185.6708984375,
        1096.5999755859375
      ],
      [
        -3311.387939453125,
        -4182.271484375,
        1087.26513671875
      ],
      [
        -3699.999755859375,
        -4249.7685546875,
        1102.623779296875
      ],
      [
        -3744.02880859375,
        -4249.7685546875,
        1278.7403564453125
      ],
      [
        -3746.760498046875,
        -4249.7685546875,
        1278.740234375
      ],
      [
        -3754.28271484375,
        -4249.7685546875,
        1302.623779296875
      ],
      [
        -2920.0,
        -4942.994140625,
        1195.5255126953125
      ],
      [
        -2920.0,
        -4919.7685546875,
        1102.623779296875
      ],
      [
        -2920.0,
        -4942.994140625,
        1195.5255126953125
      ],
      [
        -2920.0,
        -4981.9541015625,
        1302.623779296875
      ],
      [
        -2749.999755859375,
        -4919.7685546875,
        1232.623779296875
      ],
      [
        -2839.999755859375,
        -4869.7685546875,
        1230.4019775390625
      ],
      [
        -2839.999755859375,
        -4718.13916015625,
        1230.4019775390625
      ],
      [
        -2839.999755859375,
        -4718.13916015625,
        1230.4019775390625
      ],
      [
        -2799.999755859375,
        -4719.2421875,
        1231.90625
      ],
      [
        -2920.0,
        -4856.3642578125,
        1227.393310546875
      ],
      [
        -2920.0,
        -4852.89501953125,
        1179.3675537109375
      ],
      [
        -2920.0,
        -4856.3642578125,
        1227.393310546875
      ],
      [
        -2920.0,
        -4857.9619140625,
        1255.3924560546875
      ],
      [
        -2264.67724609375,
        -4319.7685546875,
        1187.623779296875
      ],
      [
        -2260.266845703125,
        -4329.7685546875,
        1187.623779296875
      ],
      [
        -2260.266845703125,
        -4329.7685546875,
        1052.623779296875
      ],
      [
        -2264.67724609375,
        -4319.7685546875,
        1052.623779296875
      ],
      [
        -2224.77978515625,
        -4410.228515625,
        1187.623779296875
      ],
      [
        -2224.77978515625,
        -4410.228515625,
        1052.623779296875
      ],
      [
        -2280.849853515625,
        -4283.1005859375,
        1187.623779296875
      ],
      [
        -2280.849853515625,
        -4283.1005859375,
        1052.623779296875
      ],
      [
        -3699.999755859375,
        -4260.35546875,
        1102.623779296875
      ],
      [
        -3729.92431640625,
        -4249.7685546875,
        1222.32177734375
      ],
      [
        -3699.999755859375,
        -4260.80517578125,
        1102.623779296875
      ],
      [
        -3733.5146484375,
        -4249.7685546875,
        1236.6832275390625
      ],
      [
        -3699.999755859375,
        -4879.7685546875,
        1302.623779296875
      ],
      [
        -3339.772216796875,
        -4739.541015625,
        1181.713134765625
      ],
      [
        -3580.227294921875,
        -4739.541015625,
        1181.713134765625
      ],
      [
        -3319.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      [
        -3339.772216796875,
        -4739.541015625,
        1181.713134765625
      ],
      [
        -3196.425048828125,
        -4739.90283203125,
        1152.623779296875
      ],
      [
        -3198.6396484375,
        -4740.77392578125,
        1082.623779296875
      ],
      [
        -3347.17578125,
        -4746.9443359375,
        1211.3271484375
      ],
      [
        -3574.965576171875,
        -4744.802734375,
        1202.759765625
      ],
      [
        -3347.175537109375,
        -4946.9443359375,
        1211.3270263671875
      ],
      [
        -3347.17578125,
        -4746.9443359375,
        1211.3271484375
      ],
      [
        -3574.9658203125,
        -4854.802734375,
        1202.759765625
      ],
      [
        -3600.0,
        -4854.5673828125,
        1201.8182373046875
      ],
      [
        -3319.999755859375,
        -4947.19970703125,
        1212.34912109375
      ],
      [
        -3347.175537109375,
        -4946.9443359375,
        1211.3270263671875
      ],
      [
        -3169.794189453125,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3030.205322265625,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -2924.617919921875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -2970.626953125,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -2924.617919921875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -2920.0,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3229.37255859375,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3275.381591796875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3302.37060546875,
        -4919.7685546875,
        1102.623779296875
      ],
      [
        -3275.381591796875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3308.169189453125,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3229.37255859375,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3169.794189453125,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3030.205322265625,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -2970.626953125,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3270.07763671875,
        -4850.7685546875,
        1082.70166015625
      ],
      [
        -3319.999755859375,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3175.480712890625,
        -5044.55859375,
        1217.7845458984375
      ],
      [
        -3024.021728515625,
        -5045.98291015625,
        1223.48095703125
      ],
      [
        -3024.021728515625,
        -5045.98291015625,
        1223.48095703125
      ],
      [
        -2958.201416015625,
        -4994.4453125,
        1225.95654296875
      ],
      [
        -3240.002197265625,
        -4992.48828125,
        1215.35791015625
      ],
      [
        -3175.480712890625,
        -5044.55859375,
        1217.7845458984375
      ],
      [
        -3295.838623046875,
        -4947.42724609375,
        1213.2578125
      ],
      [
        -3290.547119140625,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3240.002197265625,
        -4992.48828125,
        1215.35791015625
      ],
      [
        -3281.96435546875,
        -4947.5576171875,
        1213.7796630859375
      ],
      [
        -3281.96435546875,
        -4947.5576171875,
        1213.7796630859375
      ],
      [
        -2920.0,
        -4954.5869140625,
        1227.393310546875
      ],
      [
        -2958.201416015625,
        -4994.4453125,
        1225.95654296875
      ],
      [
        -3255.81689453125,
        -4912.5498046875,
        1214.7630615234375
      ],
      [
        -3255.81689453125,
        -4854.98095703125,
        1214.7630615234375
      ],
      [
        -3292.71533203125,
        -4855.599609375,
        1213.3753662109375
      ],
      [
        -3302.565185546875,
        -4855.56982421875,
        1213.0048828125
      ],
      [
        -3255.81689453125,
        -4854.98095703125,
        1214.7630615234375
      ],
      [
        -3292.71533203125,
        -4855.599609375,
        1213.3753662109375
      ],
      [
        -3699.999755859375,
        -4853.626953125,
        1198.05712890625
      ],
      [
        -3303.63720703125,
        -4969.7685546875,
        1302.623779296875
      ],
      [
        -3295.838623046875,
        -4947.42724609375,
        1213.2578125
      ],
      [
        -3369.999755859375,
        -4917.0087890625,
        1302.623779296875
      ],
      [
        -3360.86962890625,
        -4912.603515625,
        1266.10302734375
      ],
      [
        -3347.175537109375,
        -4916.06201171875,
        1211.3270263671875
      ],
      [
        -3369.999755859375,
        -4910.2978515625,
        1302.623779296875
      ],
      [
        -2978.129638671875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -2959.9150390625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -2951.49462890625,
        -4860.02587890625,
        1302.6241455078125
      ],
      [
        -2959.9150390625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4906.7421875,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -2978.129638671875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -3005.45556640625,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3005.45556640625,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3351.867919921875,
        -4751.63671875,
        1230.0960693359375
      ],
      [
        -3566.1171875,
        -4753.6513671875,
        1238.15380859375
      ],
      [
        -3351.867919921875,
        -4751.63671875,
        1230.0960693359375
      ],
      [
        -3351.867919921875,
        -4914.876953125,
        1230.0960693359375
      ],
      [
        -3600.0,
        -4863.9697265625,
        1239.427978515625
      ],
      [
        -3600.0,
        -4854.5673828125,
        1201.8182373046875
      ],
      [
        -3566.1171875,
        -4863.6513671875,
        1238.15380859375
      ],
      [
        -3600.0,
        -4879.7685546875,
        1302.623779296875
      ],
      [
        -3240.08447265625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -3248.5048828125,
        -4860.02587890625,
        1302.6241455078125
      ],
      [
        -3221.869873046875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -3240.08447265625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4906.7421875,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3194.5439453125,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3221.869873046875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3194.5439453125,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -2182.125244140625,
        -4909.47314453125,
        1315.685546875
      ],
      [
        -2214.77978515625,
        -4910.2978515625,
        1302.623779296875
      ],
      [
        -1964.791748046875,
        -4903.9833984375,
        1402.623779296875
      ],
      [
        -2182.12548828125,
        -4909.47314453125,
        1315.685546875
      ],
      [
        -3556.986083984375,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3758.24658203125,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3488.941650390625,
        -4910.29736328125,
        1302.623779296875
      ],
      [
        -3556.986083984375,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3758.24658203125,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3939.26220703125,
        -4903.9833984375,
        1402.623779296875
      ],
      [
        -3802.58349609375,
        -4310.9921875,
        1302.623779296875
      ],
      [
        -3900.749755859375,
        -4266.263671875,
        1353.5482177734375
      ],
      [
        -3985.582763671875,
        -4213.58984375,
        1402.623779296875
      ],
      [
        -3900.749755859375,
        -4266.263671875,
        1353.5482177734375
      ],
      [
        -3888.191162109375,
        -4333.81396484375,
        1329.1610107421875
      ],
      [
        -4007.749267578125,
        -4244.5771484375,
        1402.623779296875
      ],
      [
        -3835.11669921875,
        -4356.12060546875,
        1302.623779296875
      ],
      [
        -3888.191162109375,
        -4333.81396484375,
        1329.1610107421875
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.26261258125305176,
        0.2626130282878876,
        0.9284766912460327
      ],
      "plane_d": -766.841552734375,
      "bbox_min": [
        -3442.946533203125,
        -4133.39013671875,
        1012.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -3890.92822265625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1032.623779296875,
      "bbox_min": [
        -3372.23583984375,
        -4133.39013671875,
        1032.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -3961.638916015625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4012.0,
      "bbox_min": [
        -2708.999755859375,
        -4012.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -2704.999755859375,
        -4012.0,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2862418591976166,
        0.2862347960472107,
        0.9144042730331421
      ],
      "plane_d": -717.708251953125,
      "bbox_min": [
        -3372.23583984375,
        -4133.39013671875,
        1032.623779296875
      ],
      "bbox_max": [
        -3234.2998046875,
        -4057.72998046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5285.8330078125,
      "bbox_min": [
        -3372.23583984375,
        -4133.39013671875,
        1032.623779296875
      ],
      "bbox_max": [
        -3244.19921875,
        -4067.62939453125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071094512939453,
        0.7071040868759155,
        -0.0
      ],
      "plane_d": 5192.830078125,
      "bbox_min": [
        -3276.144775390625,
        -4099.5751953125,
        1032.623779296875
      ],
      "bbox_max": [
        -3244.19921875,
        -4067.62939453125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4012.0,
      "bbox_min": [
        -2704.999755859375,
        -4035.83154296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2654.999755859375,
        -4012.0,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -416.77099609375,
      "bbox_min": [
        -3442.946533203125,
        -4133.39013671875,
        1012.623779296875
      ],
      "bbox_max": [
        -3271.119384765625,
        -3890.92822265625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 5285.8330078125,
      "bbox_min": [
        -3442.946533203125,
        -4133.39013671875,
        1012.623779296875
      ],
      "bbox_max": [
        -3271.119384765625,
        -4032.349609375,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071094512939453,
        0.7071040868759155,
        -0.0
      ],
      "plane_d": 5192.830078125,
      "bbox_min": [
        -3276.144775390625,
        -4072.65478515625,
        1049.781005859375
      ],
      "bbox_max": [
        -3271.119384765625,
        -4067.62939453125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000007748603821,
        -0.8660249710083008,
        1.395172148477286e-06
      ],
      "plane_d": -4776.0458984375,
      "bbox_min": [
        -2739.973876953125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2295.551025390625,
        -3984.21875,
        1226.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.743144154548645,
        -0.669131338596344,
        0.0
      ],
      "plane_d": -4530.474609375,
      "bbox_min": [
        -2369.712646484375,
        -4155.2939453125,
        1082.623779296875
      ],
      "bbox_max": [
        -2354.909423828125,
        -4138.85302734375,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253286361694,
        0.5000001192092896,
        0.0
      ],
      "plane_d": -232.342041015625,
      "bbox_min": [
        -2739.973876953125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2295.551025390625,
        -3990.27880859375,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660269379615784,
        0.49999743700027466,
        0.0
      ],
      "plane_d": -91.2567138671875,
      "bbox_min": [
        -2615.537109375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2295.551025390625,
        -4020.00439453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41408902406692505,
        0.9102364182472229,
        0.0
      ],
      "plane_d": 2879.88818359375,
      "bbox_min": [
        -2484.04052734375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2295.551025390625,
        -4119.99951171875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.976732075214386,
        0.21446312963962555,
        0.0
      ],
      "plane_d": -1380.2791748046875,
      "bbox_min": [
        -2346.291259765625,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2295.551025390625,
        -4215.14111328125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.914959728717804,
        -0.4035452604293823,
        -0.0
      ],
      "plane_d": -3815.310791015625,
      "bbox_min": [
        -2310.823486328125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2295.551025390625,
        -4215.14111328125,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162565469741821,
        -0.40059199929237366,
        -0.0
      ],
      "plane_d": -3926.45703125,
      "bbox_min": [
        -2484.04052734375,
        -4215.14111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4119.99951171875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000298619270325,
        -0.8660082817077637,
        0.0
      ],
      "plane_d": -4824.04541015625,
      "bbox_min": [
        -2474.586181640625,
        -4215.14111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.866020917892456,
        0.5000077486038208,
        0.0
      ],
      "plane_d": -17.19970703125,
      "bbox_min": [
        -2465.059814453125,
        -4215.14111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6790370345115662,
        0.7341040372848511,
        0.0
      ],
      "plane_d": 1525.21728515625,
      "bbox_min": [
        -2354.91015625,
        -4215.14111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4155.29296875,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.743144154548645,
        -0.669131338596344,
        0.0
      ],
      "plane_d": -4530.474609375,
      "bbox_min": [
        -2354.91015625,
        -4210.19482421875,
        1082.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4155.29296875,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000013709068298,
        -0.8660246729850769,
        -0.0
      ],
      "plane_d": -4812.044921875,
      "bbox_min": [
        -2465.059814453125,
        -4169.12353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -2420.954833984375,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44329512119293213,
        -0.7678069472312927,
        -0.46256038546562195
      ],
      "plane_d": -3709.5517578125,
      "bbox_min": [
        -2465.059814453125,
        -4169.12353515625,
        1203.623779296875
      ],
      "bbox_max": [
        -2420.954833984375,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8411673307418823,
        0.48564860224723816,
        0.237871915102005
      ],
      "plane_d": -476.0616455078125,
      "bbox_min": [
        -2615.537109375,
        -4072.557373046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2587.115966796875,
        -4020.00439453125,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1062.623779296875,
      "bbox_min": [
        -2615.537109375,
        -4072.557373046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2587.115966796875,
        -4020.00439453125,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000011920928955,
        -0.8660246729850769,
        2.6352649911132175e-06
      ],
      "plane_d": -4828.6474609375,
      "bbox_min": [
        -2615.537109375,
        -4072.557373046875,
        1062.623779296875
      ],
      "bbox_max": [
        -2594.329833984375,
        -4032.6484375,
        1121.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6123776435852051,
        0.35355043411254883,
        -0.7071037888526917
      ],
      "plane_d": 624.2259521484375,
      "bbox_min": [
        -2601.536865234375,
        -4042.5830078125,
        1112.623779296875
      ],
      "bbox_max": [
        -2594.329833984375,
        -4032.6484375,
        1115.17236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500004231929779,
        -0.8660230040550232,
        0.0
      ],
      "plane_d": -4790.6455078125,
      "bbox_min": [
        -2596.536865234375,
        -4033.922607421875,
        1112.623779296875
      ],
      "bbox_max": [
        -2594.329833984375,
        -4032.6484375,
        1115.1722412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000011920928955,
        0.8660247325897217,
        1.1467783224361483e-05
      ],
      "plane_d": 4828.6328125,
      "bbox_min": [
        -2615.537109375,
        -4066.781982421875,
        1052.623779296875
      ],
      "bbox_max": [
        -2613.416015625,
        -4065.557373046875,
        1062.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7492340207099915,
        0.4325691759586334,
        0.5015299916267395
      ],
      "plane_d": -780.37060546875,
      "bbox_min": [
        -2722.857421875,
        -4221.44189453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2589.23681640625,
        -3990.27880859375,
        1121.623779296875
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.5000011920928955,
        -0.8660246729850769,
        2.6352649911132175e-06
      ],
      "plane_d": -4828.6474609375,
      "bbox_min": [
        -2722.857421875,
        -4221.44189453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2589.23681640625,
        -3990.27880859375,
        1121.623779296875
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1121.623779296875,
      "bbox_min": [
        -2667.0234375,
        -4065.557373046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2589.23681640625,
        -3990.27880859375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1062.623779296875,
      "bbox_min": [
        -2667.0234375,
        -4065.557373046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2589.23681640625,
        -3990.27880859375,
        1117.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.4999936819076538,
        -0.8660290837287903,
        -0.0
      ],
      "plane_d": -4779.642578125,
      "bbox_min": [
        -2630.650390625,
        -4062.599609375,
        1062.623779296875
      ],
      "bbox_max": [
        -2596.536865234375,
        -4010.896484375,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -246.770751953125,
      "bbox_min": [
        -2630.650390625,
        -4062.599609375,
        1062.623779296875
      ],
      "bbox_max": [
        -2596.536865234375,
        -4015.896484375,
        1117.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660261034965515,
        0.4999989867210388,
        0.0
      ],
      "plane_d": -234.800048828125,
      "bbox_min": [
        -2628.05224609375,
        -4062.599609375,
        1101.623779296875
      ],
      "bbox_max": [
        -2596.536865234375,
        -4025.422607421875,
        1117.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6123776435852051,
        0.35355043411254883,
        -0.7071037888526917
      ],
      "plane_d": 624.2259521484375,
      "bbox_min": [
        -2603.659912109375,
        -4041.30859375,
        1112.623779296875
      ],
      "bbox_max": [
        -2596.536865234375,
        -4031.422607421875,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500004231929779,
        -0.8660230040550232,
        0.0
      ],
      "plane_d": -4790.6455078125,
      "bbox_min": [
        -2598.659912109375,
        -4032.6484375,
        1112.623779296875
      ],
      "bbox_max": [
        -2596.536865234375,
        -4031.422607421875,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -2628.05224609375,
        -4062.599609375,
        1101.623779296875
      ],
      "bbox_max": [
        -2598.659912109375,
        -4025.422607421875,
        1117.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1117.623779296875,
      "bbox_min": [
        -2628.05224609375,
        -4062.599609375,
        1101.623779296875
      ],
      "bbox_max": [
        -2598.659912109375,
        -4025.422607421875,
        1117.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": -239.6529541015625,
      "bbox_min": [
        -2628.05224609375,
        -4061.83154296875,
        1101.623779296875
      ],
      "bbox_max": [
        -2620.990234375,
        -4056.599609375,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2628.05224609375,
        -4061.83154296875,
        1112.623779296875
      ],
      "bbox_max": [
        -2620.990234375,
        -4056.599609375,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1117.623779296875,
      "bbox_min": [
        -2630.650390625,
        -4058.33154296875,
        1101.623779296875
      ],
      "bbox_max": [
        -2619.05224609375,
        -4041.2431640625,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 249.77099609375,
      "bbox_min": [
        -2630.650390625,
        -4058.33154296875,
        1101.623779296875
      ],
      "bbox_max": [
        -2619.05224609375,
        -4041.2431640625,
        1117.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.2589518129825592,
        -0.9658902883529663,
        0.0
      ],
      "plane_d": -3231.58642578125,
      "bbox_min": [
        -2629.516357421875,
        -4054.2333984375,
        1101.623779296875
      ],
      "bbox_max": [
        -2626.650390625,
        -4049.9033203125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6124150156974792,
        -0.3536019027233124,
        -0.7070456743240356
      ],
      "plane_d": 963.2224731445312,
      "bbox_min": [
        -2629.516357421875,
        -4054.2333984375,
        1111.623779296875
      ],
      "bbox_max": [
        -2626.650390625,
        -4049.9033203125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999901354312897,
        -0.8660311102867126,
        0.0
      ],
      "plane_d": -4810.6416015625,
      "bbox_min": [
        -2630.650390625,
        -4058.33154296875,
        1101.623779296875
      ],
      "bbox_max": [
        -2619.05224609375,
        -4041.2431640625,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -2630.650390625,
        -4058.33154296875,
        1101.623779296875
      ],
      "bbox_max": [
        -2619.05224609375,
        -4041.2431640625,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2587907314300537,
        -0.9659333825111389,
        0.0
      ],
      "plane_d": -3232.18408203125,
      "bbox_min": [
        -2630.650390625,
        -4058.33154296875,
        1101.623779296875
      ],
      "bbox_max": [
        -2623.784423828125,
        -4046.939453125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": 248.6531982421875,
      "bbox_min": [
        -2625.284423828125,
        -4049.537353515625,
        1102.623779296875
      ],
      "bbox_max": [
        -2623.784423828125,
        -4046.939453125,
        1111.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2630.650390625,
        -4058.33154296875,
        1112.623779296875
      ],
      "bbox_max": [
        -2627.052490234375,
        -4055.099609375,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.753229558467865,
        0.42559191584587097,
        0.5015146136283875
      ],
      "plane_d": -818.7469482421875,
      "bbox_min": [
        -2667.0234375,
        -4046.169921875,
        1052.623779296875
      ],
      "bbox_max": [
        -2603.55224609375,
        -3990.27880859375,
        1062.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660253286361694,
        0.5000002384185791,
        0.0
      ],
      "plane_d": -246.79296875,
      "bbox_min": [
        -2619.05224609375,
        -4046.169921875,
        1052.623779296875
      ],
      "bbox_max": [
        -2603.55224609375,
        -4007.803466796875,
        1062.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5088441371917725,
        -0.860858678817749,
        -0.0
      ],
      "plane_d": -4812.919921875,
      "bbox_min": [
        -2619.05224609375,
        -4046.169921875,
        1052.623779296875
      ],
      "bbox_max": [
        -2613.2548828125,
        -4042.7431640625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999936819076538,
        -0.8660290837287903,
        -0.0
      ],
      "plane_d": -4779.642578125,
      "bbox_min": [
        -2612.212646484375,
        -4015.896484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2603.55224609375,
        -4007.803466796875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8578631281852722,
        0.5138782262802124,
        0.0
      ],
      "plane_d": -179.80859375,
      "bbox_min": [
        -2612.212646484375,
        -4010.896484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2610.35986328125,
        -4007.803466796875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5006539225578308,
        0.865647554397583,
        -0.0
      ],
      "plane_d": 4809.3369140625,
      "bbox_min": [
        -2645.994140625,
        -4037.7431640625,
        1052.623779296875
      ],
      "bbox_max": [
        -2619.958740234375,
        -4021.54638671875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5006539225578308,
        -0.865647554397583,
        -0.0
      ],
      "plane_d": -4810.8369140625,
      "bbox_min": [
        -2645.994140625,
        -4037.7431640625,
        1052.623779296875
      ],
      "bbox_max": [
        -2627.712646484375,
        -4025.871337890625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8656676411628723,
        0.5006192326545715,
        0.0
      ],
      "plane_d": -274.4727783203125,
      "bbox_min": [
        -2645.994140625,
        -4027.169921875,
        1052.623779296875
      ],
      "bbox_max": [
        -2645.2431640625,
        -4025.871337890625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1055.423828125,
      "bbox_min": [
        -2635.0615234375,
        -4036.4208984375,
        1052.623779296875
      ],
      "bbox_max": [
        -2619.958740234375,
        -4021.54638671875,
        1055.423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660413026809692,
        0.49997252225875854,
        0.0
      ],
      "plane_d": -262.4549560546875,
      "bbox_min": [
        -2635.0615234375,
        -4033.671630859375,
        1052.623779296875
      ],
      "bbox_max": [
        -2619.958740234375,
        -4021.54638671875,
        1055.423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999966025352478,
        0.8660274744033813,
        0.0
      ],
      "plane_d": 4795.12158203125,
      "bbox_min": [
        -2624.721923828125,
        -4024.29638671875,
        1052.623779296875
      ],
      "bbox_max": [
        -2619.958740234375,
        -4021.54638671875,
        1055.423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1054.163818359375,
      "bbox_min": [
        -2635.0615234375,
        -4033.670166015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2630.21484375,
        -4029.12548828125,
        1054.163818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000060796737671,
        0.866021990776062,
        0.0
      ],
      "plane_d": 4806.10205078125,
      "bbox_min": [
        -2635.0615234375,
        -4031.7451171875,
        1052.623779296875
      ],
      "bbox_max": [
        -2630.21484375,
        -4029.12548828125,
        1054.163818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660243153572083,
        0.5000019073486328,
        0.0
      ],
      "plane_d": -266.1470947265625,
      "bbox_min": [
        -2635.0615234375,
        -4031.7451171875,
        1052.623779296875
      ],
      "bbox_max": [
        -2633.549072265625,
        -4029.12548828125,
        1054.163818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7604115605354309,
        -0.44979920983314514,
        -0.4684601128101349
      ],
      "plane_d": 705.8880615234375,
      "bbox_min": [
        -2667.0234375,
        -4035.83154296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2635.703125,
        -3993.17724609375,
        1062.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4012.0,
      "bbox_min": [
        -2659.03759765625,
        -4022.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2649.91748046875,
        -4012.0,
        1057.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4021.999755859375,
      "bbox_min": [
        -2658.9130859375,
        -4022.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.690673828125,
        -4022.0,
        1057.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.8660260438919067,
        -0.0
      ],
      "plane_d": 4947.8427734375,
      "bbox_min": [
        -2722.857421875,
        -4221.44189453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2621.124267578125,
        -4056.33154296875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999895691871643,
        -0.8660260438919067,
        0.0
      ],
      "plane_d": -5008.64453125,
      "bbox_min": [
        -2722.857421875,
        -4221.44189453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2705.536865234375,
        -4211.44189453125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660219311714172,
        -0.5000061392784119,
        0.0
      ],
      "plane_d": 238.760498046875,
      "bbox_min": [
        -2637.016357421875,
        -4074.06591796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2621.124267578125,
        -4056.33154296875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -239.7708740234375,
      "bbox_min": [
        -2637.016357421875,
        -4071.857666015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2621.990234375,
        -4056.33154296875,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000077486038208,
        -0.866020917892456,
        -0.0
      ],
      "plane_d": -4839.646484375,
      "bbox_min": [
        -2627.490234375,
        -4071.857666015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2626.624267578125,
        -4071.357666015625,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000077486038208,
        -0.866020917892456,
        -0.0
      ],
      "plane_d": -4839.646484375,
      "bbox_min": [
        -2637.016357421875,
        -4071.357666015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2626.990234375,
        -4056.33154296875,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.500004231929779,
        0.8660230040550232,
        -0.0
      ],
      "plane_d": 4838.6455078125,
      "bbox_min": [
        -2636.150390625,
        -4071.357666015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2626.990234375,
        -4056.83154296875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": 249.652587890625,
      "bbox_min": [
        -2636.150390625,
        -4066.357666015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2635.650390625,
        -4065.49169921875,
        1057.7200927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 249.7708740234375,
      "bbox_min": [
        -2635.650390625,
        -4065.49169921875,
        1052.623779296875
      ],
      "bbox_max": [
        -2630.650390625,
        -4056.83154296875,
        1057.7200927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999901354312897,
        0.8660311102867126,
        0.0
      ],
      "plane_d": 4837.798828125,
      "bbox_min": [
        -2625.71240234375,
        -4074.06591796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2622.1142578125,
        -4070.833984375,
        1059.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": -237.5089111328125,
      "bbox_min": [
        -2625.71240234375,
        -4074.06591796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2622.1142578125,
        -4070.833984375,
        1059.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": 234.5089111328125,
      "bbox_min": [
        -2625.71240234375,
        -4074.06591796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2622.1142578125,
        -4070.833984375,
        1059.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999901354312897,
        -0.8660311102867126,
        0.0
      ],
      "plane_d": -4839.798828125,
      "bbox_min": [
        -2625.71240234375,
        -4074.06591796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2622.1142578125,
        -4070.833984375,
        1059.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39631029963493347,
        -0.6864476203918457,
        0.6096949577331543
      ],
      "plane_d": -4480.40380859375,
      "bbox_min": [
        -2625.71240234375,
        -4074.06591796875,
        1056.5999755859375
      ],
      "bbox_max": [
        -2622.1142578125,
        -4070.833984375,
        1059.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660219311714172,
        -0.5000061392784119,
        0.0
      ],
      "plane_d": 238.760498046875,
      "bbox_min": [
        -2629.69677734375,
        -4071.857666015625,
        1072.623779296875
      ],
      "bbox_max": [
        -2621.124267578125,
        -4061.83154296875,
        1079.7197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -239.7708740234375,
      "bbox_min": [
        -2629.69677734375,
        -4071.857666015625,
        1072.623779296875
      ],
      "bbox_max": [
        -2621.990234375,
        -4061.83154296875,
        1079.719482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000077486038208,
        -0.866020917892456,
        -0.0
      ],
      "plane_d": -4839.646484375,
      "bbox_min": [
        -2627.490234375,
        -4071.857666015625,
        1072.623779296875
      ],
      "bbox_max": [
        -2626.624267578125,
        -4071.357666015625,
        1079.719482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500004231929779,
        0.8660230040550232,
        -0.0
      ],
      "plane_d": 4838.6455078125,
      "bbox_min": [
        -2629.19677734375,
        -4070.49169921875,
        1072.623779296875
      ],
      "bbox_max": [
        -2626.990234375,
        -4069.2177734375,
        1077.7196044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660218715667725,
        0.5000061392784119,
        0.0
      ],
      "plane_d": -250.7601318359375,
      "bbox_min": [
        -2688.893310546875,
        -4107.025390625,
        1052.623779296875
      ],
      "bbox_max": [
        -2621.124267578125,
        -4040.179443359375,
        1113.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 249.7708740234375,
      "bbox_min": [
        -2637.016357421875,
        -4071.857666015625,
        1055.72021484375
      ],
      "bbox_max": [
        -2621.124267578125,
        -4056.33154296875,
        1113.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000077486038208,
        -0.866020917892456,
        -0.0
      ],
      "plane_d": -4839.646484375,
      "bbox_min": [
        -2637.016357421875,
        -4066.357666015625,
        1055.72021484375
      ],
      "bbox_max": [
        -2630.650634765625,
        -4056.33154296875,
        1113.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1113.623779296875,
      "bbox_min": [
        -2637.016357421875,
        -4066.357666015625,
        1113.623779296875
      ],
      "bbox_max": [
        -2630.650634765625,
        -4056.33154296875,
        1113.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000077486038208,
        -0.866020917892456,
        -0.0
      ],
      "plane_d": -4839.646484375,
      "bbox_min": [
        -2636.150390625,
        -4071.857666015625,
        1062.623779296875
      ],
      "bbox_max": [
        -2621.124267578125,
        -4056.83154296875,
        1113.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660219311714172,
        -0.5000061392784119,
        0.0
      ],
      "plane_d": 238.760498046875,
      "bbox_min": [
        -2636.150390625,
        -4071.857666015625,
        1062.623779296875
      ],
      "bbox_max": [
        -2626.124267578125,
        -4065.49169921875,
        1113.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1113.623779296875,
      "bbox_min": [
        -2636.150390625,
        -4071.857666015625,
        1062.623779296875
      ],
      "bbox_max": [
        -2626.124267578125,
        -4065.49169921875,
        1113.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1062.623779296875,
      "bbox_min": [
        -2636.150390625,
        -4067.58349609375,
        1062.623779296875
      ],
      "bbox_max": [
        -2633.527099609375,
        -4065.49169921875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -239.7708740234375,
      "bbox_min": [
        -2635.650390625,
        -4070.99169921875,
        1077.719482421875
      ],
      "bbox_max": [
        -2621.124267578125,
        -4056.83154296875,
        1113.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660219311714172,
        -0.5000061392784119,
        0.0
      ],
      "plane_d": 238.760498046875,
      "bbox_min": [
        -2626.990234375,
        -4070.99169921875,
        1079.719482421875
      ],
      "bbox_max": [
        -2621.124267578125,
        -4061.83154296875,
        1113.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2635.650390625,
        -4070.49169921875,
        1112.623779296875
      ],
      "bbox_max": [
        -2621.990234375,
        -4056.83154296875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2688.893310546875,
        -4107.025390625,
        1052.623779296875
      ],
      "bbox_max": [
        -2636.712646484375,
        -4040.179443359375,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.86602783203125,
        -0.4999958872795105,
        0.0
      ],
      "plane_d": 256.8175048828125,
      "bbox_min": [
        -2688.893310546875,
        -4107.025390625,
        1052.623779296875
      ],
      "bbox_max": [
        -2636.712646484375,
        -4053.33154296875,
        1067.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.30000096559524536,
        -0.519611120223999,
        0.8000024557113647
      ],
      "plane_d": -3776.47412109375,
      "bbox_min": [
        -2688.893310546875,
        -4107.025390625,
        1052.623779296875
      ],
      "bbox_max": [
        -2657.71240234375,
        -4075.498291015625,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8772926926612854,
        0.0999821349978447,
        0.4694262742996216
      ],
      "plane_d": -2445.1650390625,
      "bbox_min": [
        -2685.8232421875,
        -4085.78515625,
        1059.6280517578125
      ],
      "bbox_max": [
        -2680.49267578125,
        -4075.498291015625,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1057.6236572265625,
      "bbox_min": [
        -2664.091552734375,
        -4022.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2649.91748046875,
        -4012.0,
        1057.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4021.999755859375,
      "bbox_min": [
        -2664.091552734375,
        -4022.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.690673828125,
        -4022.0,
        1057.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        7.751265229671844e-07,
        0.0
      ],
      "plane_d": -3046.496826171875,
      "bbox_min": [
        -3549.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4130.7685546875,
      "bbox_min": [
        -3046.499755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4124.7685546875,
      "bbox_min": [
        -3046.499755859375,
        -4130.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3015.999755859375,
      "bbox_min": [
        -3041.499755859375,
        -4130.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2704.999755859375,
        -4124.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2704.999755859375,
      "bbox_min": [
        -2704.999755859375,
        -4130.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2704.999755859375,
        -4124.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3041.499755859375,
      "bbox_min": [
        -3041.499755859375,
        -4130.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3041.499755859375,
        -4124.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3974.7685546875,
      "bbox_min": [
        -3046.499755859375,
        -4124.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1057.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3979.7685546875,
      "bbox_min": [
        -3046.499755859375,
        -4124.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3974.7685546875,
        1057.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.8660255670547485,
        -0.0
      ],
      "plane_d": -4776.044921875,
      "bbox_min": [
        -3046.499755859375,
        -3979.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2658.927490234375,
        -3974.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3015.999755859375,
      "bbox_min": [
        -3046.499755859375,
        -3979.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2704.999755859375,
        -3974.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2819.999755859375,
      "bbox_min": [
        -2824.999755859375,
        -3979.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2704.999755859375,
        -3974.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2704.999755859375,
      "bbox_min": [
        -2704.999755859375,
        -3979.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2704.999755859375,
        -3974.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -9.765625145519152e-05,
        0.0
      ],
      "plane_d": 2824.611572265625,
      "bbox_min": [
        -2824.999755859375,
        -3979.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2824.999755859375,
        -3974.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3974.800048828125,
      "bbox_min": [
        -3046.499755859375,
        -3979.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3041.499755859375,
        -3974.800048828125,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3041.499755859375,
      "bbox_min": [
        -3041.499755859375,
        -3979.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3041.499755859375,
        -3974.800048828125,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3009.999755859375,
      "bbox_min": [
        -3034.999755859375,
        -4124.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3979.7685546875,
        1057.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3015.999755859375,
      "bbox_min": [
        -3034.999755859375,
        -4124.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3009.999755859375,
        -3979.7685546875,
        1057.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4008.7685546875,
      "bbox_min": [
        -3015.999755859375,
        -4017.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3009.999755859375,
        -4008.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4017.2685546875,
      "bbox_min": [
        -3015.999755859375,
        -4017.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3009.999755859375,
        -4017.2685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3021.999755859375,
      "bbox_min": [
        -3034.999755859375,
        -4091.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3015.99951171875,
        -3987.7685546875,
        1057.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3034.999755859375,
      "bbox_min": [
        -3034.999755859375,
        -4091.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3021.999755859375,
        -3987.7685546875,
        1057.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": -4020.768310546875,
      "bbox_min": [
        -3034.999755859375,
        -4091.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3021.999755859375,
        -3987.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3987.7685546875,
      "bbox_min": [
        -3034.999755859375,
        -3987.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3021.999755859375,
        -3987.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": -4091.268310546875,
      "bbox_min": [
        -3034.999755859375,
        -4091.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3021.999755859375,
        -4058.2685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4058.2685546875,
      "bbox_min": [
        -3034.999755859375,
        -4058.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3021.999755859375,
        -4058.2685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1057.199951171875,
      "bbox_min": [
        -3016.599609375,
        -4017.2685546875,
        1057.199951171875
      ],
      "bbox_max": [
        -3015.99951171875,
        -4008.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3016.599609375,
      "bbox_min": [
        -3016.599609375,
        -4017.2685546875,
        1057.199951171875
      ],
      "bbox_max": [
        -3015.99951171875,
        -4008.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4017.2685546875,
      "bbox_min": [
        -3016.599609375,
        -4017.2685546875,
        1057.199951171875
      ],
      "bbox_max": [
        -3015.99951171875,
        -4008.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4008.7685546875,
      "bbox_min": [
        -3016.599609375,
        -4008.7685546875,
        1057.199951171875
      ],
      "bbox_max": [
        -3015.99951171875,
        -4008.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4021.999755859375,
      "bbox_min": [
        -2709.0,
        -4022.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2704.999755859375,
        -4012.0,
        1057.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4021.999755859375,
      "bbox_min": [
        -2704.999755859375,
        -4094.796630859375,
        1052.623779296875
      ],
      "bbox_max": [
        -2664.091552734375,
        -4022.0,
        1057.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.749237060546875,
        0.43256744742393494,
        0.5015268921852112
      ],
      "plane_d": -780.3825073242188,
      "bbox_min": [
        -2690.492919921875,
        -4094.796630859375,
        1052.623779296875
      ],
      "bbox_max": [
        -2671.367431640625,
        -4043.355712890625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30000096559524536,
        -0.519611120223999,
        0.8000024557113647
      ],
      "plane_d": -3776.47412109375,
      "bbox_min": [
        -2690.492919921875,
        -4094.796630859375,
        1052.623779296875
      ],
      "bbox_max": [
        -2686.712158203125,
        -4088.126953125,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.8660255670547485,
        -0.0
      ],
      "plane_d": -4776.044921875,
      "bbox_min": [
        -2658.927490234375,
        -3984.21875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3979.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4046.4384765625,
      "bbox_min": [
        -2999.999755859375,
        -4086.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -3994.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4077.4384765625,
      "bbox_min": [
        -2999.999755859375,
        -4086.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4046.4384765625,
        1057.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -371.8382568359375,
      "bbox_min": [
        -2943.999755859375,
        -4086.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4077.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4086.0986328125,
      "bbox_min": [
        -2785.999755859375,
        -4086.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4077.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4453.6416015625,
      "bbox_min": [
        -2785.999755859375,
        -4086.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4077.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4444.9814453125,
      "bbox_min": [
        -2778.499755859375,
        -4086.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4077.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 363.177978515625,
      "bbox_min": [
        -2778.499755859375,
        -4086.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4081.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4086.0986328125,
      "bbox_min": [
        -2943.999755859375,
        -4086.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2933.999755859375,
        -4077.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -508.669921875,
      "bbox_min": [
        -2943.999755859375,
        -4086.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2933.999755859375,
        -4077.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -4590.47314453125,
      "bbox_min": [
        -2943.999755859375,
        -4086.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2933.999755859375,
        -4077.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        -0.0
      ],
      "plane_d": 4581.81298828125,
      "bbox_min": [
        -2936.499755859375,
        -4086.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2933.999755859375,
        -4077.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 500.009765625,
      "bbox_min": [
        -2936.499755859375,
        -4086.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2933.999755859375,
        -4081.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -451.857177734375,
      "bbox_min": [
        -2999.999755859375,
        -4055.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2850.499755859375,
        -4046.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4055.0986328125,
      "bbox_min": [
        -2860.499755859375,
        -4055.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2850.499755859375,
        -4046.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -4502.66015625,
      "bbox_min": [
        -2860.499755859375,
        -4055.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2850.499755859375,
        -4046.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        -0.0
      ],
      "plane_d": 4494.0,
      "bbox_min": [
        -2852.999755859375,
        -4055.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2850.499755859375,
        -4046.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 443.197021484375,
      "bbox_min": [
        -2852.999755859375,
        -4055.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2850.499755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4049.902587890625,
      "bbox_min": [
        -2999.999755859375,
        -4051.634521484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2997.999755859375,
        -4049.902587890625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4051.634521484375,
      "bbox_min": [
        -2999.999755859375,
        -4051.634521484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2997.999755859375,
        -4049.902587890625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": 4621.787109375,
      "bbox_min": [
        -2999.999755859375,
        -4051.634521484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2997.999755859375,
        -4049.902587890625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        0.5000253915786743,
        0.0
      ],
      "plane_d": -572.5450439453125,
      "bbox_min": [
        -2999.999755859375,
        -4051.634521484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2997.999755859375,
        -4049.902587890625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        -0.5000253915786743,
        -0.0
      ],
      "plane_d": -4623.51953125,
      "bbox_min": [
        -2999.999755859375,
        -4051.634521484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2997.999755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107851028442,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": 570.81298828125,
      "bbox_min": [
        -2998.499755859375,
        -4051.634521484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2997.999755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4015.4384765625,
      "bbox_min": [
        -2943.999755859375,
        -4024.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -3994.4384765625,
        1057.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -4422.64111328125,
      "bbox_min": [
        -2943.999755859375,
        -4024.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4015.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4024.0986328125,
      "bbox_min": [
        -2785.999755859375,
        -4024.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4015.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -402.8387451171875,
      "bbox_min": [
        -2785.999755859375,
        -4024.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4015.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 394.1783447265625,
      "bbox_min": [
        -2778.499755859375,
        -4024.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4015.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        -0.0
      ],
      "plane_d": 4413.98095703125,
      "bbox_min": [
        -2778.499755859375,
        -4019.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4015.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4024.0986328125,
      "bbox_min": [
        -2943.999755859375,
        -4024.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2933.999755859375,
        -4015.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4559.47265625,
      "bbox_min": [
        -2943.999755859375,
        -4024.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2933.999755859375,
        -4015.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -539.6702880859375,
      "bbox_min": [
        -2943.999755859375,
        -4024.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2933.999755859375,
        -4015.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 531.010009765625,
      "bbox_min": [
        -2936.499755859375,
        -4024.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2933.999755859375,
        -4015.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4550.8125,
      "bbox_min": [
        -2936.499755859375,
        -4019.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2933.999755859375,
        -4015.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4003.0986328125,
      "bbox_min": [
        -2859.499755859375,
        -4003.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2849.499755859375,
        -3994.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3994.4384765625,
      "bbox_min": [
        -2859.499755859375,
        -4003.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2849.499755859375,
        -3994.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -476.991455078125,
      "bbox_min": [
        -2859.499755859375,
        -4003.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2849.499755859375,
        -3994.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4475.7939453125,
      "bbox_min": [
        -2859.499755859375,
        -4003.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2849.499755859375,
        -3994.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4467.1337890625,
      "bbox_min": [
        -2851.999755859375,
        -4003.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2849.499755859375,
        -3994.4384765625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 468.3311767578125,
      "bbox_min": [
        -2851.999755859375,
        -4003.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2849.499755859375,
        -3998.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10802125930786133,
        -0.9941485524177551,
        0.0
      ],
      "plane_d": -3575.284423828125,
      "bbox_min": [
        -3046.499755859375,
        -3974.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2667.587646484375,
        -3898.5556640625,
        1057.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        -0.0
      ],
      "plane_d": -4404.92236328125,
      "bbox_min": [
        -2846.031494140625,
        -3902.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2829.04638671875,
        -3898.5556640625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2998.0,
      "bbox_min": [
        -2998.0,
        -3922.08203125,
        1052.623779296875
      ],
      "bbox_max": [
        -2823.678955078125,
        -3902.0,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        -0.0
      ],
      "plane_d": -4404.92236328125,
      "bbox_min": [
        -2846.860595703125,
        -3905.65966796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2823.678955078125,
        -3902.0,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9752788543701172,
        -0.22097784280776978,
        0.0
      ],
      "plane_d": 1913.418701171875,
      "bbox_min": [
        -2846.860595703125,
        -3905.65966796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2846.031494140625,
        -3902.0,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        -0.0
      ],
      "plane_d": -4404.92236328125,
      "bbox_min": [
        -2772.989501953125,
        -3925.654541015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2751.3486328125,
        -3913.915283203125,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9836496710777283,
        0.18009302020072937,
        0.0
      ],
      "plane_d": -2000.666015625,
      "bbox_min": [
        -2752.65576171875,
        -3925.654541015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2751.3486328125,
        -3918.51513671875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        -0.0
      ],
      "plane_d": -4404.92236328125,
      "bbox_min": [
        -2824.999755859375,
        -3974.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2772.989501953125,
        -3903.140869140625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3969.7685546875,
      "bbox_min": [
        -2824.999755859375,
        -3974.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2818.830078125,
        -3927.5546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2824.999755859375,
      "bbox_min": [
        -2824.999755859375,
        -3974.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2819.999755859375,
        -3969.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2819.999755859375,
      "bbox_min": [
        -2819.999755859375,
        -3974.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2819.999755859375,
        -3969.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.939699649810791,
        -0.3420009911060333,
        0.0
      ],
      "plane_d": 1305.6259765625,
      "bbox_min": [
        -2819.999755859375,
        -3930.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2818.830078125,
        -3927.5546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4247.66796875,
      "bbox_min": [
        -3046.499755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2739.973876953125,
        -4130.7685546875,
        1057.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3041.499755859375,
      "bbox_min": [
        -3041.499755859375,
        -4247.66796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2739.973876953125,
        -4130.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1121.623779296875,
      "bbox_min": [
        -3046.499755859375,
        -4249.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3041.499755859375,
        -3926.80859375,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3974.800048828125,
      "bbox_min": [
        -3046.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3041.499755859375,
        -3926.80859375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4247.66796875,
      "bbox_min": [
        -3046.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3041.499755859375,
        -4247.66796875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10802071541547775,
        -0.9941487312316895,
        0.0
      ],
      "plane_d": -3575.28662109375,
      "bbox_min": [
        -3046.499755859375,
        -3927.351806640625,
        1057.5999755859375
      ],
      "bbox_max": [
        -3041.499755859375,
        -3926.80859375,
        1121.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.10802071541547775,
        -0.9941487312316895,
        0.0
      ],
      "plane_d": -3575.28662109375,
      "bbox_min": [
        -3046.499755859375,
        -4247.66796875,
        1121.623779296875
      ],
      "bbox_max": [
        -3041.499755859375,
        -3926.80859375,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4247.66796875,
      "bbox_min": [
        -3046.499755859375,
        -4247.66796875,
        1121.623779296875
      ],
      "bbox_max": [
        -3041.499755859375,
        -4247.66796875,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4247.66796875,
      "bbox_min": [
        -3041.499755859375,
        -4249.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2910.0,
      "bbox_min": [
        -2910.0,
        -4249.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2894.0,
        -4247.66796875,
        1064.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2894.0,
      "bbox_min": [
        -2894.0,
        -4249.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2894.0,
        -4247.66796875,
        1064.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10802071541547775,
        -0.9941487312316895,
        0.0
      ],
      "plane_d": -3575.28662109375,
      "bbox_min": [
        -3041.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9752788543701172,
        -0.22097784280776978,
        0.0
      ],
      "plane_d": 1913.418701171875,
      "bbox_min": [
        -3026.0,
        -3925.124267578125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2845.2509765625,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1067.6236572265625,
      "bbox_min": [
        -3026.0,
        -3925.124267578125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2998.0,
        -3902.0,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3902.0,
      "bbox_min": [
        -3026.0,
        -3925.124267578125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2998.0,
        -3902.0,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3026.0,
      "bbox_min": [
        -3026.0,
        -3925.124267578125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2998.0,
        -3902.0,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2998.0,
      "bbox_min": [
        -2998.0,
        -3922.08203125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2998.0,
        -3902.0,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.8660255670547485,
        0.0
      ],
      "plane_d": -4776.044921875,
      "bbox_min": [
        -3034.999755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2651.219482421875,
        -3903.140869140625,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9836496710777283,
        0.18009302020072937,
        0.0
      ],
      "plane_d": -2000.666015625,
      "bbox_min": [
        -2752.65576171875,
        -3925.654541015625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2751.3486328125,
        -3918.51513671875,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4050.7685546875,
      "bbox_min": [
        -3034.999755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2660.6845703125,
        -3903.140869140625,
        1185.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        0.0
      ],
      "plane_d": -4404.921875,
      "bbox_min": [
        -3034.999755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2660.6845703125,
        -3903.140869140625,
        1185.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3003.1396484375,
      "bbox_min": [
        -3034.999755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2660.6845703125,
        -3969.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2716.85986328125,
      "bbox_min": [
        -3003.1396484375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2660.6845703125,
        -3969.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2994.94970703125,
      "bbox_min": [
        -3003.1396484375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2716.85986328125,
        -3969.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4046.718505859375,
      "bbox_min": [
        -3003.1396484375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2994.94970703125,
        -4039.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -3003.1396484375,
        -4050.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4046.718505859375,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4534572660923004,
        -0.8912780284881592,
        0.0
      ],
      "plane_d": -2250.0205078125,
      "bbox_min": [
        -2995.999755859375,
        -4048.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2994.94970703125,
        -4048.234375,
        1137.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -3003.1396484375,
        -4050.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4046.718505859375,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -3003.1396484375,
        -4050.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4046.718505859375,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4797437787055969,
        -0.8774086833000183
      ],
      "plane_d": 2905.50537109375,
      "bbox_min": [
        -3003.1396484375,
        -4046.718505859375,
        1078.82373046875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4039.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4042.89697265625,
      "bbox_min": [
        -3003.1396484375,
        -4046.718505859375,
        1102.623779296875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4039.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -3003.1396484375,
        -4046.718505859375,
        1102.623779296875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4042.89697265625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -3003.1396484375,
        -4046.718505859375,
        1102.623779296875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4042.89697265625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -3003.1396484375,
        -4042.89697265625,
        1102.623779296875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4039.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4797437787055969,
        -0.8774086833000183
      ],
      "plane_d": 2887.957275390625,
      "bbox_min": [
        -3003.1396484375,
        -4046.718505859375,
        1078.82373046875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4039.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -3003.1396484375,
        -4046.718505859375,
        1082.623779296875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4039.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2725.0498046875,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2716.85986328125,
        -3969.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4046.718505859375,
      "bbox_min": [
        -2725.0498046875,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2716.85986328125,
        -4039.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2725.0498046875,
        -4050.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4046.718505859375,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4534572660923004,
        -0.8912780284881592,
        -0.0
      ],
      "plane_d": -4843.7958984375,
      "bbox_min": [
        -2725.0498046875,
        -4048.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2723.999755859375,
        -4048.234375,
        1137.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2725.0498046875,
        -4050.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4046.718505859375,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2725.0498046875,
        -4050.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4046.718505859375,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47974374890327454,
        -0.8774086236953735
      ],
      "plane_d": 2905.50537109375,
      "bbox_min": [
        -2725.0498046875,
        -4046.718505859375,
        1078.82373046875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4039.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4042.89697265625,
      "bbox_min": [
        -2725.0498046875,
        -4046.718505859375,
        1102.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4039.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2725.0498046875,
        -4046.718505859375,
        1102.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4042.89697265625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2725.0498046875,
        -4046.718505859375,
        1102.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4042.89697265625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2725.0498046875,
        -4042.89697265625,
        1102.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4039.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47974374890327454,
        -0.8774086236953735
      ],
      "plane_d": 2887.95703125,
      "bbox_min": [
        -2725.0498046875,
        -4046.718505859375,
        1078.82373046875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4039.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2725.0498046875,
        -4046.718505859375,
        1082.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4039.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3974.7685546875,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -3969.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3984.7685546875,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -3974.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1069.623779296875,
      "bbox_min": [
        -2884.999755859375,
        -3984.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2819.999755859375,
        -3974.7685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -3571.1669921875,
      "bbox_min": [
        -2884.999755859375,
        -3984.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2819.999755859375,
        -3974.7685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2824.999755859375,
      "bbox_min": [
        -2884.999755859375,
        -3984.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2819.999755859375,
        -3974.7685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2884.999755859375,
      "bbox_min": [
        -2884.999755859375,
        -3984.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2884.999755859375,
        -3974.7685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3979.7685546875,
      "bbox_min": [
        -2824.999755859375,
        -3979.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2819.999755859375,
        -3974.7685546875,
        1063.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2819.999755859375,
      "bbox_min": [
        -2824.999755859375,
        -3979.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2819.999755859375,
        -3974.7685546875,
        1063.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1063.623779296875,
      "bbox_min": [
        -2824.999755859375,
        -3979.7685546875,
        1063.623779296875
      ],
      "bbox_max": [
        -2819.999755859375,
        -3974.7685546875,
        1063.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4534572660923004,
        -0.8912780284881592,
        0.0
      ],
      "plane_d": -2250.0205078125,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -3984.7685546875,
        1139.873779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660253882408142,
        0.5,
        0.0
      ],
      "plane_d": -557.0147705078125,
      "bbox_min": [
        -2994.94970703125,
        -4048.234375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2919.676025390625,
        -3998.117919921875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3998.117919921875,
      "bbox_min": [
        -2963.999755859375,
        -4032.48779296875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2919.676025390625,
        -3998.117919921875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        0.5,
        0.0
      ],
      "plane_d": 4533.48193359375,
      "bbox_min": [
        -2963.999755859375,
        -4032.48779296875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2919.676025390625,
        -3998.117919921875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": 4003.479248046875,
      "bbox_min": [
        -2963.999755859375,
        -4032.48779296875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2919.676025390625,
        -3998.117919921875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999080300331116,
        0.0,
        0.013563040643930435
      ],
      "plane_d": -2954.6591796875,
      "bbox_min": [
        -2963.999755859375,
        -4032.48779296875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2937.2314453125,
        -4018.18359375,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999081492424011,
        -0.0,
        0.013554766774177551
      ],
      "plane_d": 2922.809814453125,
      "bbox_min": [
        -2939.89990234375,
        -4020.226318359375,
        1108.123779296875
      ],
      "bbox_max": [
        -2937.2314453125,
        -4018.86865234375,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2939.89990234375,
        -4020.226318359375,
        1108.123779296875
      ],
      "bbox_max": [
        -2938.099853515625,
        -4018.86865234375,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2938.099853515625,
        -4019.310546875,
        1108.123779296875
      ],
      "bbox_max": [
        -2937.2314453125,
        -4018.86865234375,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2963.999755859375,
        -4029.60009765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2939.89990234375,
        -4018.18359375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660257458686829,
        -0.49999964237213135,
        -0.0
      ],
      "plane_d": -4570.783203125,
      "bbox_min": [
        -2963.999755859375,
        -4029.60009765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2951.499755859375,
        -4018.18359375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660257458686829,
        0.49999964237213135,
        0.0
      ],
      "plane_d": -551.0172119140625,
      "bbox_min": [
        -2957.827392578125,
        -4026.875244140625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2951.499755859375,
        -4018.18359375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2957.07177734375,
        -4026.875244140625,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4019.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2951.499755859375,
      "bbox_min": [
        -2951.499755859375,
        -4026.1279296875,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4019.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707514226436615,
        0.4084835350513458,
        -0.576684296131134
      ],
      "plane_d": 170.4227294921875,
      "bbox_min": [
        -2957.827392578125,
        -4019.7685546875,
        1076.123779296875
      ],
      "bbox_max": [
        -2956.301513671875,
        -4018.434814453125,
        1077.97802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075146436691284,
        -0.4084837734699249,
        -0.5766837000846863
      ],
      "plane_d": -3113.5986328125,
      "bbox_min": [
        -2963.999755859375,
        -4029.60009765625,
        1076.123779296875
      ],
      "bbox_max": [
        -2952.968505859375,
        -4018.4599609375,
        1092.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2963.999755859375,
        -4029.599853515625,
        1076.123779296875
      ],
      "bbox_max": [
        -2952.96875,
        -4018.4599609375,
        1092.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707514226436615,
        0.4084835350513458,
        -0.576684296131134
      ],
      "plane_d": 170.4227294921875,
      "bbox_min": [
        -2963.999755859375,
        -4019.7685546875,
        1076.123779296875
      ],
      "bbox_max": [
        -2957.071533203125,
        -4018.4599609375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375535368919373,
        -0.425826758146286,
        0.5241051912307739
      ],
      "plane_d": -4477.82080078125,
      "bbox_min": [
        -2963.999755859375,
        -4029.60009765625,
        1106.623779296875
      ],
      "bbox_max": [
        -2939.89990234375,
        -4018.848388671875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2963.999755859375,
        -4027.783447265625,
        1106.623779296875
      ],
      "bbox_max": [
        -2939.89990234375,
        -4018.848388671875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7426124215126038,
        0.42874035239219666,
        0.5144983530044556
      ],
      "plane_d": 3348.409423828125,
      "bbox_min": [
        -2962.933837890625,
        -4027.783447265625,
        1108.123779296875
      ],
      "bbox_max": [
        -2952.075927734375,
        -4018.86865234375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375609278678894,
        0.42583099007606506,
        0.5240912437438965
      ],
      "plane_d": -1054.360107421875,
      "bbox_min": [
        -2962.933837890625,
        -4019.7685546875,
        1108.123779296875
      ],
      "bbox_max": [
        -2959.380859375,
        -4018.86865234375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7426074147224426,
        -0.42873746156692505,
        0.514508068561554
      ],
      "plane_d": -98.4783935546875,
      "bbox_min": [
        -2959.386962890625,
        -4019.7685546875,
        1108.123779296875
      ],
      "bbox_max": [
        -2955.397216796875,
        -4018.86865234375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375609278678894,
        0.42583099007606506,
        0.5240912437438965
      ],
      "plane_d": -1054.360107421875,
      "bbox_min": [
        -2959.386962890625,
        -4019.7685546875,
        1112.431640625
      ],
      "bbox_max": [
        -2958.900390625,
        -4018.92724609375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2963.999755859375,
        -4032.48779296875,
        1092.123779296875
      ],
      "bbox_max": [
        -2958.32373046875,
        -4019.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2963.999755859375,
        -4032.48779296875,
        1092.123779296875
      ],
      "bbox_max": [
        -2958.32373046875,
        -4019.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2963.999755859375,
      "bbox_min": [
        -2963.999755859375,
        -4032.48779296875,
        1092.123779296875
      ],
      "bbox_max": [
        -2963.999755859375,
        -4019.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": 2825.051513671875,
      "bbox_min": [
        -2963.468505859375,
        -4018.9365234375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2919.676025390625,
        -3998.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375609278678894,
        0.42583099007606506,
        0.5240912437438965
      ],
      "plane_d": -1054.360107421875,
      "bbox_min": [
        -2963.468505859375,
        -4018.9365234375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2919.676025390625,
        -3998.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2963.29638671875,
        -4018.9365234375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2919.676025390625,
        -3998.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4004.117919921875,
      "bbox_min": [
        -2948.03564453125,
        -4012.66162109375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2919.676025390625,
        -3998.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        0.49999964237213135,
        0.0
      ],
      "plane_d": 4539.4814453125,
      "bbox_min": [
        -2929.9638671875,
        -4012.66162109375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2919.676025390625,
        -4004.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075146436691284,
        0.4084837734699249,
        -0.5766837000846863
      ],
      "plane_d": 4329.1923828125,
      "bbox_min": [
        -2929.9638671875,
        -4012.66162109375,
        1076.123779296875
      ],
      "bbox_max": [
        -2919.676025390625,
        -4004.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375535368919373,
        0.425826758146286,
        0.5241051912307739
      ],
      "plane_d": 3280.968505859375,
      "bbox_min": [
        -2924.1015625,
        -4010.356201171875,
        1106.623779296875
      ],
      "bbox_max": [
        -2919.676025390625,
        -4004.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075146436691284,
        0.4084837734699249,
        -0.5766837000846863
      ],
      "plane_d": 4329.1923828125,
      "bbox_min": [
        -2929.9638671875,
        -4004.117919921875,
        1076.123779296875
      ],
      "bbox_max": [
        -2923.03564453125,
        -3998.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": 3891.818359375,
      "bbox_min": [
        -2951.499755859375,
        -4004.117919921875,
        1076.123779296875
      ],
      "bbox_max": [
        -2944.571533203125,
        -3998.117919921875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375535368919373,
        0.425826758146286,
        0.5241051912307739
      ],
      "plane_d": 3280.968505859375,
      "bbox_min": [
        -2928.80908203125,
        -4005.117919921875,
        1108.123779296875
      ],
      "bbox_max": [
        -2923.524169921875,
        -3999.041015625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7426124215126038,
        -0.42874035239219666,
        0.5144983530044556
      ],
      "plane_d": -4463.53955078125,
      "bbox_min": [
        -2930.541259765625,
        -4013.11572265625,
        1108.123779296875
      ],
      "bbox_max": [
        -2920.5,
        -4002.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375535368919373,
        0.425826758146286,
        0.5241051912307739
      ],
      "plane_d": 3280.968505859375,
      "bbox_min": [
        -2928.80908203125,
        -4011.75341796875,
        1108.123779296875
      ],
      "bbox_max": [
        -2920.5,
        -4002.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660361766815186,
        0.4999813139438629,
        0.0
      ],
      "plane_d": 4614.6796875,
      "bbox_min": [
        -2994.94970703125,
        -4048.234375,
        1102.623779296875
      ],
      "bbox_max": [
        -2987.999755859375,
        -4039.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4042.89697265625,
      "bbox_min": [
        -2994.94970703125,
        -4048.234375,
        1102.623779296875
      ],
      "bbox_max": [
        -2992.185791015625,
        -4042.040283203125,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2994.94970703125,
        -4048.234375,
        1102.623779296875
      ],
      "bbox_max": [
        -2992.185791015625,
        -4042.89697265625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2994.94970703125,
        -4048.234130859375,
        1127.5999755859375
      ],
      "bbox_max": [
        -2992.185791015625,
        -4042.89697265625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2994.94970703125,
        -4042.89697265625,
        1102.623779296875
      ],
      "bbox_max": [
        -2994.455322265625,
        -4042.040283203125,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2994.94970703125,
        -4046.828125,
        1102.623779296875
      ],
      "bbox_max": [
        -2987.999755859375,
        -4039.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4797437787055969,
        -0.8774086833000183
      ],
      "plane_d": 2887.957275390625,
      "bbox_min": [
        -2994.94970703125,
        -4048.234375,
        1078.82373046875
      ],
      "bbox_max": [
        -2987.999755859375,
        -4039.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2994.94970703125,
        -4048.234375,
        1082.623779296875
      ],
      "bbox_max": [
        -2987.999755859375,
        -4039.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253882408142,
        0.5,
        0.0
      ],
      "plane_d": -469.20166015625,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -3984.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253882408142,
        -0.5,
        0.0
      ],
      "plane_d": -4439.951171875,
      "bbox_min": [
        -2880.499755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4009.93701171875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4041.419189453125,
      "bbox_min": [
        -2805.999755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4009.93701171875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999081492424011,
        0.0,
        0.013554766774177551
      ],
      "plane_d": -2796.664306640625,
      "bbox_min": [
        -2805.999755859375,
        -4041.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -4009.93701171875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": -4035.3193359375,
      "bbox_min": [
        -2782.58447265625,
        -4041.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -4019.310546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999080300331116,
        -0.0,
        0.013563040643930435
      ],
      "plane_d": 2764.814453125,
      "bbox_min": [
        -2781.8994140625,
        -4020.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2779.230712890625,
        -4019.310546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2781.8994140625,
        -4020.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2780.099609375,
        -4019.310546875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2780.099609375,
        -4020.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2779.230712890625,
        -4020.226318359375,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2782.58447265625,
        -4041.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2761.676025390625,
        -4020.66845703125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        -0.49999964237213135,
        0.0
      ],
      "plane_d": 382.884033203125,
      "bbox_min": [
        -2771.9638671875,
        -4035.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2761.676025390625,
        -4026.1279296875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2768.499755859375,
      "bbox_min": [
        -2768.499755859375,
        -4029.4189453125,
        1092.123779296875
      ],
      "bbox_max": [
        -2767.031005859375,
        -4026.1279296875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2768.499755859375,
        -4029.4189453125,
        1092.123779296875
      ],
      "bbox_max": [
        -2767.031005859375,
        -4026.1279296875,
        1092.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075143456459045,
        -0.4084831476211548,
        -0.5766843557357788
      ],
      "plane_d": 933.3873291015625,
      "bbox_min": [
        -2771.9638671875,
        -4035.419189453125,
        1076.123779296875
      ],
      "bbox_max": [
        -2761.676025390625,
        -4026.875244140625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2768.499755859375,
        -4035.419189453125,
        1092.123779296875
      ],
      "bbox_max": [
        -2761.676025390625,
        -4026.875244140625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2768.499755859375,
      "bbox_min": [
        -2768.499755859375,
        -4035.419189453125,
        1092.123779296875
      ],
      "bbox_max": [
        -2768.499755859375,
        -4029.4189453125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": -2676.225341796875,
      "bbox_min": [
        -2782.333251953125,
        -4041.419189453125,
        1076.123779296875
      ],
      "bbox_max": [
        -2765.03564453125,
        -4035.419189453125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075143456459045,
        -0.4084831476211548,
        -0.5766843557357788
      ],
      "plane_d": 933.3873291015625,
      "bbox_min": [
        -2771.9638671875,
        -4041.419189453125,
        1076.123779296875
      ],
      "bbox_max": [
        -2765.03564453125,
        -4035.419189453125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2768.499755859375,
        -4041.419189453125,
        1092.123779296875
      ],
      "bbox_max": [
        -2765.03564453125,
        -4035.419189453125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2768.499755859375,
      "bbox_min": [
        -2768.499755859375,
        -4041.419189453125,
        1092.123779296875
      ],
      "bbox_max": [
        -2768.499755859375,
        -4035.419189453125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375649213790894,
        -0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -258.964111328125,
      "bbox_min": [
        -2781.919921875,
        -4041.419189453125,
        1106.623779296875
      ],
      "bbox_max": [
        -2761.676025390625,
        -4020.66845703125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2781.919921875,
        -4041.419189453125,
        1106.623779296875
      ],
      "bbox_max": [
        -2765.245849609375,
        -4020.66845703125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": -4021.886962890625,
      "bbox_min": [
        -2781.919921875,
        -4041.419189453125,
        1106.623779296875
      ],
      "bbox_max": [
        -2768.499755859375,
        -4040.49609375,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7426049113273621,
        0.4287405014038086,
        0.5145090222358704
      ],
      "plane_d": -899.3235473632812,
      "bbox_min": [
        -2781.8994140625,
        -4037.419189453125,
        1108.123779296875
      ],
      "bbox_max": [
        -2765.245849609375,
        -4026.421142578125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": 2889.36083984375,
      "bbox_min": [
        -2781.8994140625,
        -4037.419189453125,
        1108.123779296875
      ],
      "bbox_max": [
        -2770.80908203125,
        -4034.419189453125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2768.499755859375,
        -4041.419189453125,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4029.599853515625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2768.499755859375,
        -4041.419189453125,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4029.599853515625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2755.999755859375,
      "bbox_min": [
        -2755.999755859375,
        -4041.419189453125,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4032.48779296875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253882408142,
        0.5,
        0.0
      ],
      "plane_d": -420.182861328125,
      "bbox_min": [
        -2805.999755859375,
        -4041.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2781.83154296875,
        -4009.93701171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375558018684387,
        -0.4258209764957428,
        0.5241067409515381
      ],
      "plane_d": -4361.27197265625,
      "bbox_min": [
        -2805.999755859375,
        -4041.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2781.83154296875,
        -4009.93701171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075148224830627,
        -0.4084834158420563,
        -0.5766835808753967
      ],
      "plane_d": -3001.810546875,
      "bbox_min": [
        -2805.999755859375,
        -4041.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2781.83154296875,
        -4009.93701171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2805.999755859375,
        -4041.419189453125,
        1066.055419921875
      ],
      "bbox_max": [
        -2781.83154296875,
        -4009.93701171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": -2676.225341796875,
      "bbox_min": [
        -2805.999755859375,
        -4041.419189453125,
        1066.82861328125
      ],
      "bbox_max": [
        -2781.8994140625,
        -4009.93701171875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": -4021.886962890625,
      "bbox_min": [
        -2805.999755859375,
        -4041.419189453125,
        1106.623779296875
      ],
      "bbox_max": [
        -2781.8994140625,
        -4009.93701171875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375649213790894,
        0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -937.85400390625,
      "bbox_min": [
        -2805.999755859375,
        -4019.7685546875,
        1106.623779296875
      ],
      "bbox_max": [
        -2799.49951171875,
        -4009.93701171875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4035.419189453125,
      "bbox_min": [
        -2790.03564453125,
        -4035.419189453125,
        1066.82861328125
      ],
      "bbox_max": [
        -2782.333251953125,
        -4035.419189453125,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660257458686829,
        0.49999964237213135,
        0.0
      ],
      "plane_d": -414.185302734375,
      "bbox_min": [
        -2799.071533203125,
        -4019.7685546875,
        1066.055419921875
      ],
      "bbox_max": [
        -2794.96826171875,
        -4012.66162109375,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7426109313964844,
        0.42874401807785034,
        0.5144973993301392
      ],
      "plane_d": 3231.08837890625,
      "bbox_min": [
        -2804.933837890625,
        -4040.49609375,
        1108.123779296875
      ],
      "bbox_max": [
        -2781.83154296875,
        -4010.356201171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375649213790894,
        0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -937.85400390625,
      "bbox_min": [
        -2804.933837890625,
        -4040.49609375,
        1108.123779296875
      ],
      "bbox_max": [
        -2785.94970703125,
        -4013.69140625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": -4021.886962890625,
      "bbox_min": [
        -2792.966796875,
        -4040.49609375,
        1108.123779296875
      ],
      "bbox_max": [
        -2785.94970703125,
        -4037.419189453125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": 2889.36083984375,
      "bbox_min": [
        -2801.425048828125,
        -4040.49609375,
        1108.123779296875
      ],
      "bbox_max": [
        -2781.83154296875,
        -4010.356201171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7426049113273621,
        -0.4287405014038086,
        0.5145090222358704
      ],
      "plane_d": -215.83050537109375,
      "bbox_min": [
        -2801.425048828125,
        -4019.7685546875,
        1108.123779296875
      ],
      "bbox_max": [
        -2794.07568359375,
        -4010.356201171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375649213790894,
        0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -937.85400390625,
      "bbox_min": [
        -2801.425048828125,
        -4019.7685546875,
        1108.123779296875
      ],
      "bbox_max": [
        -2796.75341796875,
        -4010.356201171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4035.419189453125,
      "bbox_min": [
        -2790.03564453125,
        -4035.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2782.459228515625,
        -4035.419189453125,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2768.499755859375,
        -4050.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4041.419189453125,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2768.499755859375,
        -4050.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4041.419189453125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2768.499755859375,
      "bbox_min": [
        -2768.499755859375,
        -4050.7685546875,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4041.419189453125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2755.999755859375,
      "bbox_min": [
        -2755.999755859375,
        -4050.7685546875,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4041.419189453125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47974374890327454,
        -0.0,
        -0.8774086236953735
      ],
      "plane_d": -360.75628662109375,
      "bbox_min": [
        -2731.999755859375,
        -4050.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4044.698486328125,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2731.999755859375,
        -4050.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4044.698486328125,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47974374890327454,
        -0.0,
        -0.8774086236953735
      ],
      "plane_d": -343.2081298828125,
      "bbox_min": [
        -2731.999755859375,
        -4050.7685546875,
        1098.82373046875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4044.698486328125,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660361766815186,
        0.4999813139438629,
        0.0
      ],
      "plane_d": -339.047119140625,
      "bbox_min": [
        -2731.999755859375,
        -4050.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4044.698486328125,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2730.0888671875,
        -4050.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4046.827880859375,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2730.0888671875,
        -4050.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4046.828125,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2731.999755859375,
        -4050.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2727.81396484375,
        -4044.698486328125,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4029.117919921875,
      "bbox_min": [
        -2880.499755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4029.117919921875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        0.5,
        -0.0
      ],
      "plane_d": 4476.6689453125,
      "bbox_min": [
        -2880.499755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4029.117919921875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2880.499755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4029.117919921875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375649213790894,
        0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -979.601806640625,
      "bbox_min": [
        -2880.499755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4029.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375558018684387,
        0.4258209764957428,
        0.5241067409515381
      ],
      "plane_d": 3232.564697265625,
      "bbox_min": [
        -2880.499755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4029.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": 2851.452880859375,
      "bbox_min": [
        -2880.499755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4029.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660257458686829,
        0.49999964237213135,
        0.0
      ],
      "plane_d": -463.2041015625,
      "bbox_min": [
        -2880.499755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4029.117919921875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        0.49999964237213135,
        -0.0
      ],
      "plane_d": 4482.66845703125,
      "bbox_min": [
        -2864.53564453125,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4029.117919921875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4035.117919921875,
      "bbox_min": [
        -2864.53564453125,
        -4035.117919921875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2846.4638671875,
        -4029.117919921875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": 3917.144287109375,
      "bbox_min": [
        -2864.53564453125,
        -4035.117919921875,
        1076.123779296875
      ],
      "bbox_max": [
        -2846.4638671875,
        -4029.117919921875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075148224830627,
        0.4084834158420563,
        -0.5766835808753967
      ],
      "plane_d": 4282.77734375,
      "bbox_min": [
        -2849.927734375,
        -4050.7685546875,
        1076.123779296875
      ],
      "bbox_max": [
        -2830.499755859375,
        -4029.117919921875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075143456459045,
        0.4084831476211548,
        -0.5766843557357788
      ],
      "plane_d": 242.161376953125,
      "bbox_min": [
        -2880.499755859375,
        -4050.7685546875,
        1076.123779296875
      ],
      "bbox_max": [
        -2861.071533203125,
        -4029.117919921875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": 3917.144287109375,
      "bbox_min": [
        -2867.999755859375,
        -4035.117919921875,
        1076.123779296875
      ],
      "bbox_max": [
        -2861.071533203125,
        -4029.117919921875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": 4034.476318359375,
      "bbox_min": [
        -2856.39990234375,
        -4050.7685546875,
        1108.123779296875
      ],
      "bbox_max": [
        -2831.565673828125,
        -4030.041015625,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999081492424011,
        -0.0,
        0.013554766774177551
      ],
      "plane_d": 2839.3173828125,
      "bbox_min": [
        -2854.999755859375,
        -4050.7685546875,
        1108.123779296875
      ],
      "bbox_max": [
        -2831.565673828125,
        -4049.86865234375,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375558018684387,
        0.4258209764957428,
        0.5241067409515381
      ],
      "plane_d": 3232.564697265625,
      "bbox_min": [
        -2839.102294921875,
        -4050.7685546875,
        1108.123779296875
      ],
      "bbox_max": [
        -2831.565673828125,
        -4049.86865234375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7426109313964844,
        -0.42874401807785034,
        0.5144973993301392
      ],
      "plane_d": -4414.83203125,
      "bbox_min": [
        -2839.102294921875,
        -4050.7685546875,
        1108.123779296875
      ],
      "bbox_max": [
        -2835.11865234375,
        -4049.86865234375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375558018684387,
        0.4258209764957428,
        0.5241067409515381
      ],
      "plane_d": 3232.564697265625,
      "bbox_min": [
        -2856.39990234375,
        -4049.9365234375,
        1108.123779296875
      ],
      "bbox_max": [
        -2832.085205078125,
        -4030.041015625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": 2851.452880859375,
      "bbox_min": [
        -2850.549560546875,
        -4033.117919921875,
        1108.123779296875
      ],
      "bbox_max": [
        -2843.53271484375,
        -4030.041015625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": -4031.067626953125,
      "bbox_min": [
        -2856.39990234375,
        -4036.117919921875,
        1108.123779296875
      ],
      "bbox_max": [
        -2845.30908203125,
        -4030.041015625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": 2851.452880859375,
      "bbox_min": [
        -2856.39990234375,
        -4033.117919921875,
        1108.123779296875
      ],
      "bbox_max": [
        -2845.30908203125,
        -4030.041015625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": 2851.452880859375,
      "bbox_min": [
        -2867.466796875,
        -4033.117919921875,
        1108.123779296875
      ],
      "bbox_max": [
        -2860.44970703125,
        -4030.041015625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": -4031.067626953125,
      "bbox_min": [
        -2865.6904296875,
        -4036.117919921875,
        1108.123779296875
      ],
      "bbox_max": [
        -2856.33203125,
        -4030.041015625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": 2851.452880859375,
      "bbox_min": [
        -2865.6904296875,
        -4033.117919921875,
        1108.123779296875
      ],
      "bbox_max": [
        -2856.33203125,
        -4030.041015625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999081492424011,
        -0.0,
        0.013554766774177551
      ],
      "plane_d": 2922.809814453125,
      "bbox_min": [
        -2963.999755859375,
        -4041.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2913.999755859375,
        -4009.93701171875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": -4035.3193359375,
      "bbox_min": [
        -2963.999755859375,
        -4041.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2937.4150390625,
        -4019.310546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999080300331116,
        0.0,
        0.013563040643930435
      ],
      "plane_d": -2954.6591796875,
      "bbox_min": [
        -2940.768798828125,
        -4020.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2938.10009765625,
        -4019.310546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2939.900146484375,
        -4020.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2938.10009765625,
        -4019.310546875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2940.768798828125,
        -4020.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2939.900146484375,
        -4020.226318359375,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2958.32373046875,
        -4041.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2937.4150390625,
        -4020.66845703125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660257458686829,
        -0.49999964237213135,
        -0.0
      ],
      "plane_d": -4570.783203125,
      "bbox_min": [
        -2958.32373046875,
        -4035.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2948.03564453125,
        -4026.1279296875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2951.499755859375,
      "bbox_min": [
        -2952.96875,
        -4029.419921875,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4026.1279296875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2952.96875,
        -4029.419921875,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4026.1279296875,
        1092.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075146436691284,
        -0.4084837734699249,
        -0.5766837000846863
      ],
      "plane_d": -3113.5986328125,
      "bbox_min": [
        -2958.32373046875,
        -4035.419189453125,
        1076.123779296875
      ],
      "bbox_max": [
        -2948.03564453125,
        -4026.875244140625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2958.32373046875,
        -4035.419189453125,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4026.875244140625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2951.499755859375,
      "bbox_min": [
        -2951.499755859375,
        -4035.419189453125,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4029.419921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": -2676.225341796875,
      "bbox_min": [
        -2954.9638671875,
        -4041.419189453125,
        1076.123779296875
      ],
      "bbox_max": [
        -2937.666259765625,
        -4035.419189453125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075146436691284,
        -0.4084837734699249,
        -0.5766837000846863
      ],
      "plane_d": -3113.5986328125,
      "bbox_min": [
        -2954.9638671875,
        -4041.419189453125,
        1076.123779296875
      ],
      "bbox_max": [
        -2948.03564453125,
        -4035.419189453125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2954.9638671875,
        -4041.419189453125,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4035.419189453125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2951.499755859375,
      "bbox_min": [
        -2951.499755859375,
        -4041.419189453125,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4035.419189453125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375535368919373,
        -0.425826758146286,
        0.5241051912307739
      ],
      "plane_d": -4477.82080078125,
      "bbox_min": [
        -2958.323486328125,
        -4041.419189453125,
        1106.623779296875
      ],
      "bbox_max": [
        -2938.07958984375,
        -4020.66845703125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2954.753662109375,
        -4041.419189453125,
        1106.623779296875
      ],
      "bbox_max": [
        -2938.07958984375,
        -4020.66845703125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": -4021.886962890625,
      "bbox_min": [
        -2951.499755859375,
        -4041.419189453125,
        1106.623779296875
      ],
      "bbox_max": [
        -2938.07958984375,
        -4040.49609375,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7426124215126038,
        0.42874035239219666,
        0.5144983530044556
      ],
      "plane_d": 3348.409423828125,
      "bbox_min": [
        -2954.753662109375,
        -4037.419189453125,
        1108.123779296875
      ],
      "bbox_max": [
        -2938.10009765625,
        -4026.421142578125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": 2889.36083984375,
      "bbox_min": [
        -2949.1904296875,
        -4037.419189453125,
        1108.123779296875
      ],
      "bbox_max": [
        -2938.10009765625,
        -4034.419189453125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2963.999755859375,
        -4041.419189453125,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4029.599853515625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2963.999755859375,
        -4041.419189453125,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4029.599853515625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2963.999755859375,
      "bbox_min": [
        -2963.999755859375,
        -4041.419189453125,
        1092.123779296875
      ],
      "bbox_max": [
        -2963.999755859375,
        -4032.48779296875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        0.5,
        0.0
      ],
      "plane_d": 4533.48193359375,
      "bbox_min": [
        -2938.16796875,
        -4041.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2913.999755859375,
        -4009.93701171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375609278678894,
        -0.42583099007606506,
        0.5240912437438965
      ],
      "plane_d": -142.46148681640625,
      "bbox_min": [
        -2938.16796875,
        -4041.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2913.999755859375,
        -4009.93701171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707514226436615,
        -0.4084835350513458,
        -0.576684296131134
      ],
      "plane_d": 1045.172607421875,
      "bbox_min": [
        -2938.16796875,
        -4041.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2913.999755859375,
        -4009.93701171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2938.16796875,
        -4041.419189453125,
        1066.0555419921875
      ],
      "bbox_max": [
        -2913.999755859375,
        -4009.93701171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": -2676.225341796875,
      "bbox_min": [
        -2938.10009765625,
        -4041.419189453125,
        1066.8287353515625
      ],
      "bbox_max": [
        -2913.999755859375,
        -4009.93701171875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": -4021.886962890625,
      "bbox_min": [
        -2938.10009765625,
        -4041.419189453125,
        1106.623779296875
      ],
      "bbox_max": [
        -2913.999755859375,
        -4009.93701171875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375535368919373,
        0.425826758146286,
        0.5241051912307739
      ],
      "plane_d": 3280.968505859375,
      "bbox_min": [
        -2920.5,
        -4019.7685546875,
        1106.623779296875
      ],
      "bbox_max": [
        -2913.999755859375,
        -4009.93701171875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4035.419189453125,
      "bbox_min": [
        -2937.666259765625,
        -4035.419189453125,
        1066.8287353515625
      ],
      "bbox_max": [
        -2929.9638671875,
        -4035.419189453125,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        0.49999964237213135,
        0.0
      ],
      "plane_d": 4539.4814453125,
      "bbox_min": [
        -2925.03125,
        -4019.7685546875,
        1066.0555419921875
      ],
      "bbox_max": [
        -2920.927978515625,
        -4012.66162109375,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7426074147224426,
        0.42873746156692505,
        0.514508068561554
      ],
      "plane_d": -1016.6737060546875,
      "bbox_min": [
        -2938.16796875,
        -4040.49609375,
        1108.123779296875
      ],
      "bbox_max": [
        -2915.065673828125,
        -4010.356201171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375535368919373,
        0.425826758146286,
        0.5241051912307739
      ],
      "plane_d": 3280.968505859375,
      "bbox_min": [
        -2934.0498046875,
        -4040.49609375,
        1108.123779296875
      ],
      "bbox_max": [
        -2915.065673828125,
        -4013.69140625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": -4021.886962890625,
      "bbox_min": [
        -2934.0498046875,
        -4040.49609375,
        1108.123779296875
      ],
      "bbox_max": [
        -2927.03271484375,
        -4037.419189453125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": 2889.36083984375,
      "bbox_min": [
        -2938.16796875,
        -4040.49609375,
        1108.123779296875
      ],
      "bbox_max": [
        -2918.574462890625,
        -4010.356201171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7426124215126038,
        -0.42874035239219666,
        0.5144983530044556
      ],
      "plane_d": -4463.53955078125,
      "bbox_min": [
        -2925.923828125,
        -4019.7685546875,
        1108.123779296875
      ],
      "bbox_max": [
        -2918.574462890625,
        -4010.356201171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375535368919373,
        0.425826758146286,
        0.5241051912307739
      ],
      "plane_d": 3280.968505859375,
      "bbox_min": [
        -2923.24609375,
        -4019.7685546875,
        1108.123779296875
      ],
      "bbox_max": [
        -2918.574462890625,
        -4010.356201171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4035.419189453125,
      "bbox_min": [
        -2937.540283203125,
        -4035.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2929.9638671875,
        -4035.419189453125,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4041.419189453125,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4041.419189453125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2963.999755859375,
      "bbox_min": [
        -2963.999755859375,
        -4050.7685546875,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4041.419189453125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2951.499755859375,
      "bbox_min": [
        -2951.499755859375,
        -4050.7685546875,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4041.419189453125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47974374890327454,
        0.0,
        -0.8774086236953735
      ],
      "plane_d": 2383.377685546875,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -2987.999755859375,
        -4044.6982421875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2987.999755859375,
        -4044.6982421875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47974374890327454,
        0.0,
        -0.8774086236953735
      ],
      "plane_d": 2400.92578125,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1098.82373046875
      ],
      "bbox_max": [
        -2987.999755859375,
        -4044.6982421875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660361766815186,
        0.4999813139438629,
        0.0
      ],
      "plane_d": 4614.6796875,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2987.999755859375,
        -4044.6982421875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2989.91064453125,
        -4046.827880859375,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2994.94970703125,
        -4050.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2989.9111328125,
        -4046.828125,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2992.18603515625,
        -4050.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2987.999755859375,
        -4044.6982421875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2856.5849609375,
      "bbox_min": [
        -2856.5849609375,
        -3986.754638671875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2853.5849609375,
        -3984.7685546875,
        1063.076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2853.5849609375,
      "bbox_min": [
        -2856.5849609375,
        -3986.754638671875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2853.5849609375,
        -3984.7685546875,
        1063.076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3986.754638671875,
      "bbox_min": [
        -2856.5849609375,
        -3986.754638671875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2853.5849609375,
        -3984.7685546875,
        1063.076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7265339493751526,
        0.6871305704116821
      ],
      "plane_d": -3625.5419921875,
      "bbox_min": [
        -2856.5849609375,
        -3986.754638671875,
        1060.9761962890625
      ],
      "bbox_max": [
        -2853.5849609375,
        -3984.7685546875,
        1063.076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        0.5,
        -0.0
      ],
      "plane_d": 4396.64990234375,
      "bbox_min": [
        -2800.323486328125,
        -4048.234375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -3998.117919921875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3998.117919921875,
      "bbox_min": [
        -2800.323486328125,
        -4032.48779296875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -3998.117919921875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253882408142,
        0.5,
        0.0
      ],
      "plane_d": -420.182861328125,
      "bbox_min": [
        -2800.323486328125,
        -4032.48779296875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -3998.117919921875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": 4003.479248046875,
      "bbox_min": [
        -2800.323486328125,
        -4032.48779296875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -3998.117919921875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999080300331116,
        -0.0,
        0.013563040643930435
      ],
      "plane_d": 2764.814453125,
      "bbox_min": [
        -2782.76806640625,
        -4032.48779296875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -4018.18359375,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999081492424011,
        0.0,
        0.013554766774177551
      ],
      "plane_d": -2796.664306640625,
      "bbox_min": [
        -2782.76806640625,
        -4020.226318359375,
        1108.123779296875
      ],
      "bbox_max": [
        -2780.099609375,
        -4018.86865234375,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2781.899658203125,
        -4020.226318359375,
        1108.123779296875
      ],
      "bbox_max": [
        -2780.099609375,
        -4018.86865234375,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2782.76806640625,
        -4019.310546875,
        1108.123779296875
      ],
      "bbox_max": [
        -2781.899658203125,
        -4018.86865234375,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2780.099609375,
        -4029.60009765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -4018.18359375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        -0.49999964237213135,
        0.0
      ],
      "plane_d": 382.884033203125,
      "bbox_min": [
        -2768.499755859375,
        -4029.60009765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -4018.18359375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        0.49999964237213135,
        -0.0
      ],
      "plane_d": 4402.6494140625,
      "bbox_min": [
        -2768.499755859375,
        -4026.875244140625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2762.172607421875,
        -4018.18359375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2768.499755859375,
        -4026.875244140625,
        1092.123779296875
      ],
      "bbox_max": [
        -2762.927978515625,
        -4019.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2768.499755859375,
      "bbox_min": [
        -2768.499755859375,
        -4026.1279296875,
        1092.123779296875
      ],
      "bbox_max": [
        -2768.499755859375,
        -4019.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075148224830627,
        0.4084834158420563,
        -0.5766835808753967
      ],
      "plane_d": 4217.404296875,
      "bbox_min": [
        -2763.697998046875,
        -4019.7685546875,
        1076.123779296875
      ],
      "bbox_max": [
        -2762.172607421875,
        -4018.434814453125,
        1077.9774169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075143456459045,
        -0.4084831476211548,
        -0.5766843557357788
      ],
      "plane_d": 933.3873291015625,
      "bbox_min": [
        -2767.03125,
        -4029.60009765625,
        1076.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4018.4599609375,
        1092.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2767.031005859375,
        -4029.599853515625,
        1076.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4018.4599609375,
        1092.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075148224830627,
        0.4084834158420563,
        -0.5766835808753967
      ],
      "plane_d": 4217.404296875,
      "bbox_min": [
        -2762.927978515625,
        -4019.7685546875,
        1076.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4018.4599609375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375649213790894,
        -0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -258.964111328125,
      "bbox_min": [
        -2780.099609375,
        -4029.60009765625,
        1106.623779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4018.848388671875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2780.099609375,
        -4027.783447265625,
        1106.623779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4018.848388671875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7426049113273621,
        0.4287405014038086,
        0.5145090222358704
      ],
      "plane_d": -899.3235473632812,
      "bbox_min": [
        -2767.923583984375,
        -4027.783447265625,
        1108.123779296875
      ],
      "bbox_max": [
        -2757.065673828125,
        -4018.86865234375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375558018684387,
        0.4258209764957428,
        0.5241067409515381
      ],
      "plane_d": 3164.416259765625,
      "bbox_min": [
        -2760.61865234375,
        -4019.7685546875,
        1108.123779296875
      ],
      "bbox_max": [
        -2757.065673828125,
        -4018.86865234375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7426109313964844,
        -0.42874401807785034,
        0.5144973993301392
      ],
      "plane_d": -4346.216796875,
      "bbox_min": [
        -2764.602294921875,
        -4019.7685546875,
        1108.123779296875
      ],
      "bbox_max": [
        -2760.612548828125,
        -4018.86865234375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375558018684387,
        0.4258209764957428,
        0.5241067409515381
      ],
      "plane_d": 3164.416259765625,
      "bbox_min": [
        -2761.09912109375,
        -4019.7685546875,
        1112.431396484375
      ],
      "bbox_max": [
        -2760.612548828125,
        -4018.92724609375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2761.676025390625,
        -4032.48779296875,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4019.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2761.676025390625,
        -4032.48779296875,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4019.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2755.999755859375,
      "bbox_min": [
        -2755.999755859375,
        -4032.48779296875,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4019.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": 2825.051513671875,
      "bbox_min": [
        -2800.323486328125,
        -4018.9365234375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2756.531005859375,
        -3998.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375558018684387,
        0.4258209764957428,
        0.5241067409515381
      ],
      "plane_d": 3164.416259765625,
      "bbox_min": [
        -2800.323486328125,
        -4018.9365234375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2756.531005859375,
        -3998.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2800.323486328125,
        -4018.9365234375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2756.703125,
        -3998.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4004.117919921875,
      "bbox_min": [
        -2800.323486328125,
        -4012.66162109375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2771.9638671875,
        -3998.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660257458686829,
        0.49999964237213135,
        0.0
      ],
      "plane_d": -414.185302734375,
      "bbox_min": [
        -2800.323486328125,
        -4012.66162109375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2790.03564453125,
        -4004.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075143456459045,
        0.4084831476211548,
        -0.5766843557357788
      ],
      "plane_d": 282.208251953125,
      "bbox_min": [
        -2800.323486328125,
        -4012.66162109375,
        1076.123779296875
      ],
      "bbox_max": [
        -2790.03564453125,
        -4004.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375649213790894,
        0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -937.85400390625,
      "bbox_min": [
        -2800.323486328125,
        -4010.356201171875,
        1106.623779296875
      ],
      "bbox_max": [
        -2795.89794921875,
        -4004.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075143456459045,
        0.4084831476211548,
        -0.5766843557357788
      ],
      "plane_d": 282.208251953125,
      "bbox_min": [
        -2796.9638671875,
        -4004.117919921875,
        1076.123779296875
      ],
      "bbox_max": [
        -2790.03564453125,
        -3998.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": 3891.818359375,
      "bbox_min": [
        -2775.427978515625,
        -4004.117919921875,
        1076.123779296875
      ],
      "bbox_max": [
        -2768.499755859375,
        -3998.117919921875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375649213790894,
        0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -937.85400390625,
      "bbox_min": [
        -2796.475341796875,
        -4005.117919921875,
        1108.123779296875
      ],
      "bbox_max": [
        -2791.1904296875,
        -3999.041015625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7426049113273621,
        -0.4287405014038086,
        0.5145090222358704
      ],
      "plane_d": -215.83050537109375,
      "bbox_min": [
        -2799.49951171875,
        -4013.11572265625,
        1108.123779296875
      ],
      "bbox_max": [
        -2789.458251953125,
        -4002.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375649213790894,
        0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -937.85400390625,
      "bbox_min": [
        -2799.49951171875,
        -4011.75341796875,
        1108.123779296875
      ],
      "bbox_max": [
        -2791.1904296875,
        -4002.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660361766815186,
        0.4999813139438629,
        0.0
      ],
      "plane_d": -339.047119140625,
      "bbox_min": [
        -2731.999755859375,
        -4048.234375,
        1102.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4039.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4042.89697265625,
      "bbox_min": [
        -2727.81396484375,
        -4048.234375,
        1102.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4042.040283203125,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2727.81396484375,
        -4048.234375,
        1102.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4042.89697265625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2727.813720703125,
        -4048.234130859375,
        1127.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4042.89697265625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2725.54443359375,
        -4042.89697265625,
        1102.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4042.040283203125,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2731.999755859375,
        -4046.828125,
        1102.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4039.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47974374890327454,
        -0.8774086236953735
      ],
      "plane_d": 2887.95703125,
      "bbox_min": [
        -2731.999755859375,
        -4048.234375,
        1078.82373046875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4039.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2731.999755859375,
        -4048.234375,
        1082.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4039.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2824.999755859375,
      "bbox_min": [
        -2824.999755859375,
        -3974.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2819.999755859375,
        -3969.7685546875,
        1063.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2819.999755859375,
      "bbox_min": [
        -2824.999755859375,
        -3974.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2819.999755859375,
        -3969.7685546875,
        1063.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3969.7685546875,
      "bbox_min": [
        -2824.999755859375,
        -3969.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2819.999755859375,
        -3969.7685546875,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4012.0,
      "bbox_min": [
        -2716.85986328125,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2660.6845703125,
        -4012.0,
        1139.873779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1057.6236572265625,
      "bbox_min": [
        -2716.85986328125,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2660.6845703125,
        -4012.0,
        1139.873779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4021.999755859375,
      "bbox_min": [
        -2709.0,
        -4022.0,
        1057.5999755859375
      ],
      "bbox_max": [
        -2664.091552734375,
        -4022.0,
        1057.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2716.85986328125,
        -4050.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -2709.7998046875,
        -4039.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47974374890327454,
        -0.8774086236953735
      ],
      "plane_d": 2887.95703125,
      "bbox_min": [
        -2716.85986328125,
        -4046.718505859375,
        1078.82373046875
      ],
      "bbox_max": [
        -2709.7998046875,
        -4039.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47974374890327454,
        -0.8774086236953735
      ],
      "plane_d": 2905.50537109375,
      "bbox_min": [
        -2716.85986328125,
        -4046.718505859375,
        1098.82373046875
      ],
      "bbox_max": [
        -2709.7998046875,
        -4039.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2716.85986328125,
        -4050.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2711.91064453125,
        -4042.89697265625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3021.999755859375,
      "bbox_min": [
        -3034.999755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3003.1396484375,
        -3987.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3034.999755859375,
      "bbox_min": [
        -3034.999755859375,
        -4020.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3021.999755859375,
        -3987.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -3034.999755859375,
        -4020.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3021.999755859375,
        -3987.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -2902.4072265625,
      "bbox_min": [
        -3034.999755859375,
        -4020.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3021.999755859375,
        -3987.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1380.5384521484375,
      "bbox_min": [
        -3034.999755859375,
        -4020.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3021.999755859375,
        -3987.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": -4020.768310546875,
      "bbox_min": [
        -3034.999755859375,
        -4020.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3021.999755859375,
        -3987.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3987.7685546875,
      "bbox_min": [
        -3034.999755859375,
        -3987.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3021.999755859375,
        -3987.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -3010.19970703125,
        -4050.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -3003.1396484375,
        -4039.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4797437787055969,
        -0.8774086833000183
      ],
      "plane_d": 2887.957275390625,
      "bbox_min": [
        -3010.19970703125,
        -4046.718505859375,
        1078.82373046875
      ],
      "bbox_max": [
        -3003.1396484375,
        -4039.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4797437787055969,
        -0.8774086833000183
      ],
      "plane_d": 2905.50537109375,
      "bbox_min": [
        -3010.19970703125,
        -4046.718505859375,
        1098.82373046875
      ],
      "bbox_max": [
        -3003.1396484375,
        -4039.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -3008.0888671875,
        -4050.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -3003.1396484375,
        -4042.89697265625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882434844970703,
        0.9659245014190674,
        0.0
      ],
      "plane_d": 3390.9111328125,
      "bbox_min": [
        -3034.999755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2676.163330078125,
        -4050.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2716.85986328125,
      "bbox_min": [
        -3003.1396484375,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2676.163330078125,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2994.94970703125,
      "bbox_min": [
        -3003.1396484375,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2716.85986328125,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4054.818603515625,
      "bbox_min": [
        -3003.1396484375,
        -4061.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2994.94970703125,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -3003.1396484375,
        -4054.818603515625,
        1082.623779296875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4050.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4534572660923004,
        -0.8912780284881592,
        0.0
      ],
      "plane_d": -4970.70166015625,
      "bbox_min": [
        -2995.999755859375,
        -4053.302734375,
        1127.5999755859375
      ],
      "bbox_max": [
        -2994.94970703125,
        -4052.7685546875,
        1137.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -3003.1396484375,
        -4054.818603515625,
        1082.623779296875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4050.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -3003.1396484375,
        -4054.818603515625,
        1102.623779296875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4050.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4797437787055969,
        -0.8774086833000183
      ],
      "plane_d": -981.1565551757812,
      "bbox_min": [
        -3003.1396484375,
        -4061.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4054.818603515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4058.64013671875,
      "bbox_min": [
        -3003.1396484375,
        -4061.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4054.818603515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -3003.1396484375,
        -4058.64013671875,
        1102.623779296875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4054.818603515625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -3003.1396484375,
        -4058.64013671875,
        1102.623779296875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4054.818603515625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -3003.1396484375,
        -4061.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4058.64013671875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4797437787055969,
        -0.8774086833000183
      ],
      "plane_d": -998.7047119140625,
      "bbox_min": [
        -3003.1396484375,
        -4061.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4054.818603515625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -3003.1396484375,
        -4061.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2994.94970703125,
        -4054.818603515625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2725.0498046875,
      "bbox_min": [
        -2994.94970703125,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2716.85986328125,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4054.818603515625,
      "bbox_min": [
        -2725.0498046875,
        -4061.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2716.85986328125,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2725.0498046875,
        -4054.818603515625,
        1082.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4050.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4534572660923004,
        0.8912780284881592,
        0.0
      ],
      "plane_d": 2376.92626953125,
      "bbox_min": [
        -2725.0498046875,
        -4053.302734375,
        1127.5999755859375
      ],
      "bbox_max": [
        -2723.999755859375,
        -4052.7685546875,
        1137.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2725.0498046875,
        -4054.818603515625,
        1082.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4050.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2725.0498046875,
        -4054.818603515625,
        1102.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4050.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.47974374890327454,
        -0.8774086236953735
      ],
      "plane_d": -981.156494140625,
      "bbox_min": [
        -2725.0498046875,
        -4061.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4054.818603515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4058.64013671875,
      "bbox_min": [
        -2725.0498046875,
        -4061.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4054.818603515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2725.0498046875,
        -4058.64013671875,
        1102.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4054.818603515625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2725.0498046875,
        -4058.64013671875,
        1102.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4054.818603515625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2725.0498046875,
        -4061.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4058.64013671875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.47974374890327454,
        -0.8774086236953735
      ],
      "plane_d": -998.7046508789062,
      "bbox_min": [
        -2725.0498046875,
        -4061.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4054.818603515625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2725.0498046875,
        -4061.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2716.85986328125,
        -4054.818603515625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4534572660923004,
        0.8912780284881592,
        0.0
      ],
      "plane_d": 2376.92626953125,
      "bbox_min": [
        -2994.94970703125,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660229444503784,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 345.857421875,
      "bbox_min": [
        -2800.323486328125,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4053.302978515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4103.4189453125,
      "bbox_min": [
        -2800.323486328125,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -4069.04931640625,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660229444503784,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4470.9619140625,
      "bbox_min": [
        -2800.323486328125,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -4069.04931640625,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": -4097.31396484375,
      "bbox_min": [
        -2800.323486328125,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -4069.04931640625,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999080300331116,
        -0.0,
        0.013563040643930435
      ],
      "plane_d": 2764.814453125,
      "bbox_min": [
        -2782.768310546875,
        -4083.353759765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -4069.04931640625,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999081492424011,
        0.0,
        0.013554766774177551
      ],
      "plane_d": -2796.664306640625,
      "bbox_min": [
        -2782.768310546875,
        -4082.668701171875,
        1108.123779296875
      ],
      "bbox_max": [
        -2780.099609375,
        -4081.31103515625,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2781.899658203125,
        -4082.668701171875,
        1108.123779296875
      ],
      "bbox_max": [
        -2780.099609375,
        -4081.31103515625,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2782.768310546875,
        -4082.668701171875,
        1108.123779296875
      ],
      "bbox_max": [
        -2781.899658203125,
        -4082.226806640625,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2780.099609375,
        -4083.353759765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -4071.937255859375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        0.49999964237213135,
        0.0
      ],
      "plane_d": 4433.6494140625,
      "bbox_min": [
        -2768.499755859375,
        -4083.353759765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -4071.937255859375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660222887992859,
        -0.5000054836273193,
        0.0
      ],
      "plane_d": 351.8505859375,
      "bbox_min": [
        -2768.499755859375,
        -4083.353759765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2762.172119140625,
        -4074.661865234375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2768.499755859375,
        -4081.7685546875,
        1092.123779296875
      ],
      "bbox_max": [
        -2762.927978515625,
        -4074.661865234375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2768.499755859375,
      "bbox_min": [
        -2768.499755859375,
        -4081.7685546875,
        1092.123779296875
      ],
      "bbox_max": [
        -2768.499755859375,
        -4075.4091796875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075129747390747,
        -0.4084874093532562,
        -0.5766832232475281
      ],
      "plane_d": 908.0388793945312,
      "bbox_min": [
        -2763.697998046875,
        -4083.1025390625,
        1076.123779296875
      ],
      "bbox_max": [
        -2762.172119140625,
        -4081.7685546875,
        1077.97802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075146436691284,
        0.4084837734699249,
        -0.5766837000846863
      ],
      "plane_d": 4242.7314453125,
      "bbox_min": [
        -2767.031005859375,
        -4083.077392578125,
        1076.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4071.937255859375,
        1092.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2767.031005859375,
        -4083.077392578125,
        1076.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4071.937255859375,
        1092.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075129747390747,
        -0.4084874093532562,
        -0.5766832232475281
      ],
      "plane_d": 908.0388793945312,
      "bbox_min": [
        -2762.927978515625,
        -4083.077392578125,
        1076.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4081.7685546875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375535368919373,
        0.425826758146286,
        0.5241051912307739
      ],
      "plane_d": 3190.83642578125,
      "bbox_min": [
        -2780.099609375,
        -4082.68896484375,
        1106.623779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4071.937255859375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2780.099609375,
        -4082.68896484375,
        1106.623779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4073.753662109375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7426124215126038,
        -0.42874035239219666,
        0.5144983530044556
      ],
      "plane_d": -4372.78857421875,
      "bbox_min": [
        -2767.923583984375,
        -4082.668701171875,
        1108.123779296875
      ],
      "bbox_max": [
        -2757.065673828125,
        -4073.753662109375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375583052635193,
        -0.4258343279361725,
        0.5240923166275024
      ],
      "plane_d": -285.4197998046875,
      "bbox_min": [
        -2760.61865234375,
        -4082.668701171875,
        1108.123779296875
      ],
      "bbox_max": [
        -2757.065673828125,
        -4081.7685546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.74260413646698,
        0.4287415146827698,
        0.514509379863739
      ],
      "plane_d": -872.73583984375,
      "bbox_min": [
        -2764.602294921875,
        -4082.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2760.6123046875,
        -4081.7685546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375583052635193,
        -0.4258343279361725,
        0.5240923166275024
      ],
      "plane_d": -285.4197998046875,
      "bbox_min": [
        -2761.099365234375,
        -4082.6103515625,
        1112.4306640625
      ],
      "bbox_max": [
        -2760.6123046875,
        -4081.7685546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2761.676025390625,
        -4081.7685546875,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4069.04931640625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2761.676025390625,
        -4081.7685546875,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4069.04931640625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2755.999755859375,
      "bbox_min": [
        -2755.999755859375,
        -4081.7685546875,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4069.04931640625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": -4074.689453125,
      "bbox_min": [
        -2800.323486328125,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2756.53125,
        -4082.60107421875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375583052635193,
        -0.4258343279361725,
        0.5240923166275024
      ],
      "plane_d": -285.4197998046875,
      "bbox_min": [
        -2800.323486328125,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2756.53125,
        -4082.60107421875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2800.323486328125,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2756.703369140625,
        -4082.60107421875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4097.4189453125,
      "bbox_min": [
        -2800.323486328125,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2771.9638671875,
        -4088.87548828125,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660222887992859,
        -0.5000054836273193,
        -0.0
      ],
      "plane_d": -4464.96484375,
      "bbox_min": [
        -2800.323486328125,
        -4097.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2790.03564453125,
        -4088.87548828125,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075119018554688,
        -0.40848681330680847,
        -0.5766847729682922
      ],
      "plane_d": -3027.140869140625,
      "bbox_min": [
        -2800.323486328125,
        -4097.4189453125,
        1076.123779296875
      ],
      "bbox_max": [
        -2790.03564453125,
        -4088.87548828125,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375520467758179,
        -0.4258306920528412,
        0.524104118347168
      ],
      "plane_d": -4387.69921875,
      "bbox_min": [
        -2800.323486328125,
        -4097.4189453125,
        1106.623779296875
      ],
      "bbox_max": [
        -2795.89794921875,
        -4091.180908203125,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075119018554688,
        -0.40848681330680847,
        -0.5766847729682922
      ],
      "plane_d": -3027.140869140625,
      "bbox_min": [
        -2796.9638671875,
        -4103.4189453125,
        1076.123779296875
      ],
      "bbox_max": [
        -2790.03564453125,
        -4097.4189453125,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": -2726.877197265625,
      "bbox_min": [
        -2775.427978515625,
        -4103.4189453125,
        1076.123779296875
      ],
      "bbox_max": [
        -2768.499755859375,
        -4097.4189453125,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375520467758179,
        -0.4258306920528412,
        0.524104118347168
      ],
      "plane_d": -4387.69921875,
      "bbox_min": [
        -2796.475341796875,
        -4102.49609375,
        1108.123779296875
      ],
      "bbox_max": [
        -2791.1904296875,
        -4096.4189453125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7426104545593262,
        0.42874518036842346,
        0.5144970417022705
      ],
      "plane_d": 3257.674072265625,
      "bbox_min": [
        -2799.49951171875,
        -4099.4189453125,
        1108.123779296875
      ],
      "bbox_max": [
        -2789.458251953125,
        -4088.421630859375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375520467758179,
        -0.4258306920528412,
        0.524104118347168
      ],
      "plane_d": -4387.69921875,
      "bbox_min": [
        -2799.49951171875,
        -4099.4189453125,
        1108.123779296875
      ],
      "bbox_max": [
        -2791.1904296875,
        -4089.78369140625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660361766815186,
        -0.4999813139438629,
        0.0
      ],
      "plane_d": -4389.66455078125,
      "bbox_min": [
        -2731.999755859375,
        -4061.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4053.302978515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4058.64013671875,
      "bbox_min": [
        -2727.81396484375,
        -4059.497802734375,
        1102.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4053.302978515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2727.81396484375,
        -4058.64013671875,
        1102.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4053.302978515625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2727.813720703125,
        -4058.64013671875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4053.302978515625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2725.544921875,
        -4059.497802734375,
        1102.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4058.64013671875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2731.999755859375,
        -4061.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4054.709228515625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.47974374890327454,
        -0.8774086236953735
      ],
      "plane_d": -998.7046508789062,
      "bbox_min": [
        -2731.999755859375,
        -4061.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4053.302978515625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2731.999755859375,
        -4061.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4053.302978515625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253882408142,
        -0.5,
        0.0
      ],
      "plane_d": -4519.97021484375,
      "bbox_min": [
        -2994.94970703125,
        -4091.60009765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253882408142,
        0.5,
        0.0
      ],
      "plane_d": -389.1827392578125,
      "bbox_min": [
        -2880.499755859375,
        -4091.60009765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4060.117919921875,
      "bbox_min": [
        -2805.999755859375,
        -4091.60009765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999081492424011,
        0.0,
        0.013554766774177551
      ],
      "plane_d": -2796.664306640625,
      "bbox_min": [
        -2805.999755859375,
        -4091.60009765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -4060.117919921875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": 4065.4736328125,
      "bbox_min": [
        -2782.58447265625,
        -4082.2265625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2755.999755859375,
        -4060.117919921875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999080300331116,
        -0.0,
        0.013563040643930435
      ],
      "plane_d": 2764.814453125,
      "bbox_min": [
        -2781.8994140625,
        -4082.2265625,
        1108.123779296875
      ],
      "bbox_max": [
        -2779.230712890625,
        -4080.86865234375,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2781.8994140625,
        -4082.2265625,
        1108.123779296875
      ],
      "bbox_max": [
        -2780.099609375,
        -4080.86865234375,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2780.099609375,
        -4081.310791015625,
        1108.123779296875
      ],
      "bbox_max": [
        -2779.230712890625,
        -4080.86865234375,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2782.58447265625,
        -4080.86865234375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2761.67578125,
        -4060.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        0.49999964237213135,
        0.0
      ],
      "plane_d": 4433.6494140625,
      "bbox_min": [
        -2771.9638671875,
        -4075.4091796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2761.67578125,
        -4066.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2768.499755859375,
      "bbox_min": [
        -2768.499755859375,
        -4075.4091796875,
        1092.123779296875
      ],
      "bbox_max": [
        -2767.031005859375,
        -4072.1181640625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2768.499755859375,
        -4075.4091796875,
        1092.123779296875
      ],
      "bbox_max": [
        -2767.031005859375,
        -4072.1181640625,
        1092.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075146436691284,
        0.4084837734699249,
        -0.5766837000846863
      ],
      "plane_d": 4242.7314453125,
      "bbox_min": [
        -2771.9638671875,
        -4074.661865234375,
        1076.123779296875
      ],
      "bbox_max": [
        -2761.67578125,
        -4066.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2768.499755859375,
        -4074.661865234375,
        1092.123779296875
      ],
      "bbox_max": [
        -2761.676025390625,
        -4066.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2768.499755859375,
      "bbox_min": [
        -2768.499755859375,
        -4072.1181640625,
        1092.123779296875
      ],
      "bbox_max": [
        -2768.499755859375,
        -4066.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": 3942.470458984375,
      "bbox_min": [
        -2782.333251953125,
        -4066.117919921875,
        1076.123779296875
      ],
      "bbox_max": [
        -2765.03564453125,
        -4060.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075146436691284,
        0.4084837734699249,
        -0.5766837000846863
      ],
      "plane_d": 4242.7314453125,
      "bbox_min": [
        -2771.9638671875,
        -4066.117919921875,
        1076.123779296875
      ],
      "bbox_max": [
        -2765.03564453125,
        -4060.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2768.499755859375,
        -4066.117919921875,
        1092.123779296875
      ],
      "bbox_max": [
        -2765.03564453125,
        -4060.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2768.499755859375,
      "bbox_min": [
        -2768.499755859375,
        -4066.117919921875,
        1092.123779296875
      ],
      "bbox_max": [
        -2768.499755859375,
        -4060.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375535368919373,
        0.425826758146286,
        0.5241051912307739
      ],
      "plane_d": 3190.83642578125,
      "bbox_min": [
        -2781.919921875,
        -4080.86865234375,
        1106.623779296875
      ],
      "bbox_max": [
        -2761.67578125,
        -4060.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2781.919921875,
        -4080.86865234375,
        1106.623779296875
      ],
      "bbox_max": [
        -2765.245849609375,
        -4060.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": 2877.854248046875,
      "bbox_min": [
        -2781.919921875,
        -4061.041015625,
        1106.623779296875
      ],
      "bbox_max": [
        -2768.499755859375,
        -4060.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7426124215126038,
        -0.42874035239219666,
        0.5144983530044556
      ],
      "plane_d": -4372.78857421875,
      "bbox_min": [
        -2781.8994140625,
        -4075.115966796875,
        1108.123779296875
      ],
      "bbox_max": [
        -2765.245849609375,
        -4064.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": -4057.64990234375,
      "bbox_min": [
        -2781.8994140625,
        -4067.117919921875,
        1108.123779296875
      ],
      "bbox_max": [
        -2770.80908203125,
        -4064.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2768.499755859375,
        -4071.937255859375,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4060.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2768.499755859375,
        -4071.937255859375,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4060.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2755.999755859375,
      "bbox_min": [
        -2755.999755859375,
        -4069.04931640625,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4060.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660229444503784,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4470.9619140625,
      "bbox_min": [
        -2805.999755859375,
        -4091.60009765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2781.83154296875,
        -4060.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375609278678894,
        0.42583099007606506,
        0.5240912437438965
      ],
      "plane_d": -911.4240112304688,
      "bbox_min": [
        -2805.999755859375,
        -4091.60009765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2781.83154296875,
        -4060.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707514226436615,
        0.4084835350513458,
        -0.576684296131134
      ],
      "plane_d": 307.5360107421875,
      "bbox_min": [
        -2805.999755859375,
        -4091.60009765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2781.83154296875,
        -4060.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2805.999755859375,
        -4091.60009765625,
        1066.0556640625
      ],
      "bbox_max": [
        -2781.83154296875,
        -4060.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": 3942.470458984375,
      "bbox_min": [
        -2805.999755859375,
        -4091.60009765625,
        1066.82861328125
      ],
      "bbox_max": [
        -2781.8994140625,
        -4060.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": 2877.854248046875,
      "bbox_min": [
        -2805.999755859375,
        -4091.60009765625,
        1106.623779296875
      ],
      "bbox_max": [
        -2781.8994140625,
        -4060.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375520467758179,
        -0.4258306920528412,
        0.524104118347168
      ],
      "plane_d": -4387.69921875,
      "bbox_min": [
        -2805.999755859375,
        -4091.60009765625,
        1106.623779296875
      ],
      "bbox_max": [
        -2799.49951171875,
        -4081.7685546875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4066.117919921875,
      "bbox_min": [
        -2790.03564453125,
        -4066.117919921875,
        1066.82861328125
      ],
      "bbox_max": [
        -2782.333251953125,
        -4066.117919921875,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660222887992859,
        -0.5000054836273193,
        -0.0
      ],
      "plane_d": -4464.96484375,
      "bbox_min": [
        -2799.071533203125,
        -4088.87548828125,
        1066.0556640625
      ],
      "bbox_max": [
        -2794.96826171875,
        -4081.7685546875,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7426074147224426,
        -0.42873746156692505,
        0.514508068561554
      ],
      "plane_d": -242.39208984375,
      "bbox_min": [
        -2804.933837890625,
        -4091.180908203125,
        1108.123779296875
      ],
      "bbox_max": [
        -2781.83154296875,
        -4061.041015625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375520467758179,
        -0.4258306920528412,
        0.524104118347168
      ],
      "plane_d": -4387.69921875,
      "bbox_min": [
        -2804.933837890625,
        -4087.845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2785.94970703125,
        -4061.041015625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": 2877.854248046875,
      "bbox_min": [
        -2792.966796875,
        -4064.117919921875,
        1108.123779296875
      ],
      "bbox_max": [
        -2785.94970703125,
        -4061.041015625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": -4057.64990234375,
      "bbox_min": [
        -2801.425048828125,
        -4091.180908203125,
        1108.123779296875
      ],
      "bbox_max": [
        -2781.83154296875,
        -4061.041015625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7426104545593262,
        0.42874518036842346,
        0.5144970417022705
      ],
      "plane_d": 3257.674072265625,
      "bbox_min": [
        -2801.425048828125,
        -4091.180908203125,
        1108.123779296875
      ],
      "bbox_max": [
        -2794.07568359375,
        -4081.7685546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375520467758179,
        -0.4258306920528412,
        0.524104118347168
      ],
      "plane_d": -4387.69921875,
      "bbox_min": [
        -2801.425048828125,
        -4091.180908203125,
        1108.123779296875
      ],
      "bbox_max": [
        -2796.753173828125,
        -4081.7685546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4066.117919921875,
      "bbox_min": [
        -2790.03564453125,
        -4066.117919921875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2782.459228515625,
        -4066.117919921875,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2768.499755859375,
        -4060.117919921875,
        1078.82373046875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2768.499755859375,
        -4060.117919921875,
        1078.82373046875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4050.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2768.499755859375,
      "bbox_min": [
        -2768.499755859375,
        -4060.117919921875,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4050.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2755.999755859375,
      "bbox_min": [
        -2755.999755859375,
        -4060.117919921875,
        1092.123779296875
      ],
      "bbox_max": [
        -2755.999755859375,
        -4050.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47974374890327454,
        -0.0,
        -0.8774086236953735
      ],
      "plane_d": -360.75628662109375,
      "bbox_min": [
        -2731.999755859375,
        -4056.8388671875,
        1078.82373046875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4050.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2731.999755859375,
        -4056.8388671875,
        1082.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4050.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47974374890327454,
        -0.0,
        -0.8774086236953735
      ],
      "plane_d": -343.2081298828125,
      "bbox_min": [
        -2731.999755859375,
        -4056.8388671875,
        1098.82373046875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660361766815186,
        -0.4999813139438629,
        0.0
      ],
      "plane_d": -4389.66455078125,
      "bbox_min": [
        -2731.999755859375,
        -4056.8388671875,
        1102.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2730.089111328125,
        -4054.709228515625,
        1102.623779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4050.7685546875,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2730.0888671875,
        -4054.709228515625,
        1127.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4050.7685546875,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2731.999755859375,
        -4056.8388671875,
        1102.623779296875
      ],
      "bbox_max": [
        -2727.81396484375,
        -4050.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253882408142,
        -0.5,
        0.0
      ],
      "plane_d": 425.900390625,
      "bbox_min": [
        -2880.499755859375,
        -4072.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4050.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4072.419189453125,
      "bbox_min": [
        -2880.499755859375,
        -4072.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4050.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2880.499755859375,
        -4072.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4050.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375649213790894,
        -0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -217.216064453125,
      "bbox_min": [
        -2880.499755859375,
        -4072.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4050.7685546875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375558018684387,
        -0.4258209764957428,
        0.5241067409515381
      ],
      "plane_d": -4429.42041015625,
      "bbox_min": [
        -2880.499755859375,
        -4072.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4050.7685546875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": -4048.288330078125,
      "bbox_min": [
        -2880.499755859375,
        -4072.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4050.7685546875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660257458686829,
        -0.49999964237213135,
        0.0
      ],
      "plane_d": -4513.9697265625,
      "bbox_min": [
        -2880.499755859375,
        -4072.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4050.7685546875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660257458686829,
        -0.49999964237213135,
        0.0
      ],
      "plane_d": 431.90283203125,
      "bbox_min": [
        -2864.53564453125,
        -4072.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2830.499755859375,
        -4050.7685546875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4066.419189453125,
      "bbox_min": [
        -2864.53564453125,
        -4072.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2846.4638671875,
        -4066.419189453125,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": -2701.551513671875,
      "bbox_min": [
        -2864.53564453125,
        -4072.419189453125,
        1076.123779296875
      ],
      "bbox_max": [
        -2846.4638671875,
        -4066.419189453125,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075143456459045,
        -0.4084831476211548,
        -0.5766843557357788
      ],
      "plane_d": 973.43408203125,
      "bbox_min": [
        -2849.927734375,
        -4072.419189453125,
        1076.123779296875
      ],
      "bbox_max": [
        -2830.499755859375,
        -4050.7685546875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075148224830627,
        -0.4084834158420563,
        -0.5766835808753967
      ],
      "plane_d": -3067.18310546875,
      "bbox_min": [
        -2880.499755859375,
        -4072.419189453125,
        1076.123779296875
      ],
      "bbox_max": [
        -2861.071533203125,
        -4050.7685546875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": -2701.551513671875,
      "bbox_min": [
        -2867.999755859375,
        -4072.419189453125,
        1076.123779296875
      ],
      "bbox_max": [
        -2861.071533203125,
        -4066.419189453125,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": -4066.316650390625,
      "bbox_min": [
        -2856.39990234375,
        -4071.49609375,
        1108.123779296875
      ],
      "bbox_max": [
        -2831.565673828125,
        -4050.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999081492424011,
        -0.0,
        0.013554766774177551
      ],
      "plane_d": 2839.3173828125,
      "bbox_min": [
        -2854.999755859375,
        -4051.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2831.565673828125,
        -4050.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375649213790894,
        -0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -217.216064453125,
      "bbox_min": [
        -2839.102294921875,
        -4051.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2831.565673828125,
        -4050.7685546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7426049113273621,
        0.4287405014038086,
        0.5145090222358704
      ],
      "plane_d": -941.3565063476562,
      "bbox_min": [
        -2839.102294921875,
        -4051.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2835.11865234375,
        -4050.7685546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375649213790894,
        -0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -217.216064453125,
      "bbox_min": [
        -2856.39990234375,
        -4071.49609375,
        1108.123779296875
      ],
      "bbox_max": [
        -2832.085205078125,
        -4051.6005859375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": -4048.288330078125,
      "bbox_min": [
        -2850.549560546875,
        -4071.49609375,
        1108.123779296875
      ],
      "bbox_max": [
        -2843.53271484375,
        -4068.419189453125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": 2915.943115234375,
      "bbox_min": [
        -2856.39990234375,
        -4071.49609375,
        1108.123779296875
      ],
      "bbox_max": [
        -2845.30908203125,
        -4065.419189453125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": -4048.288330078125,
      "bbox_min": [
        -2856.39990234375,
        -4071.49609375,
        1108.123779296875
      ],
      "bbox_max": [
        -2845.30908203125,
        -4068.419189453125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": -4048.288330078125,
      "bbox_min": [
        -2867.466796875,
        -4071.49609375,
        1108.123779296875
      ],
      "bbox_max": [
        -2860.44970703125,
        -4068.419189453125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": 2915.943115234375,
      "bbox_min": [
        -2865.6904296875,
        -4071.49609375,
        1108.123779296875
      ],
      "bbox_max": [
        -2856.33203125,
        -4065.419189453125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": -4048.288330078125,
      "bbox_min": [
        -2865.6904296875,
        -4071.49609375,
        1108.123779296875
      ],
      "bbox_max": [
        -2856.33203125,
        -4068.419189453125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999081492424011,
        -0.0,
        0.013554766774177551
      ],
      "plane_d": 2922.809814453125,
      "bbox_min": [
        -2963.999755859375,
        -4091.60009765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2913.999755859375,
        -4060.117919921875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": 4065.4736328125,
      "bbox_min": [
        -2963.999755859375,
        -4082.2265625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2937.4150390625,
        -4060.117919921875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999080300331116,
        0.0,
        0.013563040643930435
      ],
      "plane_d": -2954.6591796875,
      "bbox_min": [
        -2940.768798828125,
        -4082.2265625,
        1108.123779296875
      ],
      "bbox_max": [
        -2938.10009765625,
        -4080.86865234375,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2939.900146484375,
        -4082.2265625,
        1108.123779296875
      ],
      "bbox_max": [
        -2938.10009765625,
        -4080.86865234375,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2940.768798828125,
        -4081.310791015625,
        1108.123779296875
      ],
      "bbox_max": [
        -2939.900146484375,
        -4080.86865234375,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2958.32373046875,
        -4080.86865234375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2937.4150390625,
        -4060.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660257458686829,
        0.49999964237213135,
        0.0
      ],
      "plane_d": -520.017333984375,
      "bbox_min": [
        -2958.32373046875,
        -4075.4091796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2948.03564453125,
        -4066.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2951.499755859375,
      "bbox_min": [
        -2952.968505859375,
        -4075.4091796875,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4072.11767578125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2952.968505859375,
        -4075.4091796875,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4072.11767578125,
        1092.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075143456459045,
        0.4084831476211548,
        -0.5766843557357788
      ],
      "plane_d": 195.7469482421875,
      "bbox_min": [
        -2958.32373046875,
        -4074.661865234375,
        1076.123779296875
      ],
      "bbox_max": [
        -2948.03564453125,
        -4066.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2958.323486328125,
        -4074.661865234375,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4066.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2951.499755859375,
      "bbox_min": [
        -2951.499755859375,
        -4072.11767578125,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4066.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": 3942.470458984375,
      "bbox_min": [
        -2954.9638671875,
        -4066.117919921875,
        1076.123779296875
      ],
      "bbox_max": [
        -2937.666259765625,
        -4060.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075143456459045,
        0.4084831476211548,
        -0.5766843557357788
      ],
      "plane_d": 195.7469482421875,
      "bbox_min": [
        -2954.9638671875,
        -4066.117919921875,
        1076.123779296875
      ],
      "bbox_max": [
        -2948.03564453125,
        -4060.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2954.9638671875,
        -4066.117919921875,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4060.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2951.499755859375,
      "bbox_min": [
        -2951.499755859375,
        -4066.117919921875,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4060.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375649213790894,
        0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -1027.9879150390625,
      "bbox_min": [
        -2958.32373046875,
        -4080.86865234375,
        1106.623779296875
      ],
      "bbox_max": [
        -2938.07958984375,
        -4060.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2954.753662109375,
        -4080.86865234375,
        1106.623779296875
      ],
      "bbox_max": [
        -2938.07958984375,
        -4060.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": 2877.854248046875,
      "bbox_min": [
        -2951.499755859375,
        -4061.041015625,
        1106.623779296875
      ],
      "bbox_max": [
        -2938.07958984375,
        -4060.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7426049113273621,
        -0.4287405014038086,
        0.5145090222358704
      ],
      "plane_d": -125.08087158203125,
      "bbox_min": [
        -2954.753662109375,
        -4075.115966796875,
        1108.123779296875
      ],
      "bbox_max": [
        -2938.10009765625,
        -4064.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": -4057.64990234375,
      "bbox_min": [
        -2949.1904296875,
        -4067.117919921875,
        1108.123779296875
      ],
      "bbox_max": [
        -2938.10009765625,
        -4064.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2963.999755859375,
        -4071.937255859375,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4060.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2963.999755859375,
        -4071.937255859375,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4060.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2963.999755859375,
      "bbox_min": [
        -2963.999755859375,
        -4069.04931640625,
        1092.123779296875
      ],
      "bbox_max": [
        -2963.999755859375,
        -4060.117919921875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660229444503784,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 482.68896484375,
      "bbox_min": [
        -2938.16796875,
        -4091.60009765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2913.999755859375,
        -4060.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375558018684387,
        0.4258209764957428,
        0.5241067409515381
      ],
      "plane_d": 3307.350830078125,
      "bbox_min": [
        -2938.16796875,
        -4091.60009765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2913.999755859375,
        -4060.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075148224830627,
        0.4084834158420563,
        -0.5766835808753967
      ],
      "plane_d": 4354.517578125,
      "bbox_min": [
        -2938.16796875,
        -4091.60009765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2913.999755859375,
        -4060.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2938.16796875,
        -4091.60009765625,
        1066.0557861328125
      ],
      "bbox_max": [
        -2913.999755859375,
        -4060.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": 3942.470458984375,
      "bbox_min": [
        -2938.10009765625,
        -4091.60009765625,
        1066.82861328125
      ],
      "bbox_max": [
        -2913.999755859375,
        -4060.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": 2877.854248046875,
      "bbox_min": [
        -2938.10009765625,
        -4091.60009765625,
        1106.623779296875
      ],
      "bbox_max": [
        -2913.999755859375,
        -4060.117919921875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375617623329163,
        -0.42583027482032776,
        0.5240910053253174
      ],
      "plane_d": -168.857177734375,
      "bbox_min": [
        -2920.5,
        -4091.60009765625,
        1106.623779296875
      ],
      "bbox_max": [
        -2913.999755859375,
        -4081.7685546875,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4066.117919921875,
      "bbox_min": [
        -2937.666259765625,
        -4066.117919921875,
        1066.82861328125
      ],
      "bbox_max": [
        -2929.9638671875,
        -4066.117919921875,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660222887992859,
        -0.5000054836273193,
        0.0
      ],
      "plane_d": 488.6820068359375,
      "bbox_min": [
        -2925.03125,
        -4088.87548828125,
        1066.0557861328125
      ],
      "bbox_max": [
        -2920.927978515625,
        -4081.7685546875,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7426109313964844,
        -0.42874401807785034,
        0.5144973993301392
      ],
      "plane_d": -4490.13134765625,
      "bbox_min": [
        -2938.16796875,
        -4091.180908203125,
        1108.123779296875
      ],
      "bbox_max": [
        -2915.065673828125,
        -4061.041015625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375617623329163,
        -0.42583027482032776,
        0.5240910053253174
      ],
      "plane_d": -168.857177734375,
      "bbox_min": [
        -2934.0498046875,
        -4087.845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2915.065673828125,
        -4061.041015625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": 2877.854248046875,
      "bbox_min": [
        -2934.0498046875,
        -4064.117919921875,
        1108.123779296875
      ],
      "bbox_max": [
        -2927.03271484375,
        -4061.041015625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": -4057.64990234375,
      "bbox_min": [
        -2938.16796875,
        -4091.180908203125,
        1108.123779296875
      ],
      "bbox_max": [
        -2918.574462890625,
        -4061.041015625,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7426009178161621,
        0.4287453889846802,
        0.5145105719566345
      ],
      "plane_d": -990.0432739257812,
      "bbox_min": [
        -2925.923828125,
        -4091.180908203125,
        1108.123779296875
      ],
      "bbox_max": [
        -2918.574462890625,
        -4081.7685546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375617623329163,
        -0.42583027482032776,
        0.5240910053253174
      ],
      "plane_d": -168.857177734375,
      "bbox_min": [
        -2923.246337890625,
        -4091.180908203125,
        1108.123779296875
      ],
      "bbox_max": [
        -2918.574462890625,
        -4081.7685546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4066.117919921875,
      "bbox_min": [
        -2937.540283203125,
        -4066.117919921875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2929.9638671875,
        -4066.117919921875,
        1076.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2994.94970703125,
        -4060.117919921875,
        1078.82373046875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2994.94970703125,
        -4060.117919921875,
        1078.82373046875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4050.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2963.999755859375,
      "bbox_min": [
        -2963.999755859375,
        -4060.117919921875,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4050.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2951.499755859375,
      "bbox_min": [
        -2951.499755859375,
        -4060.117919921875,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4050.7685546875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47974374890327454,
        0.0,
        -0.8774086236953735
      ],
      "plane_d": 2383.377685546875,
      "bbox_min": [
        -2994.94970703125,
        -4056.839111328125,
        1078.82373046875
      ],
      "bbox_max": [
        -2987.999755859375,
        -4050.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2994.94970703125,
        -4056.839111328125,
        1082.623779296875
      ],
      "bbox_max": [
        -2987.999755859375,
        -4050.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47974374890327454,
        0.0,
        -0.8774086236953735
      ],
      "plane_d": 2400.92578125,
      "bbox_min": [
        -2994.94970703125,
        -4056.839111328125,
        1098.82373046875
      ],
      "bbox_max": [
        -2987.999755859375,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660361766815186,
        -0.4999813139438629,
        0.0
      ],
      "plane_d": 564.0621337890625,
      "bbox_min": [
        -2994.94970703125,
        -4056.839111328125,
        1102.623779296875
      ],
      "bbox_max": [
        -2987.999755859375,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2994.94970703125,
        -4054.709228515625,
        1102.623779296875
      ],
      "bbox_max": [
        -2989.91064453125,
        -4050.7685546875,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2994.94970703125,
        -4054.709228515625,
        1102.623779296875
      ],
      "bbox_max": [
        -2989.91064453125,
        -4050.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2992.185791015625,
        -4056.839111328125,
        1102.623779296875
      ],
      "bbox_max": [
        -2987.999755859375,
        -4050.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6864430904388428,
        -0.39631810784339905,
        -0.6096949577331543
      ],
      "plane_d": -2912.622802734375,
      "bbox_min": [
        -2882.231689453125,
        -4073.419189453125,
        1099.0238037109375
      ],
      "bbox_max": [
        -2867.999755859375,
        -4050.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -2882.231689453125,
        -4073.419189453125,
        1099.0238037109375
      ],
      "bbox_max": [
        -2867.999755859375,
        -4050.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000253915786743,
        -0.8660107851028442,
        0.0
      ],
      "plane_d": -2092.686279296875,
      "bbox_min": [
        -2882.231689453125,
        -4073.419189453125,
        1099.0238037109375
      ],
      "bbox_max": [
        -2867.999755859375,
        -4050.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000253915786743,
        0.8660107851028442,
        0.0
      ],
      "plane_d": 2067.686279296875,
      "bbox_min": [
        -2882.231689453125,
        -4051.7685546875,
        1099.0238037109375
      ],
      "bbox_max": [
        -2880.499755859375,
        -4050.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660229444503784,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -4607.79296875,
      "bbox_min": [
        -2994.94970703125,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2919.676025390625,
        -4053.302978515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4103.4189453125,
      "bbox_min": [
        -2963.999755859375,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2919.676025390625,
        -4069.04931640625,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660229444503784,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 482.68896484375,
      "bbox_min": [
        -2963.999755859375,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2919.676025390625,
        -4069.04931640625,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": -4097.31396484375,
      "bbox_min": [
        -2963.999755859375,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2919.676025390625,
        -4069.04931640625,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999080300331116,
        0.0,
        0.013563040643930435
      ],
      "plane_d": -2954.6591796875,
      "bbox_min": [
        -2963.999755859375,
        -4083.353759765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2937.231201171875,
        -4069.04931640625,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999081492424011,
        -0.0,
        0.013554766774177551
      ],
      "plane_d": 2922.809814453125,
      "bbox_min": [
        -2939.89990234375,
        -4082.668701171875,
        1108.123779296875
      ],
      "bbox_max": [
        -2937.231201171875,
        -4081.310791015625,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2939.89990234375,
        -4082.668701171875,
        1108.123779296875
      ],
      "bbox_max": [
        -2938.099853515625,
        -4081.310791015625,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2938.099853515625,
        -4082.668701171875,
        1108.123779296875
      ],
      "bbox_max": [
        -2937.231201171875,
        -4082.2265625,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2963.999755859375,
        -4083.353759765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2939.89990234375,
        -4071.937255859375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660257458686829,
        0.49999964237213135,
        0.0
      ],
      "plane_d": -520.017333984375,
      "bbox_min": [
        -2963.999755859375,
        -4083.353759765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2951.499755859375,
        -4071.937255859375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660222887992859,
        -0.5000054836273193,
        0.0
      ],
      "plane_d": -4601.796875,
      "bbox_min": [
        -2957.827392578125,
        -4083.353759765625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2951.499755859375,
        -4074.661865234375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2957.071533203125,
        -4081.7685546875,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4074.661865234375,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2951.499755859375,
      "bbox_min": [
        -2951.499755859375,
        -4081.7685546875,
        1092.123779296875
      ],
      "bbox_max": [
        -2951.499755859375,
        -4075.4091796875,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075111269950867,
        -0.4084877073764801,
        -0.5766851305961609
      ],
      "plane_d": -3138.9287109375,
      "bbox_min": [
        -2957.827392578125,
        -4083.1025390625,
        1076.123779296875
      ],
      "bbox_max": [
        -2956.301513671875,
        -4081.7685546875,
        1077.97802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075143456459045,
        0.4084831476211548,
        -0.5766843557357788
      ],
      "plane_d": 195.7469482421875,
      "bbox_min": [
        -2963.999755859375,
        -4083.077392578125,
        1076.123779296875
      ],
      "bbox_max": [
        -2952.968505859375,
        -4071.937255859375,
        1092.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2963.999755859375,
        -4083.077392578125,
        1076.123779296875
      ],
      "bbox_max": [
        -2952.968505859375,
        -4071.937255859375,
        1092.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075111269950867,
        -0.4084877073764801,
        -0.5766851305961609
      ],
      "plane_d": -3138.9287109375,
      "bbox_min": [
        -2963.999755859375,
        -4083.077392578125,
        1076.123779296875
      ],
      "bbox_max": [
        -2957.071533203125,
        -4081.7685546875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375649213790894,
        0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -1027.9879150390625,
      "bbox_min": [
        -2963.999755859375,
        -4082.68896484375,
        1106.623779296875
      ],
      "bbox_max": [
        -2939.89990234375,
        -4071.937255859375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2963.999755859375,
        -4082.68896484375,
        1106.623779296875
      ],
      "bbox_max": [
        -2939.89990234375,
        -4073.753662109375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7426049113273621,
        -0.4287405014038086,
        0.5145090222358704
      ],
      "plane_d": -125.08087158203125,
      "bbox_min": [
        -2962.933837890625,
        -4082.668701171875,
        1108.123779296875
      ],
      "bbox_max": [
        -2952.075927734375,
        -4073.753662109375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375540137290955,
        -0.425825834274292,
        0.5241054892539978
      ],
      "plane_d": -4504.22021484375,
      "bbox_min": [
        -2962.933837890625,
        -4082.668701171875,
        1108.123779296875
      ],
      "bbox_max": [
        -2959.380859375,
        -4081.7685546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7426086664199829,
        0.42874982953071594,
        0.5144957900047302
      ],
      "plane_d": 3375.02197265625,
      "bbox_min": [
        -2959.38720703125,
        -4082.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2955.397216796875,
        -4081.7685546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375540137290955,
        -0.425825834274292,
        0.5241054892539978
      ],
      "plane_d": -4504.22021484375,
      "bbox_min": [
        -2959.38720703125,
        -4082.6103515625,
        1112.430908203125
      ],
      "bbox_max": [
        -2958.900146484375,
        -4081.7685546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1093.623779296875,
      "bbox_min": [
        -2963.999755859375,
        -4081.7685546875,
        1092.123779296875
      ],
      "bbox_max": [
        -2958.323486328125,
        -4069.04931640625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.123779296875,
      "bbox_min": [
        -2963.999755859375,
        -4081.7685546875,
        1092.123779296875
      ],
      "bbox_max": [
        -2958.323486328125,
        -4069.04931640625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2963.999755859375,
      "bbox_min": [
        -2963.999755859375,
        -4081.7685546875,
        1092.123779296875
      ],
      "bbox_max": [
        -2963.999755859375,
        -4069.04931640625,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": -4074.689453125,
      "bbox_min": [
        -2963.46826171875,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2919.676025390625,
        -4082.60107421875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375540137290955,
        -0.425825834274292,
        0.5241054892539978
      ],
      "plane_d": -4504.22021484375,
      "bbox_min": [
        -2963.46826171875,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2919.676025390625,
        -4082.60107421875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1108.123779296875,
      "bbox_min": [
        -2963.296142578125,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2919.676025390625,
        -4082.60107421875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4097.4189453125,
      "bbox_min": [
        -2948.03564453125,
        -4103.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2919.676025390625,
        -4088.87548828125,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660222887992859,
        -0.5000054836273193,
        0.0
      ],
      "plane_d": 488.6820068359375,
      "bbox_min": [
        -2929.9638671875,
        -4097.4189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2919.676025390625,
        -4088.87548828125,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075125575065613,
        -0.40848854184150696,
        -0.5766829252243042
      ],
      "plane_d": 1019.8197021484375,
      "bbox_min": [
        -2929.9638671875,
        -4097.4189453125,
        1076.123779296875
      ],
      "bbox_max": [
        -2919.676025390625,
        -4088.87548828125,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375617623329163,
        -0.42583027482032776,
        0.5240910053253174
      ],
      "plane_d": -168.857177734375,
      "bbox_min": [
        -2924.1015625,
        -4097.4189453125,
        1106.623779296875
      ],
      "bbox_max": [
        -2919.676025390625,
        -4091.180908203125,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7075125575065613,
        -0.40848854184150696,
        -0.5766829252243042
      ],
      "plane_d": 1019.8197021484375,
      "bbox_min": [
        -2929.9638671875,
        -4103.4189453125,
        1076.123779296875
      ],
      "bbox_max": [
        -2923.03564453125,
        -4097.4189453125,
        1108.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": -2726.877197265625,
      "bbox_min": [
        -2951.499755859375,
        -4103.4189453125,
        1076.123779296875
      ],
      "bbox_max": [
        -2944.572021484375,
        -4097.4189453125,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375617623329163,
        -0.42583027482032776,
        0.5240910053253174
      ],
      "plane_d": -168.857177734375,
      "bbox_min": [
        -2928.80908203125,
        -4102.49609375,
        1108.123779296875
      ],
      "bbox_max": [
        -2923.524169921875,
        -4096.4189453125,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7426009178161621,
        0.4287453889846802,
        0.5145105719566345
      ],
      "plane_d": -990.0432739257812,
      "bbox_min": [
        -2930.541259765625,
        -4099.4189453125,
        1108.123779296875
      ],
      "bbox_max": [
        -2920.5,
        -4088.421630859375,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7375617623329163,
        -0.42583027482032776,
        0.5240910053253174
      ],
      "plane_d": -168.857177734375,
      "bbox_min": [
        -2928.80908203125,
        -4099.4189453125,
        1108.123779296875
      ],
      "bbox_max": [
        -2920.5,
        -4089.783935546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660361766815186,
        -0.4999813139438629,
        0.0
      ],
      "plane_d": 564.0621337890625,
      "bbox_min": [
        -2994.94970703125,
        -4061.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2987.999755859375,
        -4053.302978515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4058.64013671875,
      "bbox_min": [
        -2994.94970703125,
        -4059.4970703125,
        1102.623779296875
      ],
      "bbox_max": [
        -2992.185791015625,
        -4053.302978515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2994.94970703125,
        -4058.64013671875,
        1102.623779296875
      ],
      "bbox_max": [
        -2992.185791015625,
        -4053.302978515625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2994.94970703125,
        -4058.64013671875,
        1102.623779296875
      ],
      "bbox_max": [
        -2992.185791015625,
        -4053.302978515625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2994.94970703125,
        -4059.4970703125,
        1102.623779296875
      ],
      "bbox_max": [
        -2994.455078125,
        -4058.64013671875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2994.94970703125,
        -4061.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2987.999755859375,
        -4054.709228515625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4797437787055969,
        -0.8774086833000183
      ],
      "plane_d": -998.7047119140625,
      "bbox_min": [
        -2994.94970703125,
        -4061.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -2987.999755859375,
        -4053.302978515625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2994.94970703125,
        -4061.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2987.999755859375,
        -4053.302978515625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8772926926612854,
        0.0999821349978447,
        0.4694262742996216
      ],
      "plane_d": -2445.1650390625,
      "bbox_min": [
        -2687.17529296875,
        -4088.39453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2682.318603515625,
        -4073.64697265625,
        1063.98681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -2716.85986328125,
        -4061.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -2709.7998046875,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.47974374890327454,
        -0.8774086236953735
      ],
      "plane_d": -998.7046508789062,
      "bbox_min": [
        -2716.85986328125,
        -4061.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -2709.7998046875,
        -4054.818603515625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.47974374890327454,
        -0.8774086236953735
      ],
      "plane_d": -981.156494140625,
      "bbox_min": [
        -2716.85986328125,
        -4061.7685546875,
        1098.82373046875
      ],
      "bbox_max": [
        -2709.7998046875,
        -4054.818603515625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2716.85986328125,
        -4058.64013671875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2711.91064453125,
        -4050.7685546875,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3021.999755859375,
      "bbox_min": [
        -3034.999755859375,
        -4091.2685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3003.1396484375,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3034.999755859375,
      "bbox_min": [
        -3034.999755859375,
        -4091.2685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3021.999755859375,
        -4058.2685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -3034.999755859375,
        -4091.2685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3021.999755859375,
        -4058.2685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -2902.4072265625,
      "bbox_min": [
        -3034.999755859375,
        -4091.2685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3021.999755859375,
        -4058.2685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1380.5384521484375,
      "bbox_min": [
        -3034.999755859375,
        -4091.2685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3021.999755859375,
        -4058.2685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": -4091.268310546875,
      "bbox_min": [
        -3034.999755859375,
        -4091.2685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3021.999755859375,
        -4058.2685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4058.2685546875,
      "bbox_min": [
        -3034.999755859375,
        -4058.2685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3021.999755859375,
        -4058.2685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -3010.19970703125,
        -4061.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -3003.1396484375,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4797437787055969,
        -0.8774086833000183
      ],
      "plane_d": -998.7047119140625,
      "bbox_min": [
        -3010.19970703125,
        -4061.7685546875,
        1078.82373046875
      ],
      "bbox_max": [
        -3003.1396484375,
        -4054.818603515625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4797437787055969,
        -0.8774086833000183
      ],
      "plane_d": -981.1565551757812,
      "bbox_min": [
        -3010.19970703125,
        -4061.7685546875,
        1098.82373046875
      ],
      "bbox_max": [
        -3003.1396484375,
        -4054.818603515625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -3008.0888671875,
        -4058.64013671875,
        1127.5999755859375
      ],
      "bbox_max": [
        -3003.1396484375,
        -4050.7685546875,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6879106163978577,
        -0.6849433779716492,
        0.24006594717502594
      ],
      "plane_d": -658.194091796875,
      "bbox_min": [
        -3549.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -416.77099609375,
      "bbox_min": [
        -3442.946533203125,
        -4041.093017578125,
        1052.623779296875
      ],
      "bbox_max": [
        -3301.525146484375,
        -3890.92822265625,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -416.77099609375,
      "bbox_min": [
        -3442.946533203125,
        -4041.188232421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3301.525146484375,
        -3890.92822265625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 5285.8330078125,
      "bbox_min": [
        -3442.946533203125,
        -4041.188232421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3434.10791015625,
        -4032.349609375,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6324367523193359,
        -0.7313089370727539,
        0.2553643584251404
      ],
      "plane_d": -1181.271728515625,
      "bbox_min": [
        -3549.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1992727518081665,
        0.9384201169013977,
        0.2822374105453491
      ],
      "plane_d": 4158.921875,
      "bbox_min": [
        -3549.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3063.126220703125,
        -3857.455078125,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6980487108230591,
        0.6980504989624023,
        0.15954118967056274
      ],
      "plane_d": 5042.2138671875,
      "bbox_min": [
        -3479.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3339.53857421875,
        -4032.349609375,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.917862057685852,
        -0.14546944200992584,
        0.36928024888038635
      ],
      "plane_d": 2066.38818359375,
      "bbox_min": [
        -3479.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3339.53857421875,
        -4032.349609375,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6541234850883484,
        -0.7563877701759338,
        0.0
      ],
      "plane_d": -930.5595703125,
      "bbox_min": [
        -3479.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3339.53857421875,
        -4032.349609375,
        1121.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3431.343017578125,
      "bbox_min": [
        -3442.946533203125,
        -4192.00244140625,
        1052.623779296875
      ],
      "bbox_max": [
        -3348.9013671875,
        -4032.349609375,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 5285.8330078125,
      "bbox_min": [
        -3442.946533203125,
        -4043.953125,
        1052.623779296875
      ],
      "bbox_max": [
        -3431.343017578125,
        -4032.349609375,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5285.8330078125,
      "bbox_min": [
        -3431.343017578125,
        -4143.13623046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3348.9013671875,
        -4043.953125,
        1102.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1076.5999755859375,
      "bbox_min": [
        -3431.343017578125,
        -4143.13623046875,
        1071.5999755859375
      ],
      "bbox_max": [
        -3368.260498046875,
        -4044.9765625,
        1086.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3411.343017578125,
      "bbox_min": [
        -3411.343017578125,
        -4110.0,
        1071.5999755859375
      ],
      "bbox_max": [
        -3406.0,
        -4076.0,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3406.0,
      "bbox_min": [
        -3406.0,
        -4110.0,
        1071.5999755859375
      ],
      "bbox_max": [
        -3406.0,
        -4100.5,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3411.343017578125,
      "bbox_min": [
        -3431.343017578125,
        -4143.13623046875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3368.260498046875,
        -4044.9765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -434.628173828125,
      "bbox_min": [
        -3431.343017578125,
        -4046.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3430.319580078125,
        -4044.9765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7563902735710144,
        0.6541206240653992,
        0.0
      ],
      "plane_d": 5257.830078125,
      "bbox_min": [
        -3401.343017578125,
        -4143.13623046875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3368.260498046875,
        -4074.9765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -477.0546875,
      "bbox_min": [
        -3401.343017578125,
        -4076.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3400.319580078125,
        -4074.9765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5385.869140625,
      "bbox_min": [
        -3424.76611328125,
        -4201.365234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3339.53857421875,
        -4124.4921875,
        1102.6240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1076.5999755859375,
      "bbox_min": [
        -3389.611328125,
        -4165.82568359375,
        1052.623779296875
      ],
      "bbox_max": [
        -3339.53857421875,
        -4124.4921875,
        1080.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6665334701538086,
        0.6665472984313965,
        0.3338381052017212
      ],
      "plane_d": 4631.18603515625,
      "bbox_min": [
        -3354.266845703125,
        -4136.681640625,
        1052.623779296875
      ],
      "bbox_max": [
        -3339.53857421875,
        -4124.4921875,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6688962578773499,
        0.6624125838279724,
        0.3373238742351532
      ],
      "plane_d": 4618.2919921875,
      "bbox_min": [
        -3354.266845703125,
        -4136.681640625,
        1058.5216064453125
      ],
      "bbox_max": [
        -3342.22705078125,
        -4131.0341796875,
        1072.6136474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2643769681453705,
        0.26181721687316895,
        -0.9282006621360779
      ],
      "plane_d": 2963.95458984375,
      "bbox_min": [
        -3354.266845703125,
        -4136.681640625,
        1072.5999755859375
      ],
      "bbox_max": [
        -3348.65087890625,
        -4131.0341796875,
        1072.6136474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2643769681453705,
        0.26181721687316895,
        -0.9282006621360779
      ],
      "plane_d": 2963.95458984375,
      "bbox_min": [
        -3354.266845703125,
        -4136.65673828125,
        1072.5999755859375
      ],
      "bbox_max": [
        -3341.851806640625,
        -4124.4921875,
        1076.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6355183124542236,
        0.6299405097961426,
        0.44642046093940735
      ],
      "plane_d": 4244.458984375,
      "bbox_min": [
        -3389.611328125,
        -4165.82568359375,
        1076.5999755859375
      ],
      "bbox_max": [
        -3341.851806640625,
        -4124.4921875,
        1080.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7083191871643066,
        0.7058923840522766,
        0.0
      ],
      "plane_d": 5337.56884765625,
      "bbox_min": [
        -3389.611328125,
        -4165.82568359375,
        1076.5999755859375
      ],
      "bbox_max": [
        -3344.110595703125,
        -4125.80078125,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1080.5999755859375,
      "bbox_min": [
        -3389.611328125,
        -4165.73095703125,
        1080.5999755859375
      ],
      "bbox_max": [
        -3384.736572265625,
        -4160.94482421875,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1080.5999755859375,
      "bbox_min": [
        -3348.970947265625,
        -4130.59619140625,
        1080.5999755859375
      ],
      "bbox_max": [
        -3344.110595703125,
        -4125.80078125,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28535524010658264,
        -0.8666651844978333,
        0.40922343730926514
      ],
      "plane_d": -4820.12890625,
      "bbox_min": [
        -3224.999755859375,
        -3998.226806640625,
        1082.623779296875
      ],
      "bbox_max": [
        -3063.126220703125,
        -3857.455078125,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9778734445571899,
        -0.20647084712982178,
        0.03366447240114212
      ],
      "plane_d": 2159.6767578125,
      "bbox_min": [
        -3207.47998046875,
        -3997.268798828125,
        1082.623779296875
      ],
      "bbox_max": [
        -3063.126220703125,
        -3857.455078125,
        1165.0567626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3207.47998046875,
        -3997.268798828125,
        1082.623779296875
      ],
      "bbox_max": [
        -3064.999755859375,
        -3879.7685546875,
        1133.5926513671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -3169.5,
        -3968.556396484375,
        1082.623779296875
      ],
      "bbox_max": [
        -3064.999755859375,
        -3879.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3950.0,
      "bbox_min": [
        -3169.5,
        -3960.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3064.999755859375,
        -3879.7685546875,
        1102.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9415097236633301,
        -0.3369859457015991,
        0.0
      ],
      "plane_d": 1578.2994384765625,
      "bbox_min": [
        -3068.5068359375,
        -3889.566650390625,
        1082.623779296875
      ],
      "bbox_max": [
        -3064.999755859375,
        -3879.7685546875,
        1098.4541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3140.0,
      "bbox_min": [
        -3150.0,
        -3960.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3140.0,
        -3950.0,
        1090.413330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3960.0,
      "bbox_min": [
        -3150.0,
        -3960.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3149.70458984375,
        -3960.0,
        1086.5421142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 5082.8330078125,
      "bbox_min": [
        -3207.47998046875,
        -3997.268798828125,
        1082.623779296875
      ],
      "bbox_max": [
        -3169.5,
        -3968.55615234375,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1086.5999755859375,
      "bbox_min": [
        -3207.47998046875,
        -3997.268798828125,
        1086.5999755859375
      ],
      "bbox_max": [
        -3191.951416015625,
        -3983.69287109375,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1086.5999755859375,
      "bbox_min": [
        -3196.198974609375,
        -3998.226806640625,
        1086.5999755859375
      ],
      "bbox_max": [
        -3193.11865234375,
        -3996.25439453125,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6375481486320496,
        -0.7279708385467529,
        0.25217205286026
      ],
      "plane_d": -1145.8114013671875,
      "bbox_min": [
        -3502.01513671875,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3428.32373046875,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9415097236633301,
        -0.3369859457015991,
        0.0
      ],
      "plane_d": 1578.2994384765625,
      "bbox_min": [
        -3188.277587890625,
        -3976.673095703125,
        1082.623779296875
      ],
      "bbox_max": [
        -3059.999755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28535524010658264,
        -0.8666651844978333,
        0.40922343730926514
      ],
      "plane_d": -4820.12890625,
      "bbox_min": [
        -3188.277587890625,
        -3976.673095703125,
        1082.623779296875
      ],
      "bbox_max": [
        -3059.999755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9778734445571899,
        -0.20647084712982178,
        0.03366447240114212
      ],
      "plane_d": 2159.6767578125,
      "bbox_min": [
        -3163.27734375,
        -3965.86669921875,
        1082.623779296875
      ],
      "bbox_max": [
        -3059.999755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1102.623779296875,
      "bbox_min": [
        -3163.27734375,
        -3965.86669921875,
        1082.623779296875
      ],
      "bbox_max": [
        -3126.570556640625,
        -3950.0,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3950.0,
      "bbox_min": [
        -3150.0,
        -3960.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3126.570556640625,
        -3950.0,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -3150.0,
        -3960.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3126.57080078125,
        -3950.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3960.0,
      "bbox_min": [
        -3150.0,
        -3960.0,
        1085.8109130859375
      ],
      "bbox_max": [
        -3140.0,
        -3950.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3140.0,
      "bbox_min": [
        -3140.0,
        -3955.804931640625,
        1087.5501708984375
      ],
      "bbox_max": [
        -3140.0,
        -3950.0,
        1096.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4239.7685546875,
      "bbox_min": [
        -3428.32373046875,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3927.351806640625,
        1187.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.3826853334903717,
        0.9238787889480591,
        0.0
      ],
      "plane_d": 2758.4794921875,
      "bbox_min": [
        -3219.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -4239.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1087.26513671875,
      "bbox_min": [
        -3219.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4239.7685546875,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8136186599731445,
        0.0,
        0.5813989043235779
      ],
      "plane_d": 1956.310546875,
      "bbox_min": [
        -3219.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4239.7685546875,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8108856678009033,
        0.0,
        -0.5852046608924866
      ],
      "plane_d": 3235.830078125,
      "bbox_min": [
        -3219.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4239.7685546875,
        1084.9443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3219.999755859375,
      "bbox_min": [
        -3219.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4239.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3167.36328125,
      "bbox_min": [
        -3167.36328125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4239.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3083.468505859375,
      "bbox_min": [
        -3428.32373046875,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3927.351806640625,
        1187.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3086.468505859375,
      "bbox_min": [
        -3428.32373046875,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3083.468505859375,
        -3931.36865234375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1086.599853515625,
      "bbox_min": [
        -3086.468505859375,
        -4060.0,
        1086.5999755859375
      ],
      "bbox_max": [
        -3083.468505859375,
        -3931.36865234375,
        1086.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -3428.32373046875,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3086.468505859375,
        -3932.66552734375,
        1121.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6355183124542236,
        0.6299405097961426,
        0.44642046093940735
      ],
      "plane_d": 4244.458984375,
      "bbox_min": [
        -3421.02099609375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4129.38525390625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1080.5999755859375,
      "bbox_min": [
        -3421.02099609375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4129.38525390625,
        1082.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.26335620880126953,
        0.26104477047920227,
        -0.9287083148956299
      ],
      "plane_d": 2957.899169921875,
      "bbox_min": [
        -3420.64208984375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4129.38525390625,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5385.869140625,
      "bbox_min": [
        -3420.64208984375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3282.76171875,
        -4134.17333984375,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6655337810516357,
        0.6799509525299072,
        0.3077850043773651
      ],
      "plane_d": 306.72271728515625,
      "bbox_min": [
        -3372.857666015625,
        -4239.7685546875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3340.276123046875,
        -4208.77197265625,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9697036743164062,
        -0.0,
        0.24428436160087585
      ],
      "plane_d": 2932.915771484375,
      "bbox_min": [
        -3383.989013671875,
        -4239.7685546875,
        1057.767578125
      ],
      "bbox_max": [
        -3295.76171875,
        -4134.17333984375,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1076.5999755859375,
      "bbox_min": [
        -3383.989013671875,
        -4209.6884765625,
        1057.767578125
      ],
      "bbox_max": [
        -3295.76171875,
        -4134.17333984375,
        1080.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7085317969322205,
        -0.7056789398193359,
        0.0
      ],
      "plane_d": -555.638916015625,
      "bbox_min": [
        -3368.5,
        -4179.07177734375,
        1057.767578125
      ],
      "bbox_max": [
        -3349.338623046875,
        -4152.22900390625,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7277738451957703,
        0.6858171224594116,
        0.00017122454300988466
      ],
      "plane_d": 5303.45654296875,
      "bbox_min": [
        -3368.5,
        -4179.07177734375,
        1057.7677001953125
      ],
      "bbox_max": [
        -3349.338623046875,
        -4167.98828125,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.706852376461029,
        0.7073611617088318,
        -0.0
      ],
      "plane_d": 5330.37451171875,
      "bbox_min": [
        -3368.5,
        -4173.23095703125,
        1057.7677001953125
      ],
      "bbox_max": [
        -3364.766357421875,
        -4169.5,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916755437850952,
        0.6802629828453064,
        0.24254301190376282
      ],
      "plane_d": 4871.7421875,
      "bbox_min": [
        -3349.693603515625,
        -4209.6884765625,
        1076.5999755859375
      ],
      "bbox_max": [
        -3295.76171875,
        -4164.630859375,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6345945000648499,
        0.7338024973869324,
        0.24253620207309723
      ],
      "plane_d": 684.877197265625,
      "bbox_min": [
        -3349.693603515625,
        -4209.6884765625,
        1076.5999755859375
      ],
      "bbox_max": [
        -3295.76171875,
        -4164.630859375,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6965505480766296,
        0.67300945520401,
        0.24874787032604218
      ],
      "plane_d": 237.70416259765625,
      "bbox_min": [
        -3341.189697265625,
        -4209.6884765625,
        1076.5999755859375
      ],
      "bbox_max": [
        -3295.76171875,
        -4189.78173828125,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6919705271720886,
        0.6794916391372681,
        0.24386051297187805
      ],
      "plane_d": 4868.060546875,
      "bbox_min": [
        -3301.6640625,
        -4194.7666015625,
        1076.5999755859375
      ],
      "bbox_max": [
        -3295.76171875,
        -4189.78173828125,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9361915588378906,
        -0.0,
        0.35149016976356506
      ],
      "plane_d": 2705.6474609375,
      "bbox_min": [
        -3292.76171875,
        -4239.7685546875,
        1060.7547607421875
      ],
      "bbox_max": [
        -3288.314453125,
        -4193.140625,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7085317969322205,
        -0.7056789398193359,
        0.0
      ],
      "plane_d": -555.638916015625,
      "bbox_min": [
        -3368.5,
        -4173.23095703125,
        1057.6956787109375
      ],
      "bbox_max": [
        -3351.240234375,
        -4152.17041015625,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.706852376461029,
        0.7073611617088318,
        -0.0
      ],
      "plane_d": 5330.37451171875,
      "bbox_min": [
        -3368.5,
        -4173.23095703125,
        1057.6956787109375
      ],
      "bbox_max": [
        -3364.766357421875,
        -4169.5,
        1057.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6651487350463867,
        0.6651487350463867,
        0.33934393525123596
      ],
      "plane_d": 4614.98193359375,
      "bbox_min": [
        -3368.5,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4135.7568359375,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.665036678314209,
        0.6585969924926758,
        0.3521025776863098
      ],
      "plane_d": 4573.732421875,
      "bbox_min": [
        -3368.5,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3285.26171875,
        -4138.1123046875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9361915588378906,
        -0.0,
        0.35149016976356506
      ],
      "plane_d": 2705.6474609375,
      "bbox_min": [
        -3368.5,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3285.26171875,
        -4138.1123046875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068419456481934,
        0.7073715329170227,
        -4.804801574209705e-05
      ],
      "plane_d": 5330.43359375,
      "bbox_min": [
        -3368.5,
        -4201.97607421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.734619140625,
        -4138.1123046875,
        1072.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7085317969322205,
        -0.7056789398193359,
        0.0
      ],
      "plane_d": -555.638916015625,
      "bbox_min": [
        -3368.5,
        -4169.5,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.734619140625,
        -4138.1123046875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.705562174320221,
        -0.7086475491523743,
        -0.0008191458764486015
      ],
      "plane_d": -577.010498046875,
      "bbox_min": [
        -3343.800048828125,
        -4150.279296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.734619140625,
        -4138.1123046875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7045431137084961,
        -0.709661066532135,
        0.0
      ],
      "plane_d": -585.481201171875,
      "bbox_min": [
        -3343.800048828125,
        -4144.7001953125,
        1052.623779296875
      ],
      "bbox_max": [
        -3339.805419921875,
        -4140.734375,
        1062.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6713940501213074,
        0.6649112105369568,
        0.32729673385620117
      ],
      "plane_d": 4647.7470703125,
      "bbox_min": [
        -3341.637939453125,
        -4150.279296875,
        1062.5
      ],
      "bbox_max": [
        -3332.734619140625,
        -4140.734375,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6691474318504333,
        0.6691474318504333,
        0.32323914766311646
      ],
      "plane_d": 4662.142578125,
      "bbox_min": [
        -3341.637939453125,
        -4147.80517578125,
        1062.5
      ],
      "bbox_max": [
        -3332.734619140625,
        -4140.734375,
        1070.0885009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6688962578773499,
        0.6624125838279724,
        0.3373238742351532
      ],
      "plane_d": 4618.2919921875,
      "bbox_min": [
        -3348.673828125,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4135.7568359375,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6713940501213074,
        0.6649112105369568,
        0.32729673385620117
      ],
      "plane_d": 4647.7470703125,
      "bbox_min": [
        -3342.244384765625,
        -4150.279296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3335.2080078125,
        -4135.7568359375,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6691474318504333,
        0.6691474318504333,
        0.32323914766311646
      ],
      "plane_d": 4662.142578125,
      "bbox_min": [
        -3342.244384765625,
        -4144.32568359375,
        1070.0885009765625
      ],
      "bbox_max": [
        -3339.879638671875,
        -4142.5673828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6665334701538086,
        0.6665472984313965,
        0.3338381052017212
      ],
      "plane_d": 4631.18603515625,
      "bbox_min": [
        -3342.22705078125,
        -4138.1123046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3337.183349609375,
        -4135.7568359375,
        1058.5216064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3219.999755859375,
      "bbox_min": [
        -3219.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4235.3251953125,
        1058.8939208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6655337810516357,
        0.6799509525299072,
        0.3077850043773651
      ],
      "plane_d": 306.72271728515625,
      "bbox_min": [
        -3371.0078125,
        -4239.7685546875,
        1080.5999755859375
      ],
      "bbox_max": [
        -3296.76953125,
        -4166.0009765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916755437850952,
        0.6802629828453064,
        0.24254301190376282
      ],
      "plane_d": 4871.7421875,
      "bbox_min": [
        -3310.627197265625,
        -4194.9736328125,
        1080.5999755859375
      ],
      "bbox_max": [
        -3296.76953125,
        -4180.66845703125,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6919705271720886,
        0.6794916391372681,
        0.24386051297187805
      ],
      "plane_d": 4868.060546875,
      "bbox_min": [
        -3304.650390625,
        -4194.9736328125,
        1080.5999755859375
      ],
      "bbox_max": [
        -3296.76953125,
        -4187.466796875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6345945000648499,
        0.7338024973869324,
        0.24253620207309723
      ],
      "plane_d": 684.877197265625,
      "bbox_min": [
        -3348.229736328125,
        -4213.2197265625,
        1080.5999755859375
      ],
      "bbox_max": [
        -3310.529541015625,
        -4166.0009765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916755437850952,
        0.6802629828453064,
        0.24254301190376282
      ],
      "plane_d": 4871.7421875,
      "bbox_min": [
        -3342.94775390625,
        -4213.2197265625,
        1080.5999755859375
      ],
      "bbox_max": [
        -3310.529541015625,
        -4166.0009765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6965505480766296,
        0.67300945520401,
        0.24874787032604218
      ],
      "plane_d": 237.70416259765625,
      "bbox_min": [
        -3342.94775390625,
        -4213.2197265625,
        1080.5999755859375
      ],
      "bbox_max": [
        -3331.906982421875,
        -4201.787109375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3219.999755859375,
      "bbox_min": [
        -3219.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4235.2646484375,
        1058.951904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6666650176048279,
        -0.6666684150695801,
        0.3333333730697632
      ],
      "plane_d": -933.2264404296875,
      "bbox_min": [
        -3291.98681640625,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4041.88818359375,
        1082.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7059842348098755,
        0.7082275748252869,
        0.0
      ],
      "plane_d": 613.07861328125,
      "bbox_min": [
        -3291.98681640625,
        -4151.353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -3182.521240234375,
        -4041.88818359375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -3291.98681640625,
        -4151.353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -3182.521240234375,
        -4042.05517578125,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7070972919464111,
        0.7071162462234497,
        -4.741520115203457e-06
      ],
      "plane_d": 5192.845703125,
      "bbox_min": [
        -3244.19921875,
        -4108.6416015625,
        1052.623779296875
      ],
      "bbox_max": [
        -3235.132568359375,
        -4099.5751953125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7082239389419556,
        0.7059878706932068,
        0.0
      ],
      "plane_d": 596.652587890625,
      "bbox_min": [
        -3234.2998046875,
        -4089.69140625,
        1052.623779296875
      ],
      "bbox_max": [
        -3186.496337890625,
        -4041.88818359375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -3234.2998046875,
        -4089.69140625,
        1072.623779296875
      ],
      "bbox_max": [
        -3186.496337890625,
        -4041.88818359375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8136186599731445,
        0.0,
        0.5813989043235779
      ],
      "plane_d": 1956.310546875,
      "bbox_min": [
        -3222.63623046875,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4179.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8108856678009033,
        0.0,
        -0.5852046608924866
      ],
      "plane_d": 3235.830078125,
      "bbox_min": [
        -3222.63623046875,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4179.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3167.36328125,
      "bbox_min": [
        -3222.63623046875,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4179.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3219.999755859375,
      "bbox_min": [
        -3222.63623046875,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4179.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4179.7685546875,
      "bbox_min": [
        -3222.63623046875,
        -4179.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4179.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4179.7685546875,
      "bbox_min": [
        -3180.824951171875,
        -4179.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4179.7685546875,
        1082.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 5082.8330078125,
      "bbox_min": [
        -3428.32373046875,
        -4239.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3086.468505859375,
        -3942.823486328125,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1086.5999755859375,
      "bbox_min": [
        -3428.32373046875,
        -4239.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3128.210693359375,
        -3996.25927734375,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8136186599731445,
        0.0,
        0.5813989043235779
      ],
      "plane_d": 1956.310546875,
      "bbox_min": [
        -3370.07177734375,
        -4239.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3178.08203125,
        -4166.69384765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8108856678009033,
        0.0,
        -0.5852046608924866
      ],
      "plane_d": 3235.830078125,
      "bbox_min": [
        -3370.07177734375,
        -4239.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3178.08203125,
        -4166.69384765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6655337810516357,
        0.6799509525299072,
        0.3077850043773651
      ],
      "plane_d": 306.72271728515625,
      "bbox_min": [
        -3370.07177734375,
        -4239.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3297.279296875,
        -4166.69384765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6919705271720886,
        0.6794916391372681,
        0.24386051297187805
      ],
      "plane_d": 4868.060546875,
      "bbox_min": [
        -3310.529541015625,
        -4195.38037109375,
        1082.623779296875
      ],
      "bbox_max": [
        -3297.279296875,
        -4181.48876953125,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6965505480766296,
        0.67300945520401,
        0.24874787032604218
      ],
      "plane_d": 237.70416259765625,
      "bbox_min": [
        -3348.82568359375,
        -4220.77294921875,
        1082.623779296875
      ],
      "bbox_max": [
        -3310.33837890625,
        -4166.69384765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916755437850952,
        0.6802629828453064,
        0.24254301190376282
      ],
      "plane_d": 4871.7421875,
      "bbox_min": [
        -3311.417236328125,
        -4183.1015625,
        1082.623779296875
      ],
      "bbox_max": [
        -3310.33837890625,
        -4180.58642578125,
        1086.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6916755437850952,
        0.6802629828453064,
        0.24254301190376282
      ],
      "plane_d": 4871.7421875,
      "bbox_min": [
        -3325.135498046875,
        -4182.02978515625,
        1082.623779296875
      ],
      "bbox_max": [
        -3311.39208984375,
        -4166.69384765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4179.7685546875,
      "bbox_min": [
        -3211.91748046875,
        -4179.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3206.304931640625,
        -4179.7685546875,
        1086.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4179.7685546875,
      "bbox_min": [
        -3207.499755859375,
        -4179.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3178.08203125,
        -4179.7685546875,
        1086.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5385.869140625,
      "bbox_min": [
        -3428.32373046875,
        -4239.7685546875,
        1086.5999755859375
      ],
      "bbox_max": [
        -3180.92333984375,
        -4168.0556640625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1096.5999755859375,
      "bbox_min": [
        -3368.23291015625,
        -4239.7685546875,
        1086.5999755859375
      ],
      "bbox_max": [
        -3180.92333984375,
        -4168.0556640625,
        1096.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1087.26513671875,
      "bbox_min": [
        -3368.23291015625,
        -4239.7685546875,
        1086.5999755859375
      ],
      "bbox_max": [
        -3180.92333984375,
        -4168.0556640625,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8136186599731445,
        0.0,
        0.5813989043235779
      ],
      "plane_d": 1956.310546875,
      "bbox_min": [
        -3368.23291015625,
        -4239.7685546875,
        1086.5999755859375
      ],
      "bbox_max": [
        -3180.92333984375,
        -4168.0556640625,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6345945000648499,
        0.7338024973869324,
        0.24253620207309723
      ],
      "plane_d": 684.877197265625,
      "bbox_min": [
        -3368.23291015625,
        -4239.7685546875,
        1086.5999755859375
      ],
      "bbox_max": [
        -3298.281005859375,
        -4168.0556640625,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6965505480766296,
        0.67300945520401,
        0.24874787032604218
      ],
      "plane_d": 237.70416259765625,
      "bbox_min": [
        -3368.23291015625,
        -4239.7685546875,
        1086.5999755859375
      ],
      "bbox_max": [
        -3298.281005859375,
        -4168.0556640625,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6655337810516357,
        0.6799509525299072,
        0.3077850043773651
      ],
      "plane_d": 306.72271728515625,
      "bbox_min": [
        -3368.23291015625,
        -4239.7685546875,
        1086.5999755859375
      ],
      "bbox_max": [
        -3311.38818359375,
        -4168.0556640625,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916755437850952,
        0.6802629828453064,
        0.24254301190376282
      ],
      "plane_d": 4871.7421875,
      "bbox_min": [
        -3325.144775390625,
        -4182.271484375,
        1086.5999755859375
      ],
      "bbox_max": [
        -3311.38818359375,
        -4168.0556640625,
        1087.26513671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4179.7685546875,
      "bbox_min": [
        -3209.076171875,
        -4179.7685546875,
        1086.5999755859375
      ],
      "bbox_max": [
        -3180.92333984375,
        -4179.7685546875,
        1087.26513671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6965505480766296,
        0.67300945520401,
        0.24874787032604218
      ],
      "plane_d": 237.70416259765625,
      "bbox_min": [
        -3367.92529296875,
        -4239.7685546875,
        1087.26513671875
      ],
      "bbox_max": [
        -3298.448486328125,
        -4168.28369140625,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9697036743164062,
        -0.0,
        0.24428436160087585
      ],
      "plane_d": 2932.915771484375,
      "bbox_min": [
        -3311.387939453125,
        -4239.7685546875,
        1087.26513671875
      ],
      "bbox_max": [
        -3298.448486328125,
        -4182.271484375,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6919705271720886,
        0.6794916391372681,
        0.24386051297187805
      ],
      "plane_d": 4868.060546875,
      "bbox_min": [
        -3311.387939453125,
        -4196.40380859375,
        1087.26513671875
      ],
      "bbox_max": [
        -3298.448486328125,
        -4182.271484375,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6655337810516357,
        0.6799509525299072,
        0.3077850043773651
      ],
      "plane_d": 306.72271728515625,
      "bbox_min": [
        -3367.92529296875,
        -4239.7685546875,
        1087.26513671875
      ],
      "bbox_max": [
        -3311.33935546875,
        -4168.28369140625,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6919705271720886,
        0.6794916391372681,
        0.24386051297187805
      ],
      "plane_d": 4868.060546875,
      "bbox_min": [
        -3325.27392578125,
        -4185.6708984375,
        1087.26513671875
      ],
      "bbox_max": [
        -3311.33935546875,
        -4168.28369140625,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916755437850952,
        0.6802629828453064,
        0.24254301190376282
      ],
      "plane_d": 4871.7421875,
      "bbox_min": [
        -3325.27392578125,
        -4182.158203125,
        1087.26513671875
      ],
      "bbox_max": [
        -3311.499267578125,
        -4168.28369140625,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -3175.532470703125,
        -4060.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3086.468505859375,
        -3942.823486328125,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1086.5999755859375,
      "bbox_min": [
        -3131.210693359375,
        -4060.0,
        1086.5999755859375
      ],
      "bbox_max": [
        -3086.468505859375,
        -4057.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3109.968505859375,
      "bbox_min": [
        -3169.5,
        -4018.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3109.968505859375,
        -3942.823486328125,
        1102.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5055.4599609375,
      "bbox_min": [
        -3169.5,
        -4018.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3109.968505859375,
        -3950.0,
        1102.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1086.599853515625,
      "bbox_min": [
        -3160.0,
        -4018.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3133.49755859375,
        -3989.5,
        1092.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1092.0,
      "bbox_min": [
        -3160.0,
        -4018.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3133.49755859375,
        -3989.5,
        1092.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3160.0,
      "bbox_min": [
        -3160.0,
        -3991.997314453125,
        1086.5999755859375
      ],
      "bbox_max": [
        -3160.0,
        -3989.5,
        1092.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3950.0,
      "bbox_min": [
        -3169.5,
        -4002.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3109.968505859375,
        -3950.0,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3169.5,
      "bbox_min": [
        -3169.5,
        -4002.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3109.968505859375,
        -3955.804931640625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3140.0,
      "bbox_min": [
        -3150.0,
        -4002.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3109.968505859375,
        -3955.804931640625,
        1096.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        -3150.0,
        -3975.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3140.0,
        -3960.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3960.0,
      "bbox_min": [
        -3149.70458984375,
        -3975.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3140.0,
        -3960.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3144.0,
      "bbox_min": [
        -3146.0,
        -3975.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3144.0,
        -3960.0,
        1094.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1090.0,
      "bbox_min": [
        -3146.0,
        -3975.0,
        1086.0
      ],
      "bbox_max": [
        -3144.0,
        -3960.0,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1086.0,
      "bbox_min": [
        -3146.0,
        -3975.0,
        1086.0
      ],
      "bbox_max": [
        -3144.0,
        -3960.0,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3121.5,
      "bbox_min": [
        -3126.5,
        -4002.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3109.968505859375,
        -3970.0,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1087.4000244140625,
      "bbox_min": [
        -3126.5,
        -4002.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3121.5,
        -3985.0,
        1087.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 610.5869140625,
      "bbox_min": [
        -3126.5,
        -3990.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3121.5,
        -3985.0,
        1087.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3980.0,
      "bbox_min": [
        -3121.5,
        -3990.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3109.968505859375,
        -3970.0,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1087.4000244140625,
      "bbox_min": [
        -3121.5,
        -3990.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3112.968505859375,
        -3985.0,
        1087.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3985.0,
      "bbox_min": [
        -3121.5,
        -3985.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3112.968505859375,
        -3985.0,
        1087.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3112.968505859375,
        -3980.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3109.968505859375,
        -3970.0,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3970.0,
      "bbox_min": [
        -3112.968505859375,
        -3970.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3109.968505859375,
        -3970.0,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10802071541547775,
        -0.9941487312316895,
        0.0
      ],
      "plane_d": -3575.28662109375,
      "bbox_min": [
        -3083.468505859375,
        -3931.36865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3927.351806640625,
        1187.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3754.28271484375,
        -4249.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4069.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7621387243270874,
        -0.6012710928916931,
        0.24003666639328003
      ],
      "plane_d": -6.656219482421875,
      "bbox_min": [
        -3754.28271484375,
        -4249.7685546875,
        1278.740234375
      ],
      "bbox_max": [
        -3746.760498046875,
        -4244.33984375,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2214.77978515625,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2119.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48899564146995544,
        0.8722862601280212,
        0.0
      ],
      "plane_d": 2783.7412109375,
      "bbox_min": [
        -2214.77978515625,
        -4432.9013671875,
        1167.623779296875
      ],
      "bbox_max": [
        -2119.999755859375,
        -4379.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4609.7685546875,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1102.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4919.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7047529220581055,
        0.6667083501815796,
        0.24253523349761963
      ],
      "plane_d": 947.6998901367188,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1195.5255126953125
      ],
      "bbox_max": [
        -2908.47216796875,
        -4942.994140625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2484.2236328125,
      "bbox_min": [
        -2484.2236328125,
        -4813.62939453125,
        1181.2305908203125
      ],
      "bbox_max": [
        -2375.77587890625,
        -4703.9345703125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6937940120697021,
        0.7201735377311707,
        0.0
      ],
      "plane_d": 1686.3616943359375,
      "bbox_min": [
        -2484.2236328125,
        -4813.62939453125,
        1181.2305908203125
      ],
      "bbox_max": [
        -2375.77587890625,
        -4703.9345703125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6937940120697021,
        0.7201735377311707,
        -0.0
      ],
      "plane_d": 5058.2001953125,
      "bbox_min": [
        -2452.15087890625,
        -4813.62939453125,
        1181.2305908203125
      ],
      "bbox_max": [
        -2375.77587890625,
        -4703.9345703125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4703.9345703125,
      "bbox_min": [
        -2452.15087890625,
        -4813.62939453125,
        1181.2305908203125
      ],
      "bbox_max": [
        -2407.8486328125,
        -4703.9345703125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9929671287536621,
        0.11839047819375992
      ],
      "plane_d": 4638.580078125,
      "bbox_min": [
        -2452.15087890625,
        -4813.62939453125,
        1181.2305908203125
      ],
      "bbox_max": [
        -2407.8486328125,
        -4812.27099609375,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2839.999755859375,
      "bbox_min": [
        -2920.0,
        -4909.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4609.7685546875,
        1231.90625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8064050674438477,
        0.5913636684417725
      ],
      "plane_d": 3077.1162109375,
      "bbox_min": [
        -2839.999755859375,
        -4719.2421875,
        1082.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4609.7685546875,
        1231.90625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4811.14599609375,
      "bbox_min": [
        -2920.0,
        -4856.7685546875,
        1179.3675537109375
      ],
      "bbox_max": [
        -2901.78662109375,
        -4852.89501953125,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2839.999755859375,
      "bbox_min": [
        -2920.0,
        -4909.7685546875,
        1227.393310546875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4639.62060546875,
        1255.3924560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8064050674438477,
        0.5913636684417725
      ],
      "plane_d": 3077.1162109375,
      "bbox_min": [
        -2839.999755859375,
        -4719.7685546875,
        1230.4019775390625
      ],
      "bbox_max": [
        -2799.999755859375,
        -4718.13916015625,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": 4836.0390625,
      "bbox_min": [
        -2920.0,
        -4857.9619140625,
        1227.393310546875
      ],
      "bbox_max": [
        -2901.78662109375,
        -4856.3642578125,
        1255.3924560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.914959728717804,
        -0.4035452604293823,
        -0.0
      ],
      "plane_d": -3815.310791015625,
      "bbox_min": [
        -2264.67724609375,
        -4329.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2260.266845703125,
        -4319.7685546875,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.914959728717804,
        -0.4035452604293823,
        -0.0
      ],
      "plane_d": -3815.310791015625,
      "bbox_min": [
        -2224.77978515625,
        -4432.9013671875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4410.228515625,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.914959728717804,
        -0.4035452604293823,
        -0.0
      ],
      "plane_d": -3815.310791015625,
      "bbox_min": [
        -2260.266845703125,
        -4410.228515625,
        1052.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9135422706604004,
        -0.4067438244819641,
        -0.0
      ],
      "plane_d": -3873.526123046875,
      "bbox_min": [
        -2346.841796875,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7610056400299072,
        -0.6487452983856201,
        -0.0
      ],
      "plane_d": -4560.17578125,
      "bbox_min": [
        -2346.841796875,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.976732075214386,
        0.21446312963962555,
        0.0
      ],
      "plane_d": -1380.2791748046875,
      "bbox_min": [
        -2346.841796875,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4067084789276123,
        0.9135580062866211,
        0.0
      ],
      "plane_d": 2985.219970703125,
      "bbox_min": [
        -2342.36767578125,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.914959728717804,
        -0.4035452604293823,
        -0.0
      ],
      "plane_d": -3815.310791015625,
      "bbox_min": [
        -2280.849853515625,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4283.1005859375,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9135460257530212,
        -0.4067356288433075,
        -0.0
      ],
      "plane_d": -3861.5,
      "bbox_min": [
        -2342.36767578125,
        -4302.5205078125,
        1052.623779296875
      ],
      "bbox_max": [
        -2280.849853515625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.914959728717804,
        -0.4035452604293823,
        -0.0
      ],
      "plane_d": -3815.310791015625,
      "bbox_min": [
        -2295.551025390625,
        -4283.1005859375,
        1052.623779296875
      ],
      "bbox_max": [
        -2280.849853515625,
        -4249.7685546875,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8099361658096313,
        -0.3606100380420685,
        -0.4625622630119324
      ],
      "plane_d": -2866.8154296875,
      "bbox_min": [
        -2342.36767578125,
        -4302.5205078125,
        1203.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4257.44384765625,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4260.0,
      "bbox_min": [
        -2910.0,
        -4260.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2894.0,
        -4249.7685546875,
        1064.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1064.0,
      "bbox_min": [
        -2910.0,
        -4260.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2894.0,
        -4249.7685546875,
        1064.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2910.0,
      "bbox_min": [
        -2910.0,
        -4260.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2894.0,
        -4249.7685546875,
        1064.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2894.0,
      "bbox_min": [
        -2894.0,
        -4260.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2894.0,
        -4249.7685546875,
        1064.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3784.999755859375,
      "bbox_min": [
        -3784.999755859375,
        -4668.23779296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3722.8740234375,
        -4289.7998046875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600293636322021,
        0.2798992693424225,
        -0.0
      ],
      "plane_d": 4907.18798828125,
      "bbox_min": [
        -3784.999755859375,
        -4668.23779296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3722.8740234375,
        -4289.7998046875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.789697527885437,
        -0.6134963631629944,
        0.0
      ],
      "plane_d": 308.167724609375,
      "bbox_min": [
        -3784.999755859375,
        -4369.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3722.8740234375,
        -4289.7998046875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9700089693069458,
        -0.0,
        0.24306941032409668
      ],
      "plane_d": 3403.469482421875,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.932385265827179,
        0.26299288868904114,
        0.24797670543193817
      ],
      "plane_d": 4451.162109375,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.931310772895813,
        0.2715262770652771,
        0.24276229739189148
      ],
      "plane_d": 4492.71728515625,
      "bbox_min": [
        -3835.11669921875,
        -4668.23779296875,
        1102.623779296875
      ],
      "bbox_max": [
        -3750.459716796875,
        -4549.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9732754826545715,
        0.0,
        0.22964049875736237
      ],
      "plane_d": 3347.911865234375,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7658141851425171,
        -0.594942033290863,
        0.2440749555826187
      ],
      "plane_d": 29.72479248046875,
      "bbox_min": [
        -3835.11669921875,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3729.92431640625,
        -4260.35546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1222.32177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7621387243270874,
        -0.6012710928916931,
        0.24003666639328003
      ],
      "plane_d": -6.656219482421875,
      "bbox_min": [
        -3835.11669921875,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3733.5146484375,
        -4260.80517578125,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1236.6832275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1356099247932434,
        0.955426812171936,
        0.26223912835121155
      ],
      "plane_d": 4679.6083984375,
      "bbox_min": [
        -3789.732666015625,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1350298374891281,
        0.9555009007453918,
        0.2622690796852112
      ],
      "plane_d": 4677.7451171875,
      "bbox_min": [
        -3789.732666015625,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3747.18896484375,
        -4668.23779296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3744.02880859375,
        -4289.7998046875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1278.7403564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3599.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4719.7685546875,
        1181.713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3339.772216796875,
        -4740.5244140625,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4719.7685546875,
        1181.713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8292540311813354,
        0.5588719248771667,
        0.0
      ],
      "plane_d": 13.907958984375,
      "bbox_min": [
        -3198.6396484375,
        -4740.77392578125,
        1052.623779296875
      ],
      "bbox_max": [
        -3129.999755859375,
        -4692.80419921875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7978267073631287,
        0.537691593170166,
        0.272691011428833
      ],
      "plane_d": -300.9292297363281,
      "bbox_min": [
        -3170.900634765625,
        -4735.19970703125,
        1152.623779296875
      ],
      "bbox_max": [
        -3129.999755859375,
        -4692.80419921875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4242666959762573,
        0.8449944257736206,
        0.32554891705513
      ],
      "plane_d": 2255.4482421875,
      "bbox_min": [
        -3145.921875,
        -4710.5654296875,
        1152.623779296875
      ],
      "bbox_max": [
        -3129.999755859375,
        -4692.80419921875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36590203642845154,
        0.9306533932685852,
        0.0
      ],
      "plane_d": 3241.628173828125,
      "bbox_min": [
        -3198.6396484375,
        -4740.77392578125,
        1082.623779296875
      ],
      "bbox_max": [
        -3170.900634765625,
        -4729.86767578125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3600.0,
        -4947.19970703125,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4739.541015625,
        1212.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3600.0,
        -4947.19970703125,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4739.541015625,
        1212.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3600.0,
        -4854.802734375,
        1102.623779296875
      ],
      "bbox_max": [
        -3574.9658203125,
        -4829.7685546875,
        1202.759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3347.175537109375,
        -4947.19970703125,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4919.7685546875,
        1212.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701427221298218,
        0.2425345927476883
      ],
      "plane_d": 4598.58740234375,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9056028723716736,
        0.4241252839565277,
        0.001009006635285914
      ],
      "plane_d": -905.1506958007812,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7047529220581055,
        0.6667083501815796,
        0.24253523349761963
      ],
      "plane_d": 947.6998901367188,
      "bbox_min": [
        -3308.169189453125,
        -5028.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3308.169189453125,
        -5028.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2970.626953125,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3308.169189453125,
        -4932.2685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3269.999755859375,
        -4919.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6037326455116272,
        0.7593971490859985,
        0.24253419041633606
      ],
      "plane_d": 5452.61083984375,
      "bbox_min": [
        -3229.37255859375,
        -5028.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2970.626953125,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6037326455116272,
        0.7593972086906433,
        0.24253425002098083
      ],
      "plane_d": 1709.4686279296875,
      "bbox_min": [
        -3222.96435546875,
        -5028.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2970.626953125,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36590203642845154,
        0.9306533932685852,
        0.0
      ],
      "plane_d": 3241.628173828125,
      "bbox_min": [
        -3222.96435546875,
        -4750.33740234375,
        1082.623779296875
      ],
      "bbox_max": [
        -3196.425048828125,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9033738970756531,
        0.42883458733558655,
        -0.004077742341905832
      ],
      "plane_d": -869.732666015625,
      "bbox_min": [
        -3246.87841796875,
        -4801.26220703125,
        1095.0
      ],
      "bbox_max": [
        -3222.96435546875,
        -4750.33740234375,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4850.76806640625,
      "bbox_min": [
        -3270.07763671875,
        -4850.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3269.999755859375,
        -4850.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": 4850.76806640625,
      "bbox_min": [
        -3319.999755859375,
        -4932.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3269.999755859375,
        -4850.7685546875,
        1152.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6037326455116272,
        0.7593972086906433,
        0.24253425002098083
      ],
      "plane_d": 1709.4686279296875,
      "bbox_min": [
        -3319.999755859375,
        -5045.98291015625,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6037326455116272,
        0.7593971490859985,
        0.24253419041633606
      ],
      "plane_d": 5452.61083984375,
      "bbox_min": [
        -3319.999755859375,
        -5044.55859375,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3319.999755859375,
        -4947.42724609375,
        1152.623779296875
      ],
      "bbox_max": [
        -3290.547119140625,
        -4932.2685546875,
        1213.2578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3295.838623046875,
        -4994.4453125,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3295.838623046875,
        -4947.5576171875,
        1152.623779296875
      ],
      "bbox_max": [
        -3275.381591796875,
        -4932.2685546875,
        1213.7796630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.583952009677887,
        0.5839559435844421,
        0.5639109015464783
      ],
      "plane_d": 372.40728759765625,
      "bbox_min": [
        -3220.900634765625,
        -4980.81591796875,
        1152.623779296875
      ],
      "bbox_max": [
        -3184.010498046875,
        -4935.62158203125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4811.14599609375,
      "bbox_min": [
        -2946.8349609375,
        -4856.3642578125,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4850.7685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9749281406402588,
        0.0,
        -0.22251978516578674
      ],
      "plane_d": 3444.49658203125,
      "bbox_min": [
        -3319.999755859375,
        -4919.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -3255.81689453125,
        -4850.7685546875,
        1214.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2525814163666382e-08,
        0.9968532919883728,
        0.07926793396472931
      ],
      "plane_d": 4744.13818359375,
      "bbox_min": [
        -3319.999755859375,
        -4855.599609375,
        1152.623779296875
      ],
      "bbox_max": [
        -3255.81689453125,
        -4850.7685546875,
        1214.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4690.69580078125,
      "bbox_min": [
        -3292.71533203125,
        -4855.599609375,
        1152.623779296875
      ],
      "bbox_max": [
        -3255.81689453125,
        -4850.7685546875,
        1214.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3699.999755859375,
        -4854.5673828125,
        1102.623779296875
      ],
      "bbox_max": [
        -3599.999755859375,
        -4829.7685546875,
        1201.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701427221298218,
        0.2425345927476883
      ],
      "plane_d": 4598.58740234375,
      "bbox_min": [
        -3369.999755859375,
        -5065.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6037326455116272,
        0.7593971490859985,
        0.24253419041633606
      ],
      "plane_d": 5452.61083984375,
      "bbox_min": [
        -3369.999755859375,
        -5065.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3369.999755859375,
        -4969.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -3295.838623046875,
        -4912.603515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3369.999755859375,
        -4969.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -3347.175537109375,
        -4912.603515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6037326455116272,
        0.7593972086906433,
        0.24253425002098083
      ],
      "plane_d": 1709.4686279296875,
      "bbox_min": [
        -3369.999755859375,
        -5065.7685546875,
        1213.2578125
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3369.999755859375,
        -5008.603515625,
        1213.2578125
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8356147408485413,
        0.0,
        -0.5493159294128418
      ],
      "plane_d": -1788.7464599609375,
      "bbox_min": [
        -2989.006591796875,
        -4911.19970703125,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4820.59423828125,
      "bbox_min": [
        -2989.006591796875,
        -4860.02587890625,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": 4836.0390625,
      "bbox_min": [
        -2959.9150390625,
        -4860.02587890625,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42975062131881714,
        0.0,
        -0.9029476046562195
      ],
      "plane_d": -119.2418212890625,
      "bbox_min": [
        -3014.40673828125,
        -4907.19970703125,
        1290.53515625
      ],
      "bbox_max": [
        -2978.129638671875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011412267573177814,
        0.998230516910553,
        0.05835885927081108
      ],
      "plane_d": 4808.96826171875,
      "bbox_min": [
        -3014.40673828125,
        -4859.599609375,
        1290.53515625
      ],
      "bbox_max": [
        -2978.129638671875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.018744194880127907,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4778.7138671875,
      "bbox_min": [
        -3014.40673828125,
        -4859.455078125,
        1290.53515625
      ],
      "bbox_max": [
        -2989.006591796875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3600.0,
        -4916.06201171875,
        1201.8182373046875
      ],
      "bbox_max": [
        -3253.16455078125,
        -4744.802734375,
        1239.427978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3600.0,
        -4916.06201171875,
        1201.8182373046875
      ],
      "bbox_max": [
        -3253.16455078125,
        -4746.9443359375,
        1239.427978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3600.0,
        -4863.9697265625,
        1201.8182373046875
      ],
      "bbox_max": [
        -3566.1171875,
        -4854.5673828125,
        1239.427978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9749281406402588,
        0.0,
        -0.22251978516578674
      ],
      "plane_d": 3444.49658203125,
      "bbox_min": [
        -3302.565185546875,
        -4912.5498046875,
        1213.0048828125
      ],
      "bbox_max": [
        -3253.16455078125,
        -4854.98095703125,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4690.69580078125,
      "bbox_min": [
        -3302.565185546875,
        -4856.7685546875,
        1213.0048828125
      ],
      "bbox_max": [
        -3253.16455078125,
        -4854.98095703125,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2525814163666382e-08,
        0.9968532919883728,
        0.07926793396472931
      ],
      "plane_d": 4744.13818359375,
      "bbox_min": [
        -3302.565185546875,
        -4856.7685546875,
        1213.0048828125
      ],
      "bbox_max": [
        -3292.71533203125,
        -4855.56982421875,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3600.0,
        -4914.876953125,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4751.63671875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3600.0,
        -4879.7685546875,
        1238.15380859375
      ],
      "bbox_max": [
        -3549.999755859375,
        -4863.6513671875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4733.2060546875,
      "bbox_min": [
        -3253.16455078125,
        -4859.85693359375,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3221.869873046875,
        -4907.19970703125,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.011412300169467926,
        0.9982304573059082,
        0.05835884064435959
      ],
      "plane_d": 4738.2119140625,
      "bbox_min": [
        -3221.869873046875,
        -4859.599609375,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.018744278699159622,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4894.92822265625,
      "bbox_min": [
        -3210.992919921875,
        -4859.455078125,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3699.999755859375,
        -4879.7685546875,
        1198.05712890625
      ],
      "bbox_max": [
        -3600.0,
        -4853.626953125,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923880934715271,
        0.38268008828163147,
        0.0
      ],
      "plane_d": -1233.537841796875,
      "bbox_min": [
        -3128.600341796875,
        -4674.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.10009765625,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268569111824036,
        0.9238786101341248,
        0.0
      ],
      "plane_d": 2758.4775390625,
      "bbox_min": [
        -3126.600341796875,
        -4674.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.10009765625,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1121.623779296875,
      "bbox_min": [
        -3046.499755859375,
        -4261.66796875,
        1121.623779296875
      ],
      "bbox_max": [
        -3041.499755859375,
        -4249.7685546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3167.36328125,
      "bbox_min": [
        -3222.63623046875,
        -4309.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4249.7685546875,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3219.999755859375,
      "bbox_min": [
        -3219.999755859375,
        -4309.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4249.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1087.26513671875,
      "bbox_min": [
        -3219.999755859375,
        -4309.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4249.7685546875,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8136186599731445,
        0.0,
        0.5813989043235779
      ],
      "plane_d": 1956.310546875,
      "bbox_min": [
        -3219.999755859375,
        -4309.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4249.7685546875,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8108856678009033,
        0.0,
        -0.5852046608924866
      ],
      "plane_d": 3235.830078125,
      "bbox_min": [
        -3219.999755859375,
        -4309.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -3207.499755859375,
        -4249.7685546875,
        1084.9443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 1057.446044921875,
      "bbox_min": [
        -3939.26220703125,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.791748046875,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1100.3785400390625,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2712554931640625,
        0.3530268669128418,
        0.8954285979270935
      ],
      "plane_d": 1485.3206787109375,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2750813663005829,
        0.35142311453819275,
        0.894892156124115
      ],
      "plane_d": -215.431884765625,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2754322588443756,
        0.3464488685131073,
        0.8967219591140747
      ],
      "plane_d": 1463.6072998046875,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27700290083885193,
        0.3484245240688324,
        0.8954717516899109
      ],
      "plane_d": -237.17449951171875,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3248736560344696,
        0.30733799934387207,
        0.894427478313446
      ],
      "plane_d": 1431.6265869140625,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3270551264286041,
        0.3094017207622528,
        0.892919659614563
      ],
      "plane_d": -576.7142333984375,
      "bbox_min": [
        -2945.2109375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3714085817337036,
        1.1238243132538628e-05,
        0.9284694790840149
      ],
      "plane_d": -2031.978759765625,
      "bbox_min": [
        -3939.26220703125,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.791748046875,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1017.1966552734375,
      "bbox_min": [
        -3939.26220703125,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3369.999755859375,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19999998807907104,
        0.3999999761581421,
        0.8944271802902222
      ],
      "plane_d": 1496.8050537109375,
      "bbox_min": [
        -3597.21337890625,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3369.999755859375,
        -4909.36328125,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4251258969306946,
        0.1388094276189804,
        0.8944271206855774
      ],
      "plane_d": 1100.856689453125,
      "bbox_min": [
        -3939.26220703125,
        -5079.7685546875,
        1317.4210205078125
      ],
      "bbox_max": [
        -3758.24658203125,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3159162104129791,
        -0.32253599166870117,
        0.892282247543335
      ],
      "plane_d": -1351.46044921875,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.869873046875,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.42334893345832825,
        0.0,
        0.9059666991233826
      ],
      "plane_d": 407.424560546875,
      "bbox_min": [
        -3985.582763671875,
        -4310.9921875,
        1302.623779296875
      ],
      "bbox_max": [
        -3749.999755859375,
        -3869.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3431975841522217,
        -0.2707574963569641,
        0.8993920087814331
      ],
      "plane_d": -1033.765380859375,
      "bbox_min": [
        -3985.582763671875,
        -4310.9921875,
        1302.623779296875
      ],
      "bbox_max": [
        -3749.999755859375,
        -4183.41845703125,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3593549430370331,
        -0.25706222653388977,
        0.8970969915390015
      ],
      "plane_d": -909.20556640625,
      "bbox_min": [
        -3985.582763671875,
        -4266.263671875,
        1353.5482177734375
      ],
      "bbox_max": [
        -3900.749755859375,
        -4183.41845703125,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.315602570772171,
        -0.3142412602901459,
        0.8953476548194885
      ],
      "plane_d": -1324.80126953125,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.869873046875,
        -3820.217529296875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3593549430370331,
        -0.25706222653388977,
        0.8970969915390015
      ],
      "plane_d": -909.20556640625,
      "bbox_min": [
        -4007.749267578125,
        -4356.12060546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3802.58349609375,
        -4213.58984375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3431975841522217,
        -0.2707574963569641,
        0.8993920087814331
      ],
      "plane_d": -1033.765380859375,
      "bbox_min": [
        -3900.749755859375,
        -4356.12060546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3802.58349609375,
        -4266.263671875,
        1353.5482177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.0,
        0.8944271802902222
      ],
      "plane_d": 550.01416015625,
      "bbox_min": [
        -3888.191162109375,
        -4356.12060546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3835.11669921875,
        -4333.81396484375,
        1329.1610107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.0,
        0.8944271802902222
      ],
      "plane_d": 550.01416015625,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.869873046875,
        -4244.5771484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43041878938674927,
        0.12140591442584991,
        0.8944273591041565
      ],
      "plane_d": 1038.8125,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.869873046875,
        -4244.5771484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4251258969306946,
        0.1388094276189804,
        0.8944271206855774
      ],
      "plane_d": 1100.856689453125,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.869873046875,
        -4244.5771484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1017.1966552734375,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.869873046875,
        -4244.5771484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19999998807907104,
        0.3999999761581421,
        0.8944271802902222
      ],
      "plane_d": 1496.8050537109375,
      "bbox_min": [
        -3556.986083984375,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3488.941650390625,
        -4879.7685546875,
        1317.4210205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3593549430370331,
        -0.25706222653388977,
        0.8970969915390015
      ],
      "plane_d": -909.20556640625,
      "bbox_min": [
        -4035.11669921875,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3221.869873046875,
        -4244.5771484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4733.2060546875,
      "bbox_min": [
        -3248.5048828125,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3221.869873046875,
        -4859.599609375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.020015697926282883,
        0.9981757998466492,
        0.05695966258645058
      ],
      "plane_d": 4711.94189453125,
      "bbox_min": [
        -3248.5048828125,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3237.16748046875,
        -4859.85693359375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3713906705379486,
        0.0,
        0.9284766912460327
      ],
      "plane_d": -2032.00439453125,
      "bbox_min": [
        -2978.129638671875,
        -4910.2978515625,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.77978515625,
        -4379.7685546875,
        1402.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2297457456588745,
        0.4098278880119324,
        0.8827558755874634
      ],
      "plane_d": 157.9915771484375,
      "bbox_min": [
        -2214.77978515625,
        -4508.150390625,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.77978515625,
        -4379.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4820.59423828125,
      "bbox_min": [
        -2978.129638671875,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -2951.49462890625,
        -4859.599609375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": 4836.0390625,
      "bbox_min": [
        -2962.83203125,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -2951.49462890625,
        -4859.85693359375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011412267573177814,
        0.998230516910553,
        0.05835885927081108
      ],
      "plane_d": 4808.96826171875,
      "bbox_min": [
        -3100.0,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -2962.83203125,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.018744194880127907,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4778.7138671875,
      "bbox_min": [
        -3100.0,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3005.45556640625,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42975062131881714,
        0.0,
        -0.9029476046562195
      ],
      "plane_d": -119.2418212890625,
      "bbox_min": [
        -3100.0,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3014.40673828125,
        -4859.455078125,
        1343.361572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.011412300169467926,
        0.9982304573059082,
        0.05835884064435959
      ],
      "plane_d": 4738.2119140625,
      "bbox_min": [
        -3237.16748046875,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.018744278699159622,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4894.92822265625,
      "bbox_min": [
        -3194.5439453125,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3185.5927734375,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.455078125,
        1343.361572265625
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}